{
  "unified": {
    "terms": {
      "heading": "Terms and Conditions"
    },
    "termsGate": {
      "description": "To keep using Anyway, please review and accept the terms and conditions and privacy policy.",
      "updatedDescription": "We’ve made changes to the Anyway terms and conditions and privacy policy. Please review and accept the updated terms to keep using Anyway.",
      "termsLink": "Terms and Conditions"
    },
    "cdp": {
      "pageTitle": "Your Anyway Replay",
      "closeAriaLabel": "Close your Anyway Replay",
      "storyHeading": "Hey {highlight} here’s your {break}story so far",
      "storyHeadingFallback": "Here’s your story so far",
      "superpowers": {
        "heading": "Your {highlight}",
        "headingHighlight": "superpowers",
        "subtitle": "Everything we’ve learned about how you think, learn and thrive."
      },
      "storyIntro": "You’ve been busy on Anyway discovering what drives you. Here’s what we’ve learned so far…",
      "summaryHeading": "Your Anyway summary",
      "summarySubtitle": "Here’s what your journey has uncovered so far.",
      "stats": {
        "careersLabel": "Saved",
        "careersNoun": "Careers",
        "collegesLabel": "Saved",
        "collegesNoun": "Colleges",
        "badgesLabel": "Unlocked",
        "badgesNoun": "Badges"
      },
      "clarityHeading": "Career clarity score",
      "areasHeading": "Areas you most explored",
      "areas": {
        "explorationLevel": "Exploration level",
        "topBlurb": "You explored more {area} content than any other industry.",
        "strongBlurb": "You’ve shown strong interest in building knowledge.",
        "dippedBlurb": "You’ve dipped your toes in this exciting area."
      },
      "clarity": {
        "lowBody": "You’ve built a clear understanding of what suits you. Research shows that with strong career clarity you’re more likely to make confident career decisions and invest your time and money in the right pathway.",
        "mediumBody": "You’re building a clearer understanding of what suits you. Research shows that as your career clarity improves, you’re more likely to make better career decisions and avoid investing time or money in a pathway that’s not the right fit.",
        "highBody": "You’re just getting started on figuring out what suits you. Research shows that as your career clarity improves, you’re more likely to make better career decisions and avoid investing time or money in a pathway that’s not the right fit."
      },
      "copyShareLink": "Copy share link",
      "downloadPdf": "Download PDF",
      "persona": {
        "chip": "This is you",
        "tags": {
          "R": "Hands-on",
          "I": "Curious",
          "A": "Creative",
          "S": "People-focused",
          "E": "Driven",
          "C": "Organized"
        }
      },
      "details": {
        "age": "{age} years old"
      },
      "favouriteCareersHeading": "Your {highlight} careers",
      "favouriteCareersHighlight": "favorite",
      "favouriteCareersEmpty": "You haven’t favorited any careers yet. Tap the heart on a career you like and it’ll show up here.",
      "favouriteStudyHeading": "Your favorite study matches",
      "atarChip": "ATAR: {score}",
      "gpaChip": "GPA: {score}",
      "satChip": "SAT: {score}",
      "entryScoreChip": "Entry score: {score}",
      "favouriteStudyEmpty": "You haven’t saved any study matches yet. Explore colleges and programs and save the ones you like.",
      "keepGoingHeading": "Keep going {name}",
      "keepGoingHeadingFallback": "Keep going",
      "keepGoingBody": "Every activity, conversation and decision is helping shape your future. See you back inside Anyway.",
      "logoAlt": "Anyway",
      "unavailableTitle": "We couldn’t load your Replay",
      "unavailableBody": "Something went wrong loading your story. Please try again in a bit."
    },
    "cdpShared": {
      "pageTitle": "Career development plan",
      "expiresNotice": "This link expires {date}",
      "unavailableTitle": "This link is no longer available",
      "unavailableBody": "The link may have expired or been revoked. Ask the owner to share a new one.",
      "goHome": "Go to Anyway"
    },
    "auth": {
      "school": {
        "noInvitesTitle": "No school invite yet",
        "noInvites": "You haven’t been invited to a school yet. Ask your teacher to invite you, then sign in again.",
        "pickTitle": "Which school are you joining?",
        "acceptError": "Something went wrong joining that school. Please try again.",
        "loadError": "We couldn’t load your school invites. Please try again.",
        "retry": "Try again",
        "placeholder": "Select your school",
        "continue": "Continue",
        "logout": "Log out"
      },
      "passwordSetup": {
        "tokenExpired": "That took a little too long. You can add a password any time from your profile."
      },
      "providerFailed": {
        "not_available": {
          "title": "Sign-in isn’t available right now",
          "body": "Signing in with your school account isn’t available for your school right now. Sign in with your email instead, or ask your teacher."
        },
        "unauthorized_user": {
          "title": "We couldn’t sign you in",
          "body": "Your school hasn’t shared your account with Anyway. Ask your teacher or school administrator to check your access."
        },
        "login_expired": {
          "title": "That sign-in has expired",
          "body": "A sign-in only lasts a few minutes. Start again to get a fresh one."
        },
        "sign_in_failed": {
          "title": "Something went wrong signing you in",
          "body": "We couldn’t complete the sign-in with your school’s login. Please try again."
        },
        "not_set_up": {
          "title": "Your district hasn’t enabled Anyway yet",
          "body": "Anyway isn’t set up for your school district yet. Ask your school administrator about getting access."
        },
        "needs_attention": {
          "title": "Your account needs attention",
          "body": "There’s a problem with your account that a teacher or administrator needs to sort out before you can sign in."
        },
        "not_enrolled": {
          "title": "You’re not enrolled here",
          "body": "We couldn’t find you on your school’s roster for Anyway. Ask your teacher if you should have access."
        },
        "generic": {
          "title": "We couldn’t sign you in",
          "body": "Something went wrong. Please try again."
        },
        "reference": "Reference code:",
        "tryAgain": "Try again",
        "signInWithEmail": "Sign in with email",
        "backToPortal": "Go back to your portal"
      },
      "providerProof": {
        "title": "Check your email",
        "sentTo": "Enter the 6-digit code we emailed to {address}",
        "bodyWithoutAddress": "Enter the 6-digit code we emailed you to finish signing in.",
        "submit": "Continue",
        "wrongCode": "That code isn’t right. Check your email and try again.",
        "notReceivedFromPortal": "Didn’t get it? Check your spam folder. For a new code, open Anyway from your {provider} portal again.",
        "notReceivedFromLogin": "Didn’t get it? Check your spam folder. For a new code, sign in with {provider} again.",
        "goToProvider": "Go to {provider}",
        "signInAgain": "Sign in again"
      },
      "schoolAccount": {
        "title": "This email belongs to a school account",
        "body": "This email is managed by a school, so its account lives on the schools site. Sign in there, or sign up here with a personal email.",
        "goToSchoolsSite": "Go to the schools site",
        "usePersonalEmail": "Use a personal email"
      }
    },
    "allowAnimation": "Allow animations",
    "home": "home",
    "learnMore": "Learn more",
    "headUpPhoneRewards": "Heads up: You’ll need to add your number to grab your rewards",
    "inProgress": "In progress:",
    "onboarding": {
      "personalised": "You smashed it! I'm Blinky, I'm here to help you figure out your future.",
      "welcome": "Just quickly, can I get some information from you?",
      "email": "Just quickly, can I get some information from you?",
      "otp": "Thanks! I just sent you an email with a pin. Can you put that in for me?",
      "aboutYou": "Nearly there. Just quickly, can I get some information from you?",
      "aboutYouFields": {
        "firstName": "First name",
        "lastName": "Last name",
        "birthMonth": "Birth month",
        "birthYear": "Birth year",
        "state": "State"
      },
      "tooYoung": "Sorry, you’re not old enough to create an account just yet.",
      "tooYoungBackHome": "Home",
      "passwordSetup": "You’re in! Want to create a password so you can log in without waiting for an emailed code?",
      "termsAndConditions": "This is your first time so please check this box so I can create your account",
      "marketingOptIn": "Email me Anyway news, product updates, offers and surveys.",
      "termsLabel": "I agree to the {termsLink} and have read the Privacy Policy",
      "termsLabelWithAge": "I’m 13+ years of age, agree to the {termsLink} and have read the Privacy Policy",
      "termsLinkText": "Terms and Conditions",
      "termsRequired": "You need to agree to the Terms and Conditions",
      "signingUpAs": "Signing up as {email}",
      "complete": "You’re in! Let’s get exploring.",
      "completeCampaign": "Woo! Signed in. Let’s get you back to the campaign.",
      "skip": "Skip",
      "engineering": "Engineering",
      "soundDesign": "Sound Design",
      "gaming": "Gaming",
      "hiImBlinky": "Hi, I'm Blinky.",
      "letsStartExploring": "Let's start exploring",
      "toStartExploring": "to start exploring!",
      "options": "Options.",
      "sometimesItsHardTo": "Sometimes it's hard to",
      "knoWhichWayToGo": "know which way to go...",
      "butThatsWhyImHere": "But that's why I'm here!",
      "letsFindYourThing": "Let's find your thing.",
      "andGetYouPaidForIt": "and get you paid for it",
      "defaultMessage": "Welcome! Let's get you set up."
    },
    "signInQuestions": {
      "aboutYou": "Welcome back! Before you carry on, can I get a couple of details from you?",
      "marketing": "One more thing. Want me to keep you posted by email?",
      "complete": "Thanks! Let’s get back to it."
    },
    "activity": {
      "badge": {
        "displayedSkill": "You've displayed a new skill"
      },
      "overview": {
        "by": "Sponsored by {name}",
        "learningObjectives": "What you will learn",
        "skills": "Skills in this collection",
        "start": "Start",
        "continue": "Continue",
        "prize": {
          "tagEntryConfirmed": "You are entered into the prize giveaway",
          "tagMissingVerification": "You need to verify your phone number to be entered into the prize giveaway"
        },
        "tabs": {
          "learningOutcomes": "What you will learn",
          "skills": "Skills in this collection",
          "prizeEntry": "Prize entry"
        }
      },
      "completion": {
        "completedHeading": "Well done completing {name}!",
        "continueJourney": "Continue your journey",
        "chooseDifferentStory": "Choose a different story",
        "storiesCompleted": "stories completed",
        "skillsDisplayed": "Skills you've displayed",
        "youveEarned": "You've earned:",
        "coins": "coins",
        "bonusCoins": "bonus coins",
        "totalCoins": "total coins",
        "saveCoins": "Save Coins",
        "saveProgress": "Save progress",
        "keepLearning": "Keep learning",
        "notSavedYet": "Not saved yet",
        "ghostCoinsHint": "Coins count once they’re on an account. Until then they only live in this browser.",
        "greatJob": "Great job completing this activity!",
        "completionHeadingCollection": "Congratulations on completing the {assetName} on {collectionName}!",
        "completionHeadingStandalone": "Congratulations on completing the {assetName}!",
        "reCompletionHeadingCollection": "Congratulations on re-doing the {assetName} on {collectionName}!",
        "reCompletionHeadingStandalone": "Congratulations on re-doing the {assetName}!",
        "partialCount": "{completed}/{total} completed",
        "partialUnlockMessage": "Complete all {total} to unlock the badge and get bonus coins.",
        "partialUnlockBadgeOnlyMessage": "Complete all {total} to unlock the badge.",
        "enterPrizeDraw": "Enter prize draw",
        "skipPrizeDraw": "Skip prize draw",
        "wellDone": "Well done!",
        "prize": {
          "confirmHeading": "Confirm your entry",
          "confirmBody": "By clicking on the button below you are accepting our {termsLink} for the {prizeName}.",
          "confirmTermsLink": "terms and conditions",
          "confirmButton": "Confirm entry",
          "cancelButton": "Cancel",
          "confirmedHeading": "Nice! You're in the prize draw!",
          "confirmedBody": "Your entry for the {prizeName} is locked in.",
          "confirmedSubtext": "We'll announce winners soon. Good luck!",
          "phoneSkippedHeading": "You're almost done",
          "phoneSkippedBody": "We've saved your entry, but you'll need to verify your number later to lock it in.",
          "phoneSkippedSubtext": "You can do it at anytime from your profile page.",
          "cancelledHeading": "All good! Maybe next time",
          "cancelledBody": "You skipped the prize draw this time. You can always enter the next one.",
          "skillAnswerLabel": "Your answer",
          "skillAnswerPlaceholder": "Type your answer…",
          "confirmedSubtextJudged": "Winners are chosen on the best answers. We’ll announce them soon!"
        },
        "consideration": {
          "heading": "You have increased your knowledge around {area}!"
        },
        "clarity": {
          "heading": "Your clarity score went up!",
          "subtitle": "Keep exploring to grow it even more."
        },
        "firstBadge": {
          "title": "You earned your first badge! 🎉",
          "subtitle": "Nice one. Explore your badges to see what you've earned and what you can unlock next.",
          "exploreCta": "Explore badges",
          "dismissCta": "Maybe later"
        },
        "feedbackSurvey": {
          "teacherDisclosure": "Your teacher will see your answers next to your name.",
          "teacherDisclosureAnonymous": "Your teacher will see your answers, but not your name.",
          "skip": "Skip these questions",
          "thanksHeading": "Thanks for your feedback!"
        }
      },
      "mentor": {
        "storyCompleted": "completed",
        "pageOfTotal": "Page {current} of {total}",
        "disclaimer": "View General Advice Warning and Disclaimer",
        "disclaimerTitle": "General Advice Warning and Disclaimer"
      },
      "sentiment": {
        "feedbackSubmitted": "Thank you for your feedback!",
        "feedbackFailed": "Failed to submit feedback. Please try again.",
        "howDidYouFind": "How did you find {name}?",
        "positive": "Loved it",
        "neutral": "Don't care",
        "negative": "Didn't like it",
        "skip": "Skip",
        "submit": "Submit"
      },
      "closeConfirmation": {
        "title": "Are you sure you want to leave?",
        "description": "All your progress will be lost",
        "confirm": "Yes, leave",
        "cancel": "Cancel"
      },
      "notFound": {
        "heading": "Oops! I can't seem to find that content right now.",
        "description": "This activity may have been moved or is temporarily unavailable.",
        "goBack": "Go back"
      },
      "back": {
        "toPlace": "Back to {place}",
        "plain": "Back"
      }
    },
    "lessonStart": {
      "pageTitle": "Join the lesson",
      "blinkyIntro": "{teacher} has shared the lesson - “{lesson}”",
      "fallbackTeacher": "Your teacher",
      "completeMessage": "Woo! Signed in. Let’s get you started on your teacher’s lesson.",
      "enterTheCode": "Enter the code",
      "codeInputLabel": "Lesson code",
      "codeInputPlaceholder": "Your Code",
      "codeSubmitCta": "Submit",
      "startFailed": "The lesson could not be started, please try again later",
      "coachSeedFailed": "We couldn’t hand this lesson to your coach. If it doesn’t come up, try the code again.",
      "anonymousNotice": "You don’t need an account for this lesson, and we won’t ask for your name or email. We record your progress so your teacher can see where the class is up to in the lesson, not who you are. If you’re signed in, your progress is saved to your account.",
      "errorTitle": "Couldn’t load the lesson",
      "errorBody": "Try scanning the code again, or ask your teacher for a fresh one.",
      "errorRetryCta": "Try a different code",
      "noAccessTitle": "You don’t have access to this lesson",
      "noAccessBody": "This lesson was set for a specific class. Make sure you’ve accepted your school invite and been added to that class by your teacher.",
      "noAccessSeeLessonsCta": "See my lessons",
      "authPromptLine": "Shared by {teacher}. If this lesson is for you, log in to open it.",
      "authPromptLoginCta": "Log in",
      "startLessonCta": "Start lesson",
      "privacyDisclaimer": "By starting, you agree to our {privacyLink}.",
      "backToCoach": "Back to coach"
    },
    "results": {
      "raisec": {
        "heroTitle": "Your interests profile",
        "contentTitle": "Here’s what makes you tick",
        "contentDescription": "These are the interest areas that came through strongest for you.",
        "parts": {
          "R": {
            "title": "Realistic (R)",
            "shortTitle": "Realistic",
            "description": "Hands-on, practical, and happiest building or fixing real things."
          },
          "I": {
            "title": "Investigative (I)",
            "shortTitle": "Investigative",
            "description": "Curious and analytical, you like solving problems and understanding how things work."
          },
          "A": {
            "title": "Artistic (A)",
            "shortTitle": "Artistic",
            "description": "Creative and expressive, drawn to originality and design."
          },
          "S": {
            "title": "Social (S)",
            "shortTitle": "Social",
            "description": "People-focused, you like helping, teaching, and working with others."
          },
          "E": {
            "title": "Enterprising (E)",
            "shortTitle": "Enterprising",
            "description": "Persuasive and driven, energized by leading and taking initiative."
          },
          "C": {
            "title": "Conventional (C)",
            "shortTitle": "Conventional",
            "description": "Organized and detail-oriented, you bring structure and reliability."
          }
        }
      },
      "myersBriggs": {
        "heroTitle": "Your personality type",
        "contentTitle": "Here’s what makes you, you",
        "contentDescription": "These are the four traits that shaped your type.",
        "parts": {
          "E": {
            "title": "Extraverted (E)",
            "description": "Energized by people and the buzz of being around others."
          },
          "I": {
            "title": "Introverted (I)",
            "description": "Recharges with focus and quiet, thinking things through first."
          },
          "S": {
            "title": "Sensing (S)",
            "description": "Grounded in facts and the details you can see, hear and touch."
          },
          "N": {
            "title": "Intuitive (N)",
            "description": "Drawn to patterns, ideas and what could be."
          },
          "T": {
            "title": "Thinking (T)",
            "description": "Decides with logic, weighing things objectively."
          },
          "F": {
            "title": "Feeling (F)",
            "description": "Decides with values and how choices affect people."
          },
          "J": {
            "title": "Judging (J)",
            "description": "Likes plans, structure and things settled."
          },
          "P": {
            "title": "Perceiving (P)",
            "description": "Likes staying open, flexible and spontaneous."
          }
        }
      },
      "superWorkValues": {
        "heroTitle": "Your top work value",
        "contentTitle": "Here’s what matters most to you at work",
        "contentDescription": "This is the value that came through strongest in your choices.",
        "parts": {
          "altruism": {
            "title": "Making a Difference",
            "description": "Wanting work that helps other people."
          },
          "economic-returns": {
            "title": "Financial Security",
            "description": "Wanting work that pays well and builds financial security."
          },
          "security": {
            "title": "Security",
            "description": "Wanting steady, dependable work you can count on."
          },
          "independence": {
            "title": "Autonomy",
            "description": "Wanting the freedom to work your own way."
          },
          "variety": {
            "title": "Variety",
            "description": "Wanting work that changes and keeps things fresh."
          },
          "prestige": {
            "title": "Recognition",
            "description": "Wanting work that earns respect and recognition."
          },
          "achievement": {
            "title": "Achievement",
            "description": "Wanting work where you get results and master your craft."
          },
          "way-of-life": {
            "title": "Work-Life Fit",
            "description": "Wanting work that fits the life you want to live."
          },
          "surroundings": {
            "title": "Great Surroundings",
            "description": "Wanting a pleasant place to do your work."
          },
          "creativity": {
            "title": "Creativity",
            "description": "Wanting work where you create new ideas and things."
          },
          "aesthetics": {
            "title": "Aesthetics",
            "description": "Wanting work that makes things beautiful."
          },
          "intellectual-stimulation": {
            "title": "Intellectual Stimulation",
            "description": "Wanting work that keeps you thinking."
          },
          "management": {
            "title": "Leading Others",
            "description": "Wanting work where you lead and organize others."
          },
          "supervisory-relations": {
            "title": "A Good Boss",
            "description": "Wanting work with a fair, supportive manager."
          },
          "associates": {
            "title": "Belonging",
            "description": "Wanting work with people you like and belong with."
          }
        }
      },
      "selfEfficacy": {
        "heroTitle": "Your self-belief profile",
        "contentTitle": "Here’s how your self-belief shows up",
        "contentDescription": "This is where your confidence is at right now, and the source that fuels it most.",
        "parts": {
          "strong-mastery": {
            "title": "Strong: Proven by Doing",
            "shortTitle": "Proven by Doing",
            "description": "Your self-belief is strong and built on real experience. You trust yourself because you’ve done hard things before."
          },
          "strong-vicarious": {
            "title": "Strong: Inspired by Others",
            "shortTitle": "Inspired by Others",
            "description": "Your self-belief is strong, and it grows when you watch people like you succeed."
          },
          "strong-persuasion": {
            "title": "Strong: Backed by Encouragement",
            "shortTitle": "Backed by Encouragement",
            "description": "Your self-belief is strong, and the support and belief of others keeps it charged."
          },
          "strong-emotional": {
            "title": "Strong: Steady Under Pressure",
            "shortTitle": "Steady Under Pressure",
            "description": "Your self-belief is strong, and you know how to read and settle your own nerves."
          },
          "building-mastery": {
            "title": "Building: Learning by Doing",
            "shortTitle": "Learning by Doing",
            "description": "Your self-belief is growing with every attempt. Each new challenge you take on adds to it."
          },
          "building-vicarious": {
            "title": "Building: Learning from Role Models",
            "shortTitle": "Learning from Role Models",
            "description": "Your self-belief is growing, and seeing others succeed shows you what’s possible for you."
          },
          "building-persuasion": {
            "title": "Building: Lifted by Support",
            "shortTitle": "Lifted by Support",
            "description": "Your self-belief is growing, and encouragement from the people around you gives it a real boost."
          },
          "building-emotional": {
            "title": "Building: Finding Your Calm",
            "shortTitle": "Finding Your Calm",
            "description": "Your self-belief is growing as you learn to manage nerves and turn them into focus."
          },
          "emerging-mastery": {
            "title": "Emerging: Ready for Small Wins",
            "shortTitle": "Ready for Small Wins",
            "description": "Your self-belief is just getting started. Small wins from giving it a try will build it fastest."
          },
          "emerging-vicarious": {
            "title": "Emerging: Looking for Role Models",
            "shortTitle": "Looking for Role Models",
            "description": "Your self-belief is just getting started. Watching people like you succeed will help it grow."
          },
          "emerging-persuasion": {
            "title": "Emerging: Fueled by Encouragement",
            "shortTitle": "Fueled by Encouragement",
            "description": "Your self-belief is just getting started. Encouragement from the people around you will make a big difference."
          },
          "emerging-emotional": {
            "title": "Emerging: Getting to Know Your Nerves",
            "shortTitle": "Getting to Know Your Nerves",
            "description": "Your self-belief is just getting started. Learning to read and settle your feelings will help it grow."
          },
          "emerging-balanced": {
            "title": "Emerging: A Little of Everything",
            "shortTitle": "A Little of Everything",
            "description": "Your self-belief is just getting started, drawing evenly on doing, watching, encouragement and feelings."
          }
        }
      },
      "careerAdaptability": {
        "heroTitle": "Your career adaptability strength",
        "contentTitle": "Here’s how you handle what’s next",
        "contentDescription": "This is the career-readiness strength that came through most in your answers.",
        "parts": {
          "concern": {
            "title": "The Planner",
            "description": "You look ahead and care about your future. Thinking about what’s next comes naturally to you."
          },
          "control": {
            "title": "The Driver",
            "description": "You like steering your own future and taking responsibility for the choices that shape it."
          },
          "curiosity": {
            "title": "The Explorer",
            "description": "You love checking out possibilities and imagining the different ways your future could go."
          },
          "confidence": {
            "title": "The Doer",
            "description": "You back yourself to tackle obstacles and turn your plans into action."
          },
          "balanced": {
            "title": "The Generalist",
            "description": "You draw on planning, ownership, exploring and self-belief in fairly equal measure."
          }
        }
      },
      "fallback": {
        "contentTitle": "Your result"
      }
    },
    "activities": {
      "singleJob": {
        "roleOfAi": "The role of AI",
        "personalised": "Personalized",
        "theGood": "The good",
        "theBad": "The bad",
        "readMoreAbout": "Read more about {title}"
      },
      "singleInstitution": {
        "funFacts": "Fun Facts"
      },
      "multipleInstitutions": {
        "title": "Explore Institutions"
      },
      "multipleJobs": {
        "title": "Explore Jobs"
      }
    },
    "institution": {
      "nav": {
        "ariaLabel": "Institution page sections",
        "overview": "Overview",
        "careers": "Careers & work"
      },
      "hero": {
        "location": "Location",
        "exploreCourses": "Explore programs",
        "campuses": "{count} Campus | {count} Campuses",
        "topRanked": "Top 50",
        "favouriteLabel": "Save {name}"
      },
      "about": {
        "title": "About {name}",
        "showMore": "Show more",
        "showLess": "Show less",
        "imagesLabel": "Photos of {name}",
        "imageAlt": "Photo of {name}"
      },
      "costs": {
        "title": "Costs",
        "subtitle": "What it really costs to live and work here",
        "courseFee": "Avg tuition",
        "courseFeeRange": "Range {min} - {max}/yr",
        "internationalFee": "Avg international fee",
        "medianRent": "Median rent",
        "perWeek": "/ wk",
        "inSuburb": "In {suburb}",
        "livingCosts": "Avg monthly living costs",
        "perMonth": "/ mo",
        "excludingTuition": "Excluding tuition",
        "coffeePrice": "Avg coffee price",
        "standardCappuccino": "Standard cappuccino",
        "perYear": "/ yr",
        "source": "Source: IPEDS {year}",
        "residency": {
          "inDistrictTitle": "In-district cost per year",
          "districtResidents": "Residents of the college’s district",
          "inStateTitle": "In-state cost per year",
          "outOfStateTitle": "Out-of-state cost per year",
          "flatTitle": "Cost per year",
          "yourRate": "Your rate as a resident of {state}",
          "residents": "{state} residents",
          "otherStates": "Students from other states",
          "sameRate": "Same rate for every state",
          "tuitionFees": "Tuition & fees {amount}",
          "books": "Books {amount}",
          "roomAndBoard": "Room & board {amount}",
          "noHousing": "No on-campus housing",
          "breakdownSeparator": " · "
        }
      },
      "numbers": {
        "title": "By the numbers",
        "gettingIn": "Getting in",
        "atarRange": "ATAR range",
        "medianAtar": "Median ATAR",
        "gpaRange": "GPA range",
        "medianGpa": "Median GPA",
        "satRange": "SAT range",
        "medianSat": "Median SAT",
        "entryScoreRange": "Entry score range",
        "medianEntryScore": "Median entry score",
        "notAvailable": "N/A",
        "courseMix": "Program mix",
        "courseMixAriaLabel": "Program mix by degree level",
        "totalCourses": "{count} program | {count} programs",
        "undergraduate": "Undergraduate",
        "postgraduate": "Graduate",
        "vocational": "Vocational / trade",
        "acrossFaculties": "Across {count} school and field of study | Across {count} schools and fields of study",
        "popularCourses": "Most popular programs",
        "topThree": "Top 3"
      },
      "topVibes": {
        "title": "About the neighborhood",
        "subtitle": "Characteristics of the area around {name}",
        "attribution": "Source: {dataset}"
      },
      "topOccupations": {
        "title": "Popular careers from {name}",
        "subtitle": "Where a degree from {name} can take you",
        "wagePerYear": "{wage}/year"
      },
      "enquiry": {
        "title": "Interested in {name}?",
        "visitWebsite": "Visit website",
        "favouriteLabel": "Save {name}",
        "websiteLabel": "Visit the {name} website (opens in a new tab)"
      },
      "map": {
        "title": "Campus explorer",
        "campusesLabel": "Campus list",
        "mainCampus": "Main campus",
        "loadError": "We couldn't load the map right now."
      },
      "socials": {
        "title": "On socials",
        "subtitle": "See what campus life really looks like",
        "viewPost": "View post",
        "viewPostBy": "View post by {handle}",
        "stats": {
          "views": "views",
          "likes": "likes",
          "comments": "comments"
        }
      },
      "alumni": {
        "quote": "“{blurb}”",
        "studied": "Studied",
        "readMoreNewTab": "Read more about {name} (opens in a new tab)",
        "previous": "Previous graduate",
        "next": "Next graduate"
      },
      "areaOfStudy": {
        "tileNewTab": "{label} (opens in a new tab)"
      },
      "event": {
        "viewDetails": "View event details",
        "timeRange": "{start} – {end}",
        "dateRange": "{start} – {end}",
        "ctaNewTab": "{label} (opens in a new tab)",
        "previous": "Previous event",
        "next": "Next event",
        "viewDetailsNewTab": "View event details (opens in a new tab)",
        "imageAlt": "{title}"
      }
    },
    "index": {
      "placeholderTitle": "Placeholder index page"
    },
    "join": {
      "headerGeneric": "Setting things up…",
      "bodyGeneric": "Just a moment, we’re getting things ready.",
      "headerWithSchool": "Join {school}",
      "bodyWithSchool": "You’re about to join {school}. Click below to continue.",
      "bodyWithEmail": "This invite is for {email}. You’re about to join {school}. Click below to continue.",
      "cta": "Get started",
      "joinCta": "Join {school}",
      "error": "Something went wrong. Please try again.",
      "expired": {
        "header": "This invite has expired",
        "body": "Your invite to {school} has expired. Ask your teacher to send you a new one."
      },
      "accepted": {
        "header": "This invite has already been used",
        "body": "Looks like this invite was already accepted. If that was you, just log in to continue.",
        "cta": "Log in"
      },
      "mismatch": {
        "body": "This invite is for {email}, but you’re signed in as {userEmail}.",
        "cta": "Log in as {email}"
      },
      "classroomNotVerified": {
        "header": "This classroom isn’t open to students yet"
      },
      "invalid": {
        "header": "This invite link isn’t valid",
        "body": "The link may be incorrect or no longer active. Ask your teacher to send you a new invite."
      },
      "explanation": {
        "sharedProfile": "Anyway Schools uses your existing Anyway account and profile. It doesn’t create a separate account or a private school profile, and the career summary your school can see may include information you’ve added outside of school.",
        "noRewards": "There are no rewards on Anyway Schools, so you won’t earn coins or prizes for anything you do here.",
        "verifyInvite": "If you weren’t expecting this invitation, confirm it through a school channel you know, like a teacher or the school office, before you join.",
        "privacyLink": "Privacy information",
        "supportLink": "Contact support"
      }
    },
    "landing": {
      "learn": "Learn",
      "logIn": "Log in",
      "disclosure": "Promotions may involve games of skill or chance. Details, including how winners are determined, are provided in the applicable promotion terms.",
      "realCareers": {
        "title": {
          "1": "Real Careers.",
          "2": "Real Rewards."
        },
        "description": {
          "1": "Explore careers and earn coins you can redeem for real rewards.",
          "2": "Because figuring out your future should be rewarding."
        },
        "ctaBtnLabel": "Start earning",
        "blinkySpeech": "We work with companies that want to reward you for learning about their world. Good for them. Good for you."
      },
      "hero": {
        "heading": "Find your thing",
        "subheading": "Experience careers. Make a plan. Earn rewards.",
        "description": "We help you test-drive different futures, giving you the tools, experiences, and real rewards to figure out what excites you (and what doesn't).",
        "cta": "Get started",
        "careers": {
          "cabinCrew": "Flight attendant",
          "baker": "Baker",
          "professionalAthlete": "Professional boxer"
        },
        "scroll": "Scroll"
      },
      "careers": {
        "blinkyMessages": {
          "hiImBlinky": "Hi, I'm Blinky",
          "schoolToWorkFeelsHuge": "I know that going from school to work feels huge.",
          "everythingShouldFallIntoPlace": "Like everything should fall into place the second you step out of those gates.",
          "lifeDoesntWorkLikeThat": "But life doesn't work like that. And it shouldn't.",
          "thatsWhyImHere": "That's why I'm here. To help you find your thing. (And get paid for it!)"
        },
        "findAFuture": "Test-drive careers to see what fits",
        "letsGo": "Let's go",
        "graduatesFact": "Students are 42% more likely to achieve their goals when written down and progress is tracked",
        "source": "Source:",
        "universitiesAustralia": "Universities Australia"
      },
      "testimonials": {
        "heading": "Don't just take our word for it"
      },
      "yourThing": {
        "cardText": "No one else can tell you what your thing is. And you might even have more than one.",
        "cta": "Get started",
        "blinkyFarewell": "Let's start planning your future together"
      },
      "getLifeReady": {
        "tag": "Learn the skills you need",
        "skills": {
          "managingMoney": "Managing money",
          "gettingAJob": "Getting a job",
          "wellbeing": "Wellbeing",
          "volunteering": "Volunteering",
          "sustainability": "Sustainability",
          "digitalSkills": "Digital skills"
        }
      },
      "makeAPlan": {
        "heading": "Make a plan",
        "cta": "Start planning",
        "blinkyMessage": "Hey! I'm Blinky, your personalized career coach. Making life decisions can be tough, but I'm here to help you through it. Let's have a chat!",
        "labels": {
          "engineering": "Engineering",
          "nursing": "Nursing",
          "construction": "Construction",
          "budgeting": "Budgeting",
          "travel": "Travel"
        }
      },
      "virtualCareer": {
        "heading": "Virtual career experiences",
        "description": "Try out one of our virtual career experiences. The more you explore now, the more likely you are to find work that means something to you.",
        "cta": "Explore more"
      },
      "activeCampaign": {
        "daysLeft": "Closes today | Closes in {count} day | Closes in {count} days",
        "inPartnershipWith": "Reward brought to you by",
        "broughtToYouBy": "Brought to you by",
        "cta": "Get Started",
        "terms": "Rewards, competitions and promotions are subject to specific terms and conditions, including how winners are determined. Unpartnered brands not affiliated with promotions",
        "earnableCoins": "Earn {coins} coins",
        "completions": "{count} completion | {count} completions"
      }
    },
    "rewards": {
      "placeholderTitle": "Placeholder landing rewards"
    },
    "careers": {
      "title": "Careers",
      "noIndustriesFound": "No industries found",
      "noIndustriesPublished": "No industries published",
      "showMore": "Show more",
      "hero": {
        "heading": "Find a career that actually fits you",
        "subheading": "Understand where your strengths lie, what careers could suit you and develop a personal career plan with our AI career coach",
        "scroll": "Scroll",
        "spotlightImages": {
          "audioEngineer": "Audio Engineer",
          "astronaut": "Astronaut",
          "streamer": "Streamer"
        }
      },
      "coach": {
        "subheading": "Not sure where to start?",
        "heading": "Chat with Blinky,\n our AI career coach"
      },
      "exploreIndustries": "Explore industries",
      "exploreIndustryHubs": "Explore industry hubs",
      "liveExpo": "Live expo",
      "hubWithLiveExpoAriaLabel": "View {title}, live expo"
    },
    "about": {
      "nav": {
        "ourStory": "Our Story",
        "approach": "Approach",
        "partners": "Partners",
        "team": "Team"
      },
      "partnerWithUs": "Partner with us",
      "news": {
        "title": "Anyway in the news",
        "subtitle": "The latest stories, reports and announcements from Anyway",
        "cta": "Explore media"
      }
    },
    "partners": {
      "nav": {
        "theProblem": "The problem",
        "ourSolutions": "Our solutions",
        "partnerships": "Partnerships"
      },
      "contactUs": "Contact us"
    },
    "learn": {
      "pageHeading": "Learn and earn rewards",
      "collectionNotFound": "Collection not found",
      "assetNotFound": "Learning asset not found",
      "durationMinutes": "{count} Minute | {count} Minutes",
      "pages": {
        "collections": {
          "pageTitle": "Library",
          "sections": {
            "inProgress": "Pick up where you left off",
            "sponsored": "From our partners",
            "moreToExplore": "More to explore"
          },
          "search": {
            "placeholder": "Search experiences",
            "label": "Search experiences",
            "clear": "Clear search",
            "resultsHeading": "Results",
            "noResults": {
              "title": "No experiences found",
              "description": "We couldn’t find any experiences matching your search."
            },
            "resultsCount": "Showing {count} experience | Showing {count} experiences"
          },
          "errors": {
            "loadFailed": "Couldn't load the library. Please refresh."
          },
          "navLabel": "Library",
          "seoTitle": "Browse the Learning Library | Anyway",
          "seoDescription": "Discover learning experiences and playlists to keep building skills on Anyway."
        },
        "explore": {
          "pageTitle": "Explore",
          "sections": {
            "sponsored": "From our partners",
            "moreToExplore": "More to explore"
          },
          "search": {
            "placeholder": "Search experiences",
            "label": "Search experiences",
            "clear": "Clear search",
            "resultsHeading": "Results",
            "noResults": {
              "title": "No experiences found",
              "description": "We couldn’t find any experiences matching your search."
            },
            "resultsCount": "Showing {count} experience | Showing {count} experiences"
          },
          "filters": {
            "noResults": {
              "title": "No experiences found",
              "description": "No experiences match these filters. Try removing one."
            }
          },
          "errors": {
            "loadFailed": "Couldn't load the catalog. Please refresh."
          },
          "empty": {
            "title": "Nothing to explore yet",
            "description": "Check back soon for new experiences."
          },
          "seoTitle": "Explore Learning Experiences | Anyway",
          "seoDescription": "Browse every learning experience and playlist available on Anyway. Discover before you sign up."
        }
      },
      "welcomeMessage": "Welcome! I'm Blinky.",
      "loginAriaLabel": "Login",
      "logoAlt": "Anyway logo",
      "popularTopics": "Popular Topics",
      "popularChannels": "Popular Channels",
      "exploreTopics": "Explore Topics",
      "stories": "Stories",
      "experiences": "Experiences",
      "faqs": "FAQs",
      "trending": {
        "heading": "Trending experiences",
        "description": "Try out some of our unique partner experiences and get paid with coins and rewards.",
        "cta": "See more",
        "coinsPerDollar": "{coins} coins = $1"
      },
      "coinRush": {
        "bannerAlt": "Coin Rush is now active! Earn 4x coins on all unsponsored content this school holiday period."
      },
      "testimonials": {
        "card1": "Your site gives me so much comfort. Knowing all my experiences are completely normal y'know? It's not just the kind of generic stuff every adult drills into us - it really calms the whole school/life thing down. Super refreshing!",
        "card2": "Think of everything important they didn't teach you in school - Anyway covers all of that.",
        "card3": "Your website has changed my mindset on life after school - thank you so much for the service you provide!",
        "card4": "I'm in the 11th grade and your site is super helpful, relatable and comforting. It's so nice to know you went through the same sh*t. Thank you!"
      },
      "spotlight": {
        "heading": "How Anyway works",
        "card1Title": "Explore your future, your way.",
        "card1Description": "Follow your interests across careers, skills and real-world pathways.",
        "card2Title": "Experience a wide range of careers.",
        "card2Description": "Explore careers through interactive stories and earn coins and rewards.",
        "card3Title": "Get paid. Win prizes.",
        "card3Description": "Use your coins and complete campaign drops for a shot at prizes."
      }
    },
    "planIa": {
      "pageHeading": "Plan",
      "pathwaysTile": {
        "title": "Pathways",
        "description": "Map the steps to your dream job. Save routes that interest you, or build your own from your saved jobs."
      },
      "portfolioTile": {
        "title": "Portfolio",
        "description": "Keep track of the things you’ve done, learned and achieved along the way."
      },
      "savedTile": {
        "title": "Saved",
        "description": "Save jobs, courses and opportunities you want to come back to."
      },
      "clarity": {
        "title": "Clarity score",
        "description": "See what’s shaping your career clarity score and where you can build more confidence.",
        "cta": "View clarity score",
        "value": "{percentage}%",
        "ringLabel": "Career clarity score: {percentage} percent"
      }
    },
    "profileIa": {
      "pageHeading": "Profile",
      "header": {
        "changeAvatar": "Change your avatar",
        "editDetails": "Edit details",
        "phoneVerified": "Verified"
      },
      "details": {
        "title": "Personal details",
        "description": "Your account information and personal details.",
        "firstName": "First name",
        "lastName": "Last name",
        "email": "Email",
        "phone": "Phone number",
        "state": "State",
        "birthday": "Birthday",
        "notSet": "Not set",
        "edit": "Edit details",
        "cancel": "Cancel"
      },
      "preferences": {
        "title": "Preferences",
        "description": "Choose how Anyway works for you.",
        "animations": {
          "label": "Allow animations",
          "description": "Enjoy animations and visual effects throughout Anyway."
        },
        "emails": {
          "label": "Emails from Anyway",
          "description": "Get updates about new experiences, rewards and opportunities."
        },
        "saved": "Preferences updated"
      },
      "security": {
        "title": "Account security",
        "description": "Manage your password and keep your account secure."
      },
      "support": {
        "title": "Need a hand?",
        "description": "Got a question, feedback or something not working? We’re here to help.",
        "contact": "Get in touch",
        "faq": "Browse FAQs",
        "opensInNewTab": "(opens in a new tab)"
      }
    },
    "clarityIa": {
      "pageHeading": "Career clarity",
      "score": {
        "title": "Career clarity score",
        "description": "Career Clarity measures your progress toward making an informed career decision. The higher your score, the more you’ve explored your options and the better prepared you are to plan your future.",
        "value": "{percentage}%",
        "ringLabel": "Career clarity score: {percentage} percent",
        "riskTriggerLabel": "{risk}. What is career clarity?"
      },
      "explainer": {
        "title": "What is career clarity?",
        "close": "Got it"
      },
      "areas": {
        "heading": "How your score is made up",
        "description": "These areas contribute to your clarity score",
        "loadError": "We couldn’t load your areas right now."
      }
    },
    "learnIa": {
      "pageHeading": "Learn",
      "experiences": {
        "title": "Experiences for you",
        "seeAll": "All experiences"
      },
      "latestReads": {
        "title": "Latest reads",
        "seeAll": "All advice"
      },
      "selfDiscovery": {
        "title": "Learn about yourself"
      },
      "badges": {
        "title": "Latest badges to earn",
        "seeAll": "All badges"
      },
      "nav": {
        "ariaLabel": "Learn sections",
        "all": "All",
        "experiences": "Experiences",
        "advice": "Advice",
        "badges": "Badges"
      },
      "rewardsTile": {
        "title": "Anyway rewards",
        "description": "Earn coins while you learn and go into draws to win money can’t buy experiences.",
        "badge": "Rewards"
      },
      "experiencesTile": {
        "title": "Experiences",
        "description": "Explore Anyway career experiences. The more you explore now, the more likely you are to find work that fits."
      },
      "featuredExpo": {
        "title": "Featured expo"
      },
      "watchDiscover": {
        "title": "Watch and discover",
        "seeAll": "All videos"
      },
      "filters": {
        "ariaLabel": "Filter experiences",
        "all": "All experiences",
        "any": "Any {label}",
        "industry": {
          "label": "Industry"
        },
        "type": {
          "label": "Type",
          "partner": "Partner experiences",
          "anyway": "Anyway experiences"
        },
        "coins": {
          "label": "Coin value",
          "under-200": "Under 200 coins",
          "200-499": "200 to 499 coins",
          "500-plus": "500+ coins"
        },
        "length": {
          "label": "Length",
          "under-10": "Under 10 minutes",
          "10-30": "10 to 30 minutes",
          "over-30": "Over 30 minutes"
        },
        "picked": "{option}, {label} filter"
      },
      "experienceCard": {
        "completed": "Completed"
      },
      "byPartner": "by {partner}",
      "badgesCategory": {
        "gridTitle": "Tap on a badge to learn more",
        "empty": "No badges to earn yet",
        "error": "Couldn’t load badges. Please try again."
      },
      "featured": {
        "title": "Featured"
      },
      "partners": {
        "title": "More from our partners"
      },
      "articleFilters": {
        "ariaLabel": "Filter advice",
        "all": "All advice",
        "videos": "Videos",
        "empty": "No articles here yet. Try another filter.",
        "error": "Couldn’t load articles. Please refresh.",
        "showMore": "Show more",
        "search": {
          "placeholder": "Search articles",
          "label": "Search articles",
          "clear": "Clear search"
        },
        "noResults": "No articles match your search.",
        "resultsHeading": "Results",
        "resultsCount": "Showing {count} article | Showing {count} articles",
        "loadMoreError": "Couldn’t load more articles. Try again."
      },
      "videoFilters": {
        "empty": "No videos here yet.",
        "error": "Couldn’t load videos. Please refresh.",
        "search": {
          "placeholder": "Search videos",
          "label": "Search videos"
        },
        "noResults": "No videos match your search.",
        "resultsHeading": "Videos",
        "resultsCount": "Showing {count} video | Showing {count} videos",
        "loadMoreError": "Couldn’t load more videos. Try again."
      },
      "searchToggle": {
        "open": "Search"
      }
    },
    "exploreIa": {
      "pageHeading": "Explore",
      "nav": {
        "ariaLabel": "Explore sections",
        "all": "All",
        "institutions": "Institutions",
        "courses": "Courses",
        "industries": "Industries",
        "jobs": "Jobs"
      },
      "institutionsTile": {
        "title": "Institutions",
        "description": "Explore colleges, institutions and training providers."
      },
      "coursesTile": {
        "title": "Courses",
        "description": "Find the right course for your next step."
      },
      "jobsTile": {
        "title": "Jobs",
        "description": "Explore careers and find jobs that fit you."
      },
      "industriesTile": {
        "title": "Industries",
        "description": "Discover industries and where they could take you."
      },
      "industries": {
        "forYou": {
          "title": "Industries for you",
          "seeAll": "All industries"
        },
        "latestExpos": {
          "title": "Latest expos"
        },
        "recommended": {
          "title": "Recommended for you"
        },
        "all": {
          "title": "All industries"
        },
        "filters": {
          "ariaLabel": "Filter industries",
          "all": "All industries"
        },
        "search": {
          "label": "Search industries",
          "placeholder": "Search industries by name",
          "clear": "Clear search",
          "resultsHeading": "Search results",
          "resultsCount": "{count} industry found | {count} industries found",
          "noResults": "No industries match your search."
        }
      },
      "filters": {
        "counted": "{label} · {count}",
        "loadError": "We couldn’t load the filters right now."
      },
      "institutions": {
        "row": {
          "title": "Institutions to explore",
          "seeAll": "All institutions"
        },
        "filters": {
          "ariaLabel": "Filter institutions"
        }
      },
      "courses": {
        "row": {
          "title": "Courses to explore",
          "seeAll": "All courses"
        },
        "card": {
          "meta": "{level} · {duration}"
        },
        "filters": {
          "ariaLabel": "Filter courses",
          "all": "All courses",
          "level": "Qualification level",
          "location": "Location",
          "tiers": {
            "undergraduate": "Undergraduate",
            "postgraduate": "Postgraduate",
            "vocational": "Vocational"
          }
        },
        "search": {
          "label": "Search courses",
          "placeholder": "Search courses or institutions",
          "clear": "Clear search"
        },
        "results": {
          "heading": "Courses",
          "range": "Showing {to} of {total} courses",
          "empty": "No courses match these filters.",
          "emptyDescription": "Try clearing a filter or searching for something else.",
          "error": "We couldn’t load courses right now."
        }
      },
      "jobs": {
        "row": {
          "title": "Fast-growing jobs",
          "seeAll": "All jobs"
        },
        "card": {
          "wagePerYear": "{wage}/year"
        },
        "filters": {
          "ariaLabel": "Filter jobs",
          "all": "All jobs",
          "growing": "Growing",
          "industry": "Industry",
          "salary": "Salary",
          "salaryBands": {
            "low_pay": "Lower pay",
            "medium_pay": "Middle pay",
            "high_pay": "Higher pay"
          }
        },
        "search": {
          "label": "Search jobs",
          "placeholder": "Search jobs by name",
          "clear": "Clear search"
        },
        "results": {
          "heading": "Jobs",
          "range": "Showing {to} of {total} jobs",
          "empty": "No jobs match these filters.",
          "emptyDescription": "Try clearing a filter or searching for something else.",
          "error": "We couldn’t load jobs right now."
        }
      }
    },
    "partnerWithUs": {
      "heading": "Partner with us",
      "subheading": "Interested in working together?",
      "body": "We partner with brands, educators, industry, and governments who care about helping young people find their thing and build better futures. Let's create something great together.",
      "learnMore": "Learn more",
      "videoTitle": "Anyway Mission Statement"
    },
    "footer": {
      "copyright": "© 2026 ANYWAY"
    },
    "geoRegion": {
      "switcher": {
        "heading": "Region",
        "ariaLabel": "Choose your region"
      },
      "countryName": {
        "USA": "United States",
        "AUS": "Australia"
      },
      "selector": {
        "title": "Choose your region",
        "description": "Pick the version of Anyway made for where you are. You can change this at any time.",
        "current": "Current region"
      },
      "confirmDialog": {
        "title": "This page may not be available on the {region} site",
        "description": "We can take you to the {region} homepage instead.",
        "continue": "Continue to the {region} site",
        "stay": "Stay on this page"
      }
    },
    "common": {
      "back": "Back",
      "by": "By",
      "close": "Close",
      "exitPreview": "Exit preview",
      "yes": "Yes",
      "no": "No",
      "next": "Next",
      "select": "Select",
      "typeHere": "Type here",
      "min": "min",
      "minShort": "m",
      "earnCoins": "Earn {coins}",
      "rushCoins": "Coin Rush - {coins}",
      "progressCount": "Progress: {completed}/{total}",
      "readMore": "Read more",
      "exploreMore": "Explore more",
      "scrollLeft": "Scroll left",
      "scrollRight": "Scroll right",
      "scrollableList": "Scrollable list",
      "scrollableListRoleDescription": "scrollable list",
      "loadingContent": "Loading content, please wait",
      "assetCard": {
        "view": "View {title}",
        "withDetails": "{name}, {details}",
        "completed": "completed",
        "sponsor": "sponsored by {sponsor}",
        "coinRush": "Coin Rush",
        "coins": "earn {count} coin | earn {count} coins",
        "progress": "{completed} of {total} done",
        "duration": "{count} minute | {count} minutes",
        "wage": "{wage}",
        "wageUnavailable": "N/A",
        "saved": "saved"
      },
      "contentRecommendations": "Content recommendations",
      "jobRecommendations": "Job recommendations",
      "institutionRecommendations": "Institution recommendations",
      "actionRecommendations": "Action recommendations",
      "industryRecommendations": "Industry recommendations",
      "surveyRecommendations": "Feedback survey",
      "surveyCard": {
        "eyebrow": "Quick survey",
        "open": "Give feedback on {name}"
      },
      "saved": "Saved",
      "carousel": {
        "navigation": "Carousel navigation",
        "slideOf": "Slide {current} of {total}",
        "slide": "slide",
        "previousSlide": "Previous slide",
        "nextSlide": "Next slide",
        "pauseCarousel": "Pause carousel",
        "playCarousel": "Play carousel"
      },
      "submit": "Submit",
      "rateOf": "Rate {value} out of {max}",
      "likert": {
        "stronglyAgree": "Strongly agree",
        "agree": "Agree",
        "neutral": "Neutral",
        "disagree": "Disagree",
        "stronglyDisagree": "Strongly disagree"
      },
      "combobox": {
        "noResultsFound": "No results found",
        "loading": "Loading..."
      },
      "wagePerYear": "{wage}/year"
    },
    "toast": {
      "closeNotification": "Close notification",
      "defaultTitle": {
        "success": "Success",
        "error": "Error",
        "warning": "Warning"
      }
    },
    "account": {
      "heading": "My account",
      "verifyDialog": {
        "heading": "Complete your profile",
        "cta": "Verify now",
        "alertTitle": "Complete your account",
        "alertDescription": "To confirm your identity",
        "alertAriaLabel": "Complete your account to confirm your identity",
        "lacOverviewAlertTitle": "Complete profile to enter draw",
        "lacOverviewAlertAriaLabel": "Complete your profile to enter this prize draw"
      },
      "phoneField": {
        "saveAndVerify": "Save & verify",
        "changePhoneNumber": "Change phone number"
      },
      "password": {
        "addHeading": "Add a password",
        "changeHeading": "Change your password",
        "description": "Use a password as an alternative to emailed login codes.",
        "emailMeACode": "Email me a code",
        "codeSentTo": "Enter the code we sent to {email}",
        "codeIncorrect": "That code isn’t right.",
        "saveButton": "Save password",
        "saved": "Password saved"
      },
      "rosterManaged": "Your school manages this account, so it can’t be deleted here. Ask your school to remove you from their roster.",
      "nameRosterManaged": "Your school manages your name. Ask your teacher to change it."
    },
    "nav": {
      "home": "Home",
      "schools": "Schools",
      "account": "Account",
      "badges": "Badges",
      "rewardStore": "Reward Store",
      "saved": "Saved",
      "logout": "Logout",
      "learn": "Learn",
      "explore": "Explore",
      "coachAdvice": "Coach",
      "careerAdvice": "Career advice",
      "about": "About us",
      "signIn": "Sign in",
      "mainAriaLabel": "Main navigation",
      "portfolio": "Portfolio",
      "myLessons": "My Lessons",
      "menuButton": "Main menu",
      "closeMenu": "Close navigation",
      "drawerTitle": "Menu",
      "chat": "Chat",
      "plan": "Plan",
      "profile": "Profile",
      "clarityStat": "clarity",
      "clarityStatMenu": "clarity score",
      "coinsStat": "coins",
      "logOut": "Log out"
    },
    "explore": {
      "eyebrow": "Explore",
      "heading": "Explore what’s next for you",
      "pitch": "Choose a category to dig into industries, career advice and {nounPlural}.",
      "search": {
        "label": "Search everything",
        "placeholder": "Search {nounPlural}, jobs and industries",
        "institutions": "{nounPluralCapitalised}",
        "jobs": "Jobs",
        "industries": "Industries",
        "loading": "Searching…",
        "empty": "No matches yet. Keep typing, or press Enter to search {nounPlural}.",
        "failed": "Search isn’t working right now. Try again in a moment."
      },
      "browse": "Browse by category",
      "categories": {
        "industries": {
          "title": "Industries",
          "description": "Explore different industries, what they involve and how to get there."
        },
        "institutions": {
          "title": "Institutions",
          "description": "Colleges, universities and training providers across {region}."
        }
      },
      "coach": {
        "eyebrow": "Not sure where to start?",
        "heading": "Chat with Blinky",
        "description": "Get personalised recommendations based on your interests, goals and where you are right now.",
        "cta": "Start chatting"
      }
    },
    "jobCandidates": {
      "header": {
        "title": "Pathways"
      },
      "toast": {
        "jobSaved": "Added to your pathways"
      },
      "list": {
        "openRoute": "Open the plan for {route}",
        "setAside": "Not my thing",
        "restore": "Restore",
        "setAsideHeading": "Not my thing",
        "markTop": "Make {occupation} your top pick",
        "unmarkTop": "Remove {occupation} as your top pick",
        "orderHint": "Your top pick sits first."
      },
      "card": {
        "topPick": "Top pick",
        "shortlisted": "Shortlisted",
        "wagePerYear": "{wage} / year",
        "fastGrowing": "Fast growing",
        "routeKicker": "Route {number}",
        "fillStatus": {
          "empty": "Provider not picked yet",
          "partial": "Plan in progress",
          "filled": "Plan ready"
        },
        "menu": "Options for {occupation}",
        "showRoutes": "Show {count} route | Show {count} routes",
        "hideRoutes": "Hide routes"
      },
      "buckets": {
        "plans": {
          "title": "My pathway plans",
          "description": "Plans you’ve built with programs and institutions.",
          "sectionCount": "{count} complete",
          "sectionCountInProgress": "{count} in progress",
          "empty": "No plans yet. Tap Build plan on a saved pathway to start one."
        },
        "saved": {
          "title": "My saved pathways",
          "description": "Routes you’ve saved and can build into a plan.",
          "sectionCount": "{count} saved",
          "empty": "Nothing saved right now. Explore jobs with Blinky and save the routes that interest you.",
          "emptyCta": "Explore jobs"
        },
        "setAside": {
          "title": "Not my thing",
          "description": "Options you’re not considering right now.",
          "sectionCount": "{count} ruled out",
          "empty": "Nothing here yet. Routes you rule out wait here in case you change your mind."
        }
      },
      "row": {
        "buildPlan": "Build plan",
        "edit": "Edit",
        "preferred": "Preferred pathway",
        "courses": "{count} program | {count} programs",
        "institutions": "{count} institution | {count} institutions",
        "remove": "Remove the {route} route",
        "buildPlanFor": "Build plan for {route}",
        "editPlanFor": "Edit plan for {route}",
        "restoreRoute": "Restore {route}",
        "restoreJob": "Restore all routes for {occupation}",
        "setAsideRoute": "Mark {route} as not my thing"
      },
      "section": {
        "compareRoutes": "Compare routes",
        "setAsideAll": "Mark all as not my thing",
        "restoreJob": "Restore job",
        "restoreRoutes": "Restore these routes",
        "makeTopPick": "Make this your top pick",
        "removeTopPick": "Remove as top pick"
      },
      "empty": {
        "title": "You don’t have any pathways yet",
        "description": "Pathways map the steps to your dream job. Explore jobs with Blinky and save routes that interest you, or build a pathway from your saved jobs.",
        "cta": "Explore jobs with Blinky",
        "features": {
          "saveRoutes": {
            "title": "Save routes",
            "description": "Find jobs you’re interested in and save pathways to them."
          },
          "buildPlan": {
            "title": "Build your plan",
            "description": "Add programs and institutions to create your personalized pathway."
          },
          "trackProgress": {
            "title": "Track your progress",
            "description": "See your steps, stay motivated and move closer to your goal."
          }
        }
      },
      "error": {
        "message": "We couldn’t load your pathways right now.",
        "retry": "Try again"
      },
      "unavailable": {
        "title": "Pathways isn’t available yet"
      },
      "glance": {
        "title": "How you can get there",
        "subtitle": "{count} main route, leading to {occupation}. | {count} main routes, all leading to {occupation}.",
        "openRoute": "See the {route} route",
        "banner": {
          "title": "Not sure which route is right for you?",
          "description": "See each pathway side-by-side and choose the one that suits you best.",
          "cta": "See this pathway | Compare all {count} pathways"
        },
        "badges": {
          "mostFlexible": "Most flexible",
          "deepestGrounding": "Deepest grounding",
          "handsOnFromDayOne": "Hands-on from day one",
          "earnWhileYouLearn": "Earn while you learn",
          "mostCommonWayIn": "Most common way in",
          "broadestGrounding": "Broadest grounding"
        },
        "routes": {
          "degreeFirst": "Straight to 4-year college",
          "subdegreeFirst": "Community college first",
          "workFirst": "Work first",
          "certificateFirst": "Certificate first",
          "apprenticeship": "Apprenticeship",
          "military": "Military"
        },
        "stats": {
          "years": "{years} year | {years} years",
          "months": "{months} month | {months} months",
          "yearsAndMonths": "{years} {months}",
          "yearsRange": "{min}–{max} years",
          "durationRange": "{min}–{max}",
          "hecs": "HECS, nothing upfront",
          "subsidisedTafe": "Subsidised TAFE fees",
          "aroundFee": "Around {fee} in fees",
          "noAtar": "No ATAR needed",
          "atarAround": "ATAR around {atar}",
          "labels": {
            "duration": "Time to qualify",
            "fees": "Fees",
            "entry": "Entry"
          }
        }
      },
      "compare": {
        "heading": "Ways into {occupation}",
        "youAreHere": "You are here today",
        "medianWage": "Median wage: {wage}",
        "stateWage": "Typical pay in {state}: {wage}",
        "unavailable": "We couldn’t load the route steps right now.",
        "weighUp": {
          "thinkAbout": "What to think about",
          "openRoute": "Compare {route}"
        },
        "decision": {
          "interested": "I like it, save it to pathways",
          "saved": "Saved to {pathways}",
          "remove": "Remove",
          "notForMe": "Not my thing",
          "description": "Compare this route, then tell me what you think.",
          "pathways": "pathways"
        }
      },
      "routeDeepDive": {
        "title": "Build a plan",
        "stepsTitle": "Your steps",
        "stepsSubtitle": "Here’s the path from where you are now to your first job.",
        "personaliseHint": "Add your institution and program to personalize this step.",
        "goal": "Your goal",
        "slots": {
          "course": "Program",
          "institution": "Institution",
          "addCourse": "Shortlist a program",
          "addInstitution": "Shortlist an institution",
          "addAnotherCourse": "Add another program",
          "addAnotherInstitution": "Add another institution",
          "capHint": "You can shortlist up to {max}. Swap one out if you find a better fit.",
          "searchCourse": "Search program names and degrees",
          "searchInstitution": "Search universities, colleges, trade schools",
          "results": "Results",
          "remove": "Remove {name}",
          "resultsAnnouncement": "{count} results",
          "noResults": "No matches found",
          "searchError": "We couldn’t search right now. Try again.",
          "fromYourSaved": "Your saved",
          "recommended": "Recommended for you",
          "done": "Done",
          "search": "Search",
          "recommendedHint": "Matched to {job}. Search for anything else.",
          "suggestionsAnnouncement": "{count} to pick from",
          "capFullTitle": "Shortlist’s full",
          "loading": "Searching",
          "coursePromptTitle": "Start with what you’d study",
          "coursePromptBody": "Try a field like nursing, or a credential like an associate degree.",
          "institutionPromptTitle": "Where would you study?",
          "institutionPromptBody": "Search universities, colleges and trade schools.",
          "card": {
            "duration": "Duration",
            "durationYears": "{years} year | {years} years",
            "durationMonths": "{months} month | {months} months",
            "entryScore": "Entry score",
            "atar": "ATAR {score}",
            "noAtar": "N/A",
            "atarNotRequired": "No ATAR",
            "openAdmission": "Open admission",
            "gpa": "GPA {score}",
            "sat": "SAT {score}",
            "feeType": "Fee type",
            "feeHecs": "HECS supported",
            "feeFreeTafe": "Free TAFE",
            "feeSubsidised": "Subsidised"
          }
        },
        "steps": {
          "schoolPlan": "School plan",
          "courseInstitution": "Program + institution",
          "applications": "Applications",
          "study": "Study",
          "onTheJob": "On the job",
          "credentials": "Accreditation",
          "firstJob": "First job"
        }
      }
    },
    "actions": {
      "verify_phone_number": "Verify your phone",
      "cashout": "Redeem",
      "westpac_cashout": "Cash out with Westpac",
      "westpac_cashout_faq": "Westpac FAQ",
      "prize_entry": "Enter prize draw",
      "refer_a_friend": "Refer a friend",
      "saved": "Saved",
      "learn_library": "Learn library",
      "my_lessons": "My lessons",
      "account": "Account",
      "wallet": "Wallet",
      "rewards": "Rewards",
      "my_pathways": "My pathways",
      "portfolio": "Portfolio",
      "categories": {
        "rewards": "Rewards",
        "account": "Account"
      }
    },
    "seo": {
      "landing": {
        "title": "Career Advice, AI Career Coach & Learn & Earn | Anyway",
        "description": "Anyway helps students explore careers, get personalized AI career coaching, make a plan and earn rewards while figuring out what fits.",
        "ogTitle": "Explore careers, make a plan and earn rewards | Anyway",
        "ogDescription": "Anyway helps young people explore careers, get personalized AI career coaching and earn rewards while building a plan for what comes next."
      },
      "learn": {
        "title": "Learn & Earn | Explore Careers & Earn Rewards | Anyway",
        "description": "Explore careers and life skills, complete activities, earn coins and unlock rewards, experiences and campaign entries with Anyway Learn & Earn.",
        "ogTitle": "Learn & Earn with Anyway",
        "ogDescription": "Complete activities, explore future pathways, earn coins and unlock rewards, experiences and competitions with Anyway."
      },
      "about": {
        "title": "About Anyway {'|'} Helping Young People Find Their Thing",
        "description": "Learn how Anyway combines engaged learning and AI-powered 1:1 career coaching to help young people explore options, build confidence and plan life after school.",
        "ogTitle": "About Anyway: helping young people find their thing",
        "ogDescription": "See Anyway’s mission, story and impact across career learning, AI coaching and partnerships with educators, government and industry."
      },
      "partners": {
        "title": "Partners | Anyway",
        "description": "Partner with Anyway to connect your brand with the next generation of talent."
      },
      "careers": {
        "title": "Career Advice & AI Career Coach for Students | Anyway",
        "description": "Explore industries, understand your strengths and build a personal career plan with Anyway’s AI career coach.",
        "ogTitle": "Find a career that actually fits you | Anyway",
        "ogDescription": "Understand your strengths, explore industries and chat with Anyway’s AI career coach to build a career plan that fits you."
      },
      "explore": {
        "title": "Explore industries, career advice and institutions | Anyway",
        "description": "Pick a category and explore industries, career advice, and every college, university and training provider across {region}.",
        "ogTitle": "Explore what’s next for you | Anyway",
        "ogDescription": "Pick a category and explore industries, career advice, and every college, university and training provider across {region}."
      },
      "login": {
        "title": "Sign up | Anyway"
      },
      "terms": {
        "title": "Terms and Conditions | Anyway",
        "description": "Read the Anyway Terms and Conditions."
      },
      "privacyPolicy": {
        "title": "Privacy Policy | Anyway",
        "description": "Read the Anyway Privacy Policy."
      },
      "institutionGuide": {
        "hub": {
          "title": "Colleges, Universities & Training Providers in {region} | Anyway",
          "description": "Browse every college, university and training provider in {region} by name, state and institution type.",
          "ogTitle": "Find the right institution for you | Anyway",
          "ogDescription": "Every college, university and training provider in {region}, searchable by name, state and institution type."
        }
      },
      "faqSection": {
        "title": "{section} | Anyway"
      },
      "mediaCentre": {
        "title": "Anyway Media Centre {'|'} Understanding Careers, Gen Z & Work",
        "description": "Find the latest media releases and research from Anyway, the AI-powered careers platform helping young people consider all industries and find their thing."
      }
    },
    "wallet": {
      "title": "Badges",
      "tabs": {
        "badges": "Badges",
        "skills": "Skills"
      },
      "skills": {
        "title": "Skills",
        "subtitle": "{count} / {total} skills earned",
        "empty": "No skills available yet"
      },
      "sponsored": {
        "title": "Sponsored badges",
        "subtitle": "Partnered content for you",
        "empty": "No partnered content available"
      },
      "countEarned": "{count} {label}",
      "badgeList": {
        "title": "More badges you can earn",
        "subtitle": "Earned {count} / {total} badges",
        "empty": "No badges earned yet",
        "showMore": "Show more"
      },
      "detail": {
        "coinsAvailable": "Coins available",
        "associatedSkills": "Associated skills",
        "getBadge": "Get Badge",
        "continue": "Continue",
        "completed": "Completed",
        "by": "Sponsored by {name}",
        "back": "Back to wallet",
        "prize": "Prize Entry Available",
        "getBadgeLabel": "Get Badge: {name}",
        "getBadgeLabelEarned": "Get Badge: {name}, Earned"
      },
      "earned": "Earned"
    },
    "redemptionFaqs": {
      "heading": "Redeem FAQs"
    },
    "referralFaqs": {
      "heading": "Referral FAQs"
    },
    "rewardsStore": {
      "referralsHeading": "Invite friends!",
      "cashoutSection": {
        "heading": "Cashout",
        "faqsLink": "Cashout FAQs",
        "cashoutButton": "Cashout",
        "coinsStillCount": {
          "heading": "Your coins still count",
          "body": "Rewards aren’t available in this experience, but any coins you earn will stay in your balance. You may be able to use your coins in other experiences."
        },
        "viewAll": "View all",
        "dayCount": "{count} day | {count} days",
        "eligibility": {
          "heading": "Cashout eligibility",
          "coins": "{current} / {threshold} coins",
          "badge": "Eligible",
          "earnMore": "Earn {coins} more coins to cashout",
          "completeAccount": "Complete your account verification to unlock cashout",
          "ready": "You're all set! Cash out now."
        },
        "monthlyCap": {
          "heading": "Monthly cap reached",
          "usage": "{used} / {limit} this month",
          "reset": "Resets {date}: {days}"
        },
        "lifetimeCap": {
          "heading": "Lifetime cap reached",
          "body": "You've hit the {amount} lifetime cashout amount on this account"
        },
        "pending": {
          "heading": "Pending cashouts",
          "amount": "{amount} - {provider}",
          "caption": "~{amount} cash value available from {coins} coins"
        },
        "history": {
          "title": "Cash out history",
          "total": "Total cash out",
          "empty": "You haven't cashed out yet."
        },
        "status": {
          "received": "Pending",
          "underReview": "Under review",
          "appealUnderReview": "Appeal under review",
          "processing": "Processing",
          "paid": "Paid",
          "unsuccessful": "Unsuccessful",
          "unsuccessfulAppealAvailable": "Unsuccessful appeal available"
        },
        "providers": {
          "giftpay": "GiftPay",
          "westpac": "Westpac",
          "bankTransfer": "Bank transfer"
        },
        "picker": {
          "title": "Choose cashout method",
          "description": "Pick where you'd like your money to go.",
          "westpacCardLabel": "Westpac - $50 Bonus cash out"
        },
        "comingSoon": {
          "heading": "Direct cashouts",
          "highligtedSubheading": "coming soon"
        },
        "sheet": {
          "title": "Cash out",
          "description": "Choose how you'd like to cash out your rewards.",
          "redemptionDisabledNote": "Some options aren’t available right now. You’re still earning coins, and your balance remains yours.",
          "giftPay": {
            "title": "Gift Pay gift card",
            "subtitle": "Limits apply"
          },
          "faq": "Frequently Asked Questions"
        },
        "trigger": {
          "heading": "Cash out your rewards",
          "subtitle": "Send your coins to any Australian bank account, or pick a Westpac bonus or gift card."
        }
      },
      "invite": {
        "title": "Referrals",
        "headline": "Refer a friend. Earn together.",
        "howItWorks": "How it works",
        "linkLabel": "Your unique referral link",
        "copy": "Copy",
        "copied": "Copied",
        "share": "Share referral link",
        "shareTitle": "Join me on Anyway",
        "shareText": "Sign up with my link and we both get rewarded.",
        "showMore": "Show more",
        "showLess": "Show less",
        "coinsEarned": "{coins} Coins earned",
        "faqs": "Referrals FAQs",
        "referralLabel": "Referral {number}",
        "statusPending": "Pending",
        "statusQualified": "Qualified",
        "statusQualifiedCoins": "Qualified - {coins} coins earned",
        "signedUpAt": "Signed up {date}",
        "moreToGo": "{coins} more to go",
        "unlockAfter": "Unlock after {link}",
        "unlockAfterLink": "completing your account",
        "invitesUsed": "{used} of {max} invites used",
        "emailInvite": {
          "trigger": "Invite by email",
          "title": "Invite by email",
          "description": "We’ll send your friend an email with your referral link.",
          "label": "Friend’s email",
          "placeholder": "friend{'@'}email.com",
          "send": "Send invite",
          "sending": "Sending…",
          "invalidEmail": "Enter a valid email address.",
          "sentTitle": "Invite sent!",
          "sentDescription": "Your invite is on its way.",
          "sentBody": "Invite on its way to {email}, if they don’t already have an account.",
          "sendAnother": "Send another invite",
          "done": "Done",
          "error": "We couldn’t send that invite. Please try again."
        },
        "steps": {
          "share": {
            "title": "You share",
            "description": "Copy your link and send it to a friend."
          },
          "verify": {
            "title": "They verify",
            "description": "Your friend signs up and verifies their account."
          },
          "paid": {
            "title": "You both get paid",
            "descriptionCoins": "When your friend earns {coins} coins, you get {reward} coins too.",
            "descriptionCash": "When your friend earns {coins} coins, you get {reward}."
          }
        }
      },
      "referee": {
        "title": "Your referral bonus",
        "description": "Someone sent you an invite. When you earn {coins} coins you will both get paid.",
        "descriptionNamed": "{name} sent you this invite. When you earn {coins} coins you will both get paid.",
        "coinProgress": "{current} / {target} coins",
        "descriptionCoinsDone": "You’ve earned enough. Finish your account and your bonus is paid.",
        "descriptionCoinsDoneNamed": "You’ve earned enough. Finish your account and you and {name} both get paid.",
        "next": {
          "earn": "Next: Earn {coins} coins - {remaining} to go",
          "account": "Next: Complete your account"
        },
        "steps": {
          "joined": "Sign up",
          "earn": "Earn {coins} coins",
          "paid": "You both get paid"
        }
      },
      "cashout": {
        "heading": "Redeem",
        "tileLabel": "Giftpay",
        "cashOutBtn": "Cash out",
        "giftpay": "Giftpay",
        "coinBalance": "Your current coin balance",
        "completeAccount": "Don't forget! You must {link} to redeem.",
        "completeAccountLinkText": "complete your account",
        "maxCashoutsHeading": "You've maxed out!",
        "maxCashoutsDescription": "You've reached the maximum total you can redeem.",
        "maxMonthlyCashoutsHeading": "You've reached your monthly limit!",
        "maxMonthlyCashoutsDescription": "You've reached the maximum you can redeem for this month. Redeem more next month.",
        "confirmation": {
          "heading": "Congrats!",
          "subheading": "Your gift card is being processed",
          "backButton": "My rewards"
        },
        "footerText": "Processed within 10 days.",
        "amount": {
          "pageTitle": "Cash out",
          "belowMinimum": "You need at least {coins} coins to cash out. Keep earning and come back soon!"
        },
        "review": {
          "pageTitle": "Confirm cash out",
          "paidVia": "Paid via",
          "giftCard": "Gift Pay gift card",
          "arrival": "Your gift card will usually arrive within 7 days",
          "maxValue": "The maximum cash out value is {amount} — you'll receive {amount}."
        },
        "history": {
          "heading": "Redemption history",
          "total": "Total redeemed: {total}",
          "missingMoney": "Missing your money? <br> Make sure to check your spam folder.",
          "coins": "coins",
          "status": {
            "received": "Pending",
            "underReview": "Under review",
            "appealUnderReview": "Appeal under review",
            "processing": "Processing",
            "paid": "Paid",
            "unsuccessful": "Unsuccessful",
            "unsuccessfulAppealAvailable": "Unsuccessful appeal available"
          }
        },
        "continueBtn": "Continue",
        "availableToCashout": "Available to redeem",
        "cashoutTooltip": "Minimum redemption is 500 coins ($5). Rewards are usually delivered within 7 days.",
        "conversion": "{coinsPerDollar} coins = $1 of GiftPay value",
        "submitBtnLabel": "Redeem with GiftPay",
        "successText": "Coin redemption has been requested"
      },
      "giftCardsCTA": {
        "heading": "Gift Cards",
        "text": "Coming soon"
      },
      "referralPayment": {
        "heading": "Claim payment"
      },
      "prizes": {
        "earnableCoins": "{coins} coins",
        "latestCampaign": "Latest Campaigns"
      },
      "summaryStrip": {
        "cashValue": "~{amount} cash value",
        "totalEarned": "TOTAL\nEARNED",
        "friendsReferred": "FRIENDS\nREFERRED",
        "prizesEntered": "CAMPAIGNS\nENTERED"
      },
      "activeCampaign": {
        "ctaContinue": "Continue",
        "ctaStart": "Start"
      },
      "otherPrizes": {
        "heading": "Other campaigns",
        "daysLeft": "Ends in {days}d",
        "showMore": "Show more",
        "sponsorPrefix": "Sponsored by",
        "coinPrefix": "Earn",
        "stepsComplete": "{completed} / {total} steps complete",
        "allStepsComplete": "All steps complete",
        "schoolCompletionNote": "You completed this with a school account, so it is not eligible for the prize draw.",
        "earned": "{coins} earned",
        "bestAnswerWins": "Answer a quick question when you enter. Best answer wins.",
        "viewYourAnswer": "View your answer",
        "yourAnswerTitle": "Your answer",
        "state": {
          "entryConfirmed": "Your entry is confirmed 👍"
        },
        "cta": {
          "start": "Start",
          "continue": "Continue",
          "submitEntry": "Submit entry",
          "doAgain": "Do it again"
        }
      },
      "prizeSteps": {
        "title": "Finish your entry",
        "heading": "Steps to complete",
        "countRemaining": "{remaining} / {total} remaining",
        "showCompleted": "Show completed steps",
        "hideCompleted": "Hide completed steps",
        "submitEntry": "Submit entry",
        "back": "Back",
        "terms": "By clicking this button you are accepting the {link} for this prize entry",
        "termsLink": "terms & conditions",
        "account": {
          "title": "Complete your account",
          "subtitle": "To confirm your identity"
        },
        "skillQuestion": {
          "title": "Answer the skill question",
          "subtitle": "Answered when you submit your entry. Best answer wins."
        }
      }
    },
    "campaigns": {
      "termsAndConditions": {
        "heading": "Terms and Conditions"
      },
      "blockedReasons": {
        "campaignDatesNotValid": "Campaign is not valid",
        "campaignNotStarted": "Campaign has not started yet",
        "campaignEnded": "Campaign has ended",
        "completeExperienceRequired": "Complete this experience to unlock this prize draw."
      }
    },
    "schools": {
      "form": {
        "schoolName": {
          "label": "School name",
          "placeholder": "Enter school name",
          "required": "School name is required"
        },
        "firstName": {
          "label": "First name",
          "placeholder": "Enter first name",
          "required": "First name is required"
        },
        "lastName": {
          "label": "Last name",
          "placeholder": "Enter last name",
          "required": "Last name is required"
        },
        "email": {
          "label": "Email",
          "placeholder": "Enter your email",
          "required": "Email is required",
          "invalid": "Enter a valid email address"
        },
        "phoneNumber": {
          "label": "Phone number",
          "required": "Phone number is required",
          "invalid": "Enter a valid phone number"
        },
        "state": {
          "label": "State",
          "placeholder": "Select state",
          "required": "State is required"
        },
        "submit": "Submit inquiry",
        "success": "Thank you for your inquiry! We'll be in touch soon."
      },
      "thankYou": {
        "heading": "Thank you!",
        "description": "Your inquiry has been submitted. We'll be in touch soon.",
        "submitAnother": "Submit another inquiry"
      }
    },
    "content": {
      "considerationAreas": {
        "label": "Considerations",
        "none": "None",
        "placeholder": "Select a consideration"
      }
    },
    "portfolio": {
      "title": "My Portfolio",
      "tabs": {
        "overview": "Overview",
        "education": "Education",
        "workExperience": "Work experience",
        "achievements": "Achievements",
        "evidence": "Evidence"
      },
      "discard": {
        "title": "Discard unsaved changes?",
        "description": "Your edits haven’t been saved yet. If you leave now, you’ll lose them.",
        "confirm": "Discard changes",
        "cancel": "Keep editing"
      }
    },
    "errors": {
      "sendMessageFailed": "Something went wrong sending your message.",
      "contentDeclined": "We couldn’t respond to that. Try rephrasing, or ask about something else.",
      "initFailed": "Something went wrong starting the conversation.",
      "genericFailed": "Oops, something went wrong.",
      "retry": "Retry",
      "pageNotFound": "Page not found"
    },
    "considerations": {
      "level": "Level {level}",
      "levelUntilNext": "{remaining}% until level {nextLevel}",
      "score": "Career clarity",
      "keepGoingHeading": "Keep going to boost your score:",
      "personalGrowthSection": "Personal growth",
      "industriesSection": "Areas explored",
      "levelFallback": "Level 1",
      "backToChat": "Back to chat",
      "viewProfile": "View consideration score",
      "scorePillAriaLabel": "{score}%, {label}",
      "userNameFallback": "Hi there 👋",
      "scoreInfoTrigger": "What is this? »",
      "scoreInfoDialogBody": "Career Clarity is the measure of your overall progress toward making a considered career decision. The higher this score, the more thoughtfully you've explored your options, and the more equipped you are to make a plan for your future.",
      "risk": {
        "low": "Deciding",
        "medium": "Engaging",
        "high": "Exploring",
        "lowDialogBody": "You have engaged with lots of different fields to a good degree of depth. You are well equipped to make a considered career decision.",
        "mediumDialogBody": "You have engaged with a good selection of content, but there is still more to be explored. You are on your way to being prepared to make a considered career decision.",
        "highDialogBody": "You are just starting your career exploration journey. Keep exploring to get a better idea of what careers are of interest to you before making a decision."
      },
      "nav": {
        "coins": "Coins",
        "badges": "Badges",
        "saved": "Saved",
        "pathways": "Pathways"
      },
      "profile": {
        "addName": "Add your name",
        "addNameSubtext": "To personalize your experience",
        "editAriaLabel": "Edit profile"
      },
      "share": {
        "triggerAriaLabel": "Share your profile",
        "replayHeading": "Your future, on Replay",
        "replayDescription": "See the careers, strengths and possibilities that kept showing up for you, all wrapped into one shareable story.",
        "replayCta": "View your Replay",
        "replayLogoAlt": "Anyway Replay",
        "settingsCta": "Share settings",
        "copy": "Copy",
        "copied": "Copied!",
        "createFailed": "Something went wrong creating your share link.",
        "preview": "Preview",
        "previewHint": "Your link will capture a snapshot of your plan as it is right now. Later changes won’t update it.",
        "shareCta": "Generate share link",
        "settings": {
          "pageTitle": "Share settings",
          "heading": "Share settings",
          "closeAriaLabel": "Close share settings",
          "activeHeading": "Current active link",
          "activeDescription": "Anyone with this link can view your Career Development Plan, career clarity score and assessment results until {date}.",
          "linkName": "Anyway Replay",
          "createdLabel": "Created",
          "expiresLabel": "Expires",
          "expiredLabel": "Expired",
          "expiresInDays": "(in {count} day) | (in {count} days)",
          "daysSinceEnded": "({count} day) | ({count} days)",
          "stopSharingHeading": "Need to stop sharing?",
          "stopSharingDescription": "Generating a new link immediately disables your current link. You can also revoke it without creating a new one.",
          "generateNew": "Generate a new link",
          "revoke": "Revoke link",
          "revokeConfirmTitle": "Revoke this link?",
          "revokeConfirmMessage": "Anyone using this link will immediately lose access. This can’t be undone.",
          "revokeConfirmButton": "Revoke link",
          "revokeConfirmCancel": "Cancel",
          "previousLinks": "Previous links ({count})"
        },
        "status": {
          "active": "Active",
          "expired": "Expired",
          "revoked": "Revoked"
        }
      },
      "showMore": "Show more",
      "showLess": "Show less",
      "selfDiscovery": {
        "title": "Self discovery",
        "minutes": "{count} Minute | {count} Minutes",
        "viewResults": "View results",
        "retake": "Retake"
      }
    },
    "saved": {
      "institutions": "Institutions",
      "jobs": "Jobs",
      "empty": {
        "title": "Nothing saved yet",
        "description": "Tap the heart on jobs and institutions to save them here."
      },
      "saveJobAriaLabel": "Save {jobTitle}",
      "unsaveJobAriaLabel": "Remove {jobTitle} from saved",
      "unsaveInstitutionAriaLabel": "Remove {institutionTitle} from saved"
    },
    "avatar": {
      "heading": "Choose your avatar",
      "selectCta": "Confirm avatar",
      "savedMessage": "Avatar updated",
      "changeAriaLabel": "Change avatar",
      "counter": "{current} / {total}",
      "previousAvatar": "Previous avatar",
      "nextAvatar": "Next avatar"
    },
    "signUpCta": {
      "article": {
        "title": "A convo a day keeps career fog at bay. Ask me anything!",
        "button": "Chat with Blinky"
      },
      "video": {
        "title": "You can’t be what you don’t see. Now you’ve seen, lets chat being!",
        "button": "Speak to Blinky"
      },
      "hub": {
        "title": "I’m cooking up virtual career experiences for you as we speak…",
        "button": "Go see Blinky"
      },
      "industry": {
        "title": "I’m cooking up virtual career experiences for you as we speak…",
        "button": "Go see Blinky"
      },
      "job": {
        "title": "My job is making sure your job is the right job.",
        "button": "Get Blinky’s guidance"
      },
      "institution": {
        "title": "I studied dad jokes at uni. Now I’m a master of sighcology.",
        "button": "Find your pathway"
      },
      "course": {
        "title": "Let’s test-drive the jobs this course may lead to before you apply!",
        "button": "Visit Blinky"
      }
    },
    "articles": {
      "badge": "Article",
      "badges": {
        "careerPathwayMap": "Pathway map",
        "stepByStepGuide": "Step-by-step guide",
        "rankedCards": "Ranked list",
        "salaryGuide": "Salary guide",
        "comparisonGuide": "Comparison guide",
        "practitionerStories": "Stories",
        "dayInTheLife": "Day in the life",
        "quizLanding": "Career quiz",
        "explainer": "Outlook",
        "editorialEssay": "Article"
      },
      "byAuthor": "By {name}",
      "inThisGuide": "In this guide",
      "keepReading": "Keep reading",
      "lastUpdated": "Last updated {date}",
      "minRead": "{count} min read",
      "readArticleNamed": "Read article {title}",
      "pathway": {
        "inThisArticle": "In this article",
        "mostCommon": "Most common",
        "pros": "Pros",
        "cons": "Cons",
        "roleColumn": "Role",
        "timeToFirstRole": "Time to first role",
        "salaryAu": "Starting salary (AU)",
        "salaryUs": "Starting salary (US)",
        "faqsHeading": "Frequently Asked Questions"
      },
      "ranked": {
        "jumpToRole": "Jump to role",
        "jumpToSkill": "Jump to skill",
        "jumpToCompany": "Jump to company",
        "averageSalary": "Average salary",
        "salaryAu": "AU",
        "salaryUs": "US",
        "demandOutlook": "Demand outlook",
        "companiesDisclaimer": "Company details are based on publicly available information and may change. They were accurate at the time of publishing.",
        "faqsHeading": "Frequently Asked Questions"
      },
      "salaryGuide": {
        "inThisArticle": "In this article",
        "entryRoleColumn": "Entry role",
        "levelColumn": "Level",
        "australia": "Australia",
        "unitedStates": "United States",
        "levelEntry": "Entry • 0–2 yrs",
        "levelMid": "Mid • 3–6 yrs",
        "levelSenior": "Senior • 7+ yrs",
        "bridgeButton": "Explore modules",
        "faqsHeading": "Frequently Asked Questions"
      },
      "comparison": {
        "inThisArticle": "In this article",
        "whatItIs": "What it is",
        "whoSuitsIt": "Who suits it",
        "inAustralia": "In Australia",
        "inTheUs": "In the US",
        "realTalk": "The real talk",
        "bestFor": "Best for:",
        "filterLabel": "Filter costs by region",
        "filterAustralia": "Australia",
        "filterUnitedStates": "United States",
        "filterShowBoth": "Show both",
        "comparingHeading": "Comparing the options",
        "optionColumn": "Option",
        "durationColumn": "Duration",
        "costAuColumn": "Cost (AU)",
        "costUsColumn": "Cost (US)",
        "faqsHeading": "Frequently Asked Questions"
      },
      "stories": {
        "jumpToStory": "Jump to a story",
        "bylineNameAge": "{name}, {age}",
        "bylineWithRole": "{lead} — {role}",
        "youngerSelfLabel": "What they’d tell their younger self",
        "compositeDisclaimer": "The people in this article are composite profiles, built from real interviews, published career stories and industry research. Names and details have been changed."
      },
      "dayInTheLife": {
        "inThisArticle": "In this article",
        "faqsHeading": "Frequently Asked Questions"
      },
      "quiz": {
        "inThisArticle": "In this article",
        "start": "Start",
        "whatYouWillLearn": "What you will learn",
        "mapsTo": "Maps to"
      },
      "explainer": {
        "inThisArticle": "In this article",
        "outlookGrowing": "Growing",
        "outlookEvolving": "Evolving",
        "groupGrowing": "Growing fast",
        "groupEvolving": "Evolving, not disappearing",
        "faqsHeading": "Frequently Asked Questions"
      }
    },
    "hubs": {
      "atAGlance": "At a glance",
      "atAGlanceSources": "Source: {sources} | Sources: {sources}",
      "why": "Why {title}?",
      "industryOutlook": "Industry outlook",
      "entryRequirements": "Entry requirements",
      "expo": {
        "liveNow": "Live now",
        "title": "Career Expos",
        "regionLabel": "Career expo",
        "eyebrow": "Career expo · {title} hub",
        "exploreHub": "Explore the {title} hub"
      },
      "learnMore": {
        "title": "Learn more about {title}",
        "subtitle": "Explore our unique {title} experiences and earn money!"
      },
      "topJobs": {
        "title": "Top {title} jobs",
        "rowAriaLabel": "Top {title} jobs"
      },
      "whereToStudy": {
        "title": "Where to study {title}",
        "rowAriaLabel": "Where to study {title}"
      },
      "videos": {
        "title": "Videos",
        "rowAriaLabel": "Videos",
        "play": "Watch {title}",
        "playSponsored": "Watch {title}, sponsored by {sponsor}"
      },
      "articles": {
        "title": "Articles",
        "rowAriaLabel": "Articles",
        "read": "Read {title}",
        "readByPartner": "Read {title}, by {partner}"
      },
      "heroImageAlt": "{title} in action",
      "backedBy": "Backed by"
    },
    "videos": {
      "sponsoredBy": "This video is proudly sponsored by:",
      "share": "Share",
      "linkCopied": "Link copied",
      "showMore": "Show more",
      "showLess": "Show less",
      "speakers": "Speakers",
      "minuteWatch": "{count} minute watch | {count} minute watch"
    },
    "storyAsset": {
      "finish": "Finish",
      "continue": "Continue",
      "tryAgain": "Try Again",
      "begin": "Begin",
      "savedJob": "We’ve saved this job for you",
      "scrollCard": {
        "prompt": "Scroll to the end to continue"
      },
      "startLearningOutcomes": {
        "lead": "By the end you’ll be able to"
      },
      "feedback": {
        "greatJob": "Great job!",
        "notQuite": "Not quite!",
        "keepGoing": "Keep going!",
        "great": "Great!",
        "niceOne": "Nice one!",
        "letsGo": "Let's go!",
        "nailedIt": "Nailed It!"
      }
    },
    "feedbackSurvey": {
      "lesson": {
        "connectToCareers": "I can connect what I’m learning in class to real world careers",
        "discoveredPathway": "I discovered or considered a career pathway I had not thought about before",
        "futureMotivation": "I’m more motivated to think about my future",
        "futureConfidence": "I feel more confident planning my next steps after high school",
        "coachValue": "The AI Coach helped me think more deeply about my interests, strengths, or future options",
        "subjectEngagement": "I am more motivated to engage in this class",
        "overallExperience": "How would you rate your overall experience on Anyway?",
        "experience": {
          "excellent": "Excellent",
          "good": "Good",
          "poor": "Poor",
          "veryPoor": "Very poor"
        },
        "learnedAboutSelf": "What is one thing you learned about yourself, your future, or a possible career?",
        "useAgain": "How likely are you to use Anyway again?",
        "recommend": "How likely are you to recommend Anyway to a friend?",
        "anythingElse": "Please add anything else you’d like to say about your experience using Anyway"
      }
    },
    "institutionGuide": {
      "noun": {
        "plural": "institutions",
        "pluralCapitalised": "Institutions"
      },
      "common": {
        "retry": "Try again"
      },
      "hub": {
        "title": "Institutions",
        "pitch": "Every college, university and training provider across {region}, in one place.",
        "backToExplore": "Back to explore",
        "searchLabel": "Search {nounPlural}",
        "searchPlaceholder": "Search {nounPlural} by name",
        "searchClear": "Clear search",
        "allInstitutions": "All {nounPlural}",
        "resultsHeading": "{nounPluralCapitalised}",
        "resultsRange": "Showing {from}–{to} of {total}",
        "empty": "No {nounPlural} match",
        "emptyDescription": "Try another keyword or clear the filters.",
        "clearFilters": "Clear filters",
        "loadError": "We could not load the {nounPlural} right now."
      },
      "filters": {
        "state": "State",
        "sector": "Institution type",
        "option": "{name} ({count})"
      },
      "institutionType": {
        "university": "University",
        "tafe": "TAFE",
        "higherEducationProvider": "Higher education provider",
        "registeredTrainingOrganisation": "Registered training organisation",
        "communityCollege": "Community College"
      },
      "card": {
        "location": "{city}, {state}",
        "campuses": "{count} campus | {count} campuses"
      }
    },
    "course": {
      "notFound": "We couldn’t find that course.",
      "seo": {
        "title": "{course} at {institution} | Anyway",
        "description": "Entry, length, fees and the careers {course} at {institution} can lead to."
      },
      "nav": {
        "overview": "Overview",
        "elsewhere": "Also offered at",
        "institution": "The institution"
      },
      "glance": {
        "title": "At a glance",
        "qualification": "Qualification",
        "duration": "Duration",
        "durationRange": "{min} to {max}",
        "entry": "Entry",
        "fees": "Fees"
      },
      "offeredElsewhere": {
        "title": "Also offered at",
        "rowLabel": "{name} at other institutions"
      },
      "attribution": "{description} Source: {source}"
    },
    "faq": {
      "sections": {
        "general": "General FAQs",
        "referral": "Referral FAQs",
        "cashout": "Cashout FAQs",
        "westpac50100": "Westpac 50–100 FAQs",
        "schoolsLanding": "Schools teachers landing FAQs",
        "schoolsLeadersLanding": "Schools leaders landing FAQs",
        "schoolsAdvisorsLanding": "Schools advisors landing FAQs",
        "campaign": "Campaign FAQs"
      },
      "empty": "There are no questions in this section yet.",
      "publicPageToggle": "Enable standalone public page",
      "publicPageHint": "Published at {url}",
      "publicPageHidden": "Standalone page is hidden",
      "publicPageAlwaysOn": "The General section’s standalone page is always on",
      "shownOn": "Shown on: {surfaces}",
      "surfaces": {
        "general": "the Learn landing page FAQ block, the campaign landing page when the active campaign has no FAQs of its own (first 5), and the standalone public page",
        "cashout": "the Rewards page cashout tab and the cashout FAQ modal, plus the standalone public page when enabled",
        "referral": "the Rewards page referrals tab, plus the standalone public page when enabled",
        "westpac50100": "the Rewards page Westpac tab and the Westpac cashout modal (deal ended), plus the standalone public page when enabled",
        "schoolsLanding": "the schools teachers landing page, plus the standalone public page when enabled",
        "schoolsLeadersLanding": "the schools leaders landing page, plus the standalone public page when enabled",
        "schoolsAdvisorsLanding": "the schools advisors landing page, plus the standalone public page when enabled",
        "campaign": "campaign pages only, edited in the campaign editor"
      }
    },
    "mediaCentre": {
      "title": "Media Centre",
      "subtitle": "Find the latest news from Anyway",
      "moreArticles": "More news from Anyway",
      "contactTitle": "Need to get in touch?",
      "contactLine": "Contact us at {email}",
      "contactEmail": "media{'@'}anyway.ai",
      "empty": "No media releases yet. Check back soon.",
      "error": "We couldn’t load the latest news. Try again soon."
    }
  },
  "bankTransfer": {
    "cashout": {
      "optionLimit": "{amount} limit · {days} day delay",
      "bankAccountRow": {
        "title": "Bank account",
        "subtitle": "Transfer directly to your bank account"
      },
      "direct": {
        "detailsHeading": "Bank account",
        "notStoredNotice": "We don't store your BSB or account number after your payment has been processed, so you'll need to enter them each time you cash out.",
        "bsbLabel": "BSB",
        "bsbPlaceholder": "123-456",
        "accountNumberLabel": "Account number",
        "accountNumberPlaceholder": "123456789",
        "accountHolderNameLabel": "Name on your bank account",
        "accountHolderNamePlaceholder": "Jane Smith",
        "accountHolderNameHint": "The account holder’s name, as your bank shows it. Not the account’s nickname, like “Westpac Saver”.",
        "bsbBranchWithBank": "{bank} · {branch}, {suburb} {state}",
        "bsbBranch": "{branch}, {suburb} {state}",
        "unusualAccountNumberLength": "Most {bank} account numbers are {lengths} digits. You entered {length}. Check it before you continue.",
        "unusualAccountNumberLengthUnnamedBank": "Most account numbers at this bank are {lengths} digits. You entered {length}. Check it before you continue.",
        "confirmAccountNumber": "Yes, this is correct"
      },
      "form": {
        "submit": "Cash out",
        "continue": "Continue"
      },
      "faqPrompt": "Have any questions?",
      "faqLink": "Check the FAQs",
      "review": {
        "pageTitle": "Confirm cash out",
        "paidVia": "Paid via",
        "bankAccount": "Bank account",
        "arrival": "Please allow at least 7 days for your payment to arrive"
      },
      "confirmation": {
        "heading": "Congrats!",
        "subheading": "Your payment is being processed",
        "backButton": "My rewards"
      },
      "errorState": {
        "title": "Something went wrong",
        "body": "We couldn't load your cash out. Please check your connection and try again.",
        "tryAgain": "Try again"
      },
      "errors": {
        "generic": "Something went wrong. Please try again.",
        "bsbInvalid": "Enter a valid 6-digit BSB.",
        "bsbNotFound": "We can’t find this BSB. Check it against your bank app or a bank statement.",
        "bsbNotElectronic": "This BSB can’t receive bank transfers. Use the BSB for your everyday account.",
        "accountNumberInvalid": "Enter a 6 to 9 digit account number using numbers only.",
        "accountNumberIncludesBsb": "This looks like your BSB and account number together. Enter just the account number, without the BSB.",
        "accountNumberLooksLikeCard": "This looks like a card number. Enter the account number from your bank app or statement, not the number on your card.",
        "accountNameInvalid": "Enter the name on your bank account in 32 characters or fewer, using only letters, numbers, spaces, hyphens, apostrophes and full stops.",
        "accountNameNickname": "That looks like your account’s nickname. Enter the name of the person who holds the account, for example Jane Smith.",
        "bankAccountAlreadyUsed": "These bank account details can't be used. Please check them, or try a different account.",
        "rateLimited": "You've made too many cashout attempts. Please try again in about {minutes} min.",
        "profileIncomplete": "Complete your profile before you cash out."
      },
      "status": {
        "pending": {
          "heading": "Your cashout is being reviewed",
          "body": "We've got your request. Our team is reviewing it and we'll let you know as soon as it's been approved."
        },
        "approved": {
          "heading": "Cashout approved",
          "body": "Your cashout has been approved and is on its way to your bank account."
        },
        "processed": {
          "heading": "Cashout complete",
          "body": "We've sent your cashout to your nominated bank account."
        },
        "onHold": {
          "heading": "Cashout on hold",
          "body": "Your cashout is currently on hold. We'll be in touch shortly."
        },
        "rejected": {
          "heading": "Cashout declined",
          "body": "Your cashout request was declined. Please contact support if you have questions."
        }
      },
      "blocked": {
        "insufficientCoins": {
          "body": "You need at least {coins} coins to cash out. Keep earning to unlock it!"
        },
        "phoneNotVerified": {
          "body": "Verify your phone number so we can keep your account secure before you cash out."
        },
        "lifetimeLimitExceeded": {
          "body": "You have reached the maximum amount you can cash out across all rewards."
        },
        "monthlyLimitExceeded": {
          "body": "You can request another cashout next month."
        }
      }
    }
  },
  "westpac": {
    "cashout": {
      "heading": "$50 Bonus cash out",
      "tileLabel": "Bonus cash out",
      "tileSubtitle": "Cash out to your Westpac account",
      "faq": {
        "heading": "Anyway x Westpac Promotions FAQ"
      },
      "banner": {
        "heading": "Cashout of up to $100!",
        "partner": "In partnership with Westpac",
        "subtitle": "$50 Anyway reward + an additional $50 Westpac ‘Double You’ bonus*",
        "disclaimer": "*new customer bonus, subject to eligibility and terms"
      },
      "offer": {
        "newCustomer": {
          "title": "Westpac",
          "subtitle": "Receive up to $50 bonus.",
          "bonusNote": "Plus a $50 bonus for new Westpac customers",
          "amount": "$100"
        }
      },
      "rewardsOffer": {
        "heading": "Get up to $100 with Anyway × Westpac",
        "subheading": "Cash out 500 Coins to get up to $100",
        "summary": {
          "anyway": {
            "title": "$50 Reward",
            "content": "From earning 500 coins on Anyway"
          },
          "westpac": {
            "title": "Up to $50",
            "content": "Optional Westpac ‘Double You’ new customer bonus",
            "terms": "Subject to eligibility and terms"
          }
        },
        "newCustomer": {
          "title": "New to Westpac?",
          "content": "Open an eligible account and unlock an extra $50 cashback.",
          "isOver18": {
            "title": "18 or over",
            "content": "Open a Westpac Choice account, make an eligible savings deposit, then spend $50 within 15 days to receive $50 cashback. T&Cs and eligibility criteria apply."
          },
          "isUnder18": {
            "title": "Under 18",
            "content": "Open a Westpac Choice account and make an eligible $50 savings deposit within 10 days to receive $50 cashback. T&Cs and eligibility criteria apply."
          }
        },
        "existingCustomer": {
          "title": "Already bank with Westpac",
          "content": "Cashout 500 coins and get $50 paid into your eligible Westpac account.",
          "receive": {
            "title": "You’ll receive $50 from Anyway",
            "content": "Paid directly into your eligible Westpac account"
          }
        },
        "faq": "How does the Westpac rewards work?",
        "backToOptions": "Back to cash-out options"
      },
      "promo": {
        "bonusTag": "$50 Bonus",
        "heading": "Best value cash out thanks to our partner Westpac",
        "highlight": "Turn 500 Coins into $50 💸",
        "subHighlight": "Yep… that's 10x value",
        "disclaimer": "Rewards are paid into an eligible Westpac account. Available once per user. Eligibility applies. Age 14+.",
        "noAccountLink": "Don't have a Westpac account?"
      },
      "howItWorks": {
        "heading": "How it works",
        "earnStep": "Earn 500 coins",
        "rewardStep": "$50 Anyway reward bonus"
      },
      "summary": {
        "heading": "Available to cash out",
        "bonusTag": "10x Bonus",
        "originalValue": "$5",
        "bonusValue": "$50",
        "unavailableValue": "$0",
        "conversionRate": "{coins} coins = $1",
        "currentCoinValueLabel": "Your Current Coin value",
        "accountDetailsHeading": "Your Westpac Account Details"
      },
      "form": {
        "bsbLabel": "BSB",
        "bsbPlaceholder": "000-000",
        "accountNumberLabel": "Account number",
        "submit": "Cash out",
        "tncLabel": "I am 14yo+ and have read the {link}",
        "tncLinkText": "terms and conditions",
        "continue": "Continue",
        "pageTitle": "Bank Account"
      },
      "confirmation": {
        "heading": "Congrats!",
        "subheading": "Your payment is being processed",
        "backButton": "Continue"
      },
      "errors": {
        "generic": "Something went wrong. Please try again.",
        "bsbNotWestpac": "This BSB isn't a Westpac BSB. Please enter a Westpac account BSB.",
        "accountNumberInvalid": "Enter a 6-digit account number using numbers only.",
        "rateLimited": "You've made too many cashout attempts. Please try again in about {minutes} min.",
        "profileIncomplete": "Complete your profile before you cash out."
      },
      "status": {
        "pending": {
          "heading": "Your cashout is being reviewed",
          "body": "We've got your request. Our team is reviewing it and we'll let you know as soon as it's been approved."
        },
        "approved": {
          "heading": "Cashout approved",
          "body": "Your cashout has been approved and is on its way to your bank account."
        },
        "processed": {
          "heading": "Cashout complete",
          "body": "We've sent your cashout to your nominated bank account."
        },
        "onHold": {
          "heading": "Cashout on hold",
          "body": "Your cashout is currently on hold. We'll be in touch shortly."
        },
        "rejected": {
          "heading": "Cashout declined",
          "body": "Your cashout request was declined. Please contact support if you have questions."
        }
      },
      "blocked": {
        "insufficientCoins": {
          "heading": "You don't have enough coins yet",
          "body": "You need at least 500 coins to cash out with Westpac. Keep earning to unlock it!"
        },
        "phoneNotVerified": {
          "heading": "Verify your phone number first",
          "body": "Verify your phone number so we can keep your account secure before you cash out."
        },
        "lifetimeLimitExceeded": {
          "heading": "You've reached your lifetime cashout limit",
          "body": "You have reached the maximum amount you can cash out across all rewards."
        },
        "monthlyLimitExceeded": {
          "heading": "You've reached this month's cashout limit",
          "body": "You can request another cashout next month."
        },
        "budgetExhausted": {
          "heading": "Westpac cashouts are paused",
          "body": "The Westpac cashout program has reached its total budget for this period."
        }
      },
      "review": {
        "pageTitle": "Confirm cash out",
        "paidVia": "Paid via",
        "account": "Westpac account",
        "arrival": "Please allow at least 7 days for your payment to arrive"
      }
    },
    "partnerLanding": {
      "seo": {
        "50": {
          "title": "Learn. Earn. Cash out up to $50 — Anyway x Westpac",
          "description": "Earn up to $50 by completing real-life skill learnings on Anyway. Cash out into an eligible Westpac account.",
          "ogTitle": "Learn. Earn. Cash out up to $50 with Anyway and Westpac",
          "ogDescription": "Earn up to $50 by completing real-life skill learnings on Anyway. Subject to eligibility and terms."
        },
        "100": {
          "title": "Learn. Earn. Cash out up to $100 — Anyway x Westpac",
          "description": "Earn up to $100 in rewards across Anyway and Westpac. Complete learning content for an Anyway reward of up to $50, plus an optional Westpac Double You bonus.",
          "ogTitle": "Learn. Earn. Cash out up to $100 with Anyway and Westpac",
          "ogDescription": "Earn up to $100 in rewards across Anyway and Westpac. Subject to eligibility and terms."
        }
      },
      "hero": {
        "titleLine1": "Learn. Earn.",
        "titleLine2": "Cash out up to {amount}",
        "partnershipLabel": "In partnership with Westpac",
        "cashAlt": "Cash bills illustration",
        "westpacLogoAlt": "Westpac logo",
        "titleLine2_50": "Cash out up to {amount}"
      },
      "earnUpTo": {
        "headline": "Earn up to $50 by completing real-life skill learnings on Anyway.",
        "subheadHtml": "Anyway <strong>pays you</strong> to figure out your future - <strong>score up to $50 now!</strong>"
      },
      "offerIncludes": {
        "title": "This offer includes:",
        "bodyHtml": "An <strong>Anyway reward of up to $50</strong> for completing learning content, and <strong>An optional $50 Westpac</strong> ‘Double You’ new <strong>customer bonus</strong>, subject to eligibility and terms."
      },
      "howItWorks": {
        "title": "How it works",
        "steps": {
          "earnCoins": {
            "label": "Earn 500 coins"
          },
          "anywayBonus": {
            "label": "$50 Anyway reward bonus",
            "sub": "(Paid into an eligible Westpac account)"
          },
          "westpacBonus": {
            "label": "$50 Westpac ‘Double You’ new customer bonus",
            "sub": "(for eligible new customers only, Ts&Cs apply. Paid into an eligible Westpac account)"
          },
          "total": {
            "label": "$100 cash!",
            "sub": "(into your Westpac Account)"
          },
          "total50": {
            "label": "$50 cash!",
            "sub": "(Paid into an eligible Westpac account)"
          }
        },
        "iconAlts": {
          "coin": "Gold coin",
          "cash": "Cash bills",
          "cashBill": "Banknote"
        }
      },
      "learnEarnBanner": {
        "leftLabel": "LEARN",
        "rightLabel": "& EARN",
        "anywayAlt": "Anyway",
        "westpacAlt": "Westpac"
      },
      "explore": {
        "title": "Anyway pays you to explore your future.",
        "highlight": "$50 Anyway Reward Bonus"
      },
      "cards": {
        "learn": {
          "step": "Step 1",
          "title": "Learn",
          "body": "Complete short learning stories on Anyway.",
          "imageAlt": "Graduation cap"
        },
        "earnCoins": {
          "step": "Step 2",
          "title": "Earn coins",
          "body": "Each lesson earns Anyway coins. Reach 500 coins to unlock your reward.",
          "imageAlt": "Gold coin"
        },
        "openAccount": {
          "step": "Step 3",
          "title": "Open account",
          "body": "To cash out your reward, you’ll need an eligible Westpac account. If you don’t have one, you can choose to {openAccountLink}.",
          "openAccountLinkText": "open one online",
          "imageAlt": "Wallet with Westpac card"
        },
        "cashOut": {
          "step": "Step 4",
          "title": "Cash out",
          "body": "Redeem your $50 Anyway reward into your Westpac account",
          "imageAlt": "Cash bills"
        },
        "doubleYour": {
          "step": "Step 5",
          "title": "Double your $50 with Westpac",
          "body": "(You may be eligible to receive an additional $50 Westpac ‘Double You’ bonus)",
          "imageAlt": "Stack of cash with Westpac logo"
        }
      },
      "westpacSteps": {
        "promoAlt": "Double your $50",
        "validity": "Valid from 8 June – 30 September 2026",
        "itTakesALittle": "IT TAKES A LITTLE",
        "title": "To receive the Westpac Double You bonus:",
        "step1": {
          "imageAlt": "Westpac Choice account illustration",
          "body": "Open a Westpac Choice everyday account and an eligible savings account"
        },
        "step2": {
          "imageAlt": "Under 18 deposit illustration",
          "body": "If you are under 18; deposit at least $50 into your Choice account within 10 days"
        },
        "step3": {
          "imageAlt": "18 or over spend illustration",
          "body": "If you are 18 or over; spend $50 from your Choice account within 15 days"
        },
        "step4": {
          "imageAlt": "Westpac piggy bank",
          "body": "Westpac will deposit a $50 bonus into your savings account"
        }
      },
      "cta": {
        "title": "You may be eligible to receive up to $100 in rewards across Anyway and Westpac, subject to eligibility and terms",
        "cashAlt": "Cash bills illustration",
        "button": "Start learning",
        "title50": "Your first $50 reward could be just a few lessons away."
      },
      "footnote": {
        "newCustomers": "New customers only.",
        "termsLink": "Westpac terms and conditions",
        "terms": "{termsLink} apply.",
        "termsLinkShort": "Terms & conditions",
        "faqPrompt": "Got any question? {faqLink}",
        "faqLink": "Read our FAQs"
      },
      "terms": {
        "modal100": {
          "title": "The Fine Print\nAnyway x Westpac $100 Offer",
          "anywayBonus": {
            "heading": "Anyway $50 Reward Bonus",
            "items": [
              "Limited time offer.",
              "One redemption.",
              "Maximum reward value: $50.",
              "Members must redeem 500 Anyway Coins ($5 value) to receive the $50 Anyway bonus reward.",
              "Offer end 30 September 2026, or when a total $100,000 of Reward Bonus payments are made, whatever comes first.",
              "The promotion is provided and funded by Anyway, not Westpac.",
              "The reward will be paid into an eligible Westpac account.",
              "Available to Australian residents aged between 14 and 24.",
              "Reward processing may take up to 7 business days.",
              "Eligibility and redemption requirements are determined by Anyway.",
              "Anyway reserves the right to modify, suspend or withdraw the promotion at any time.",
              "Anyway Australia is operated by Year13 Pty Ltd (ABN 93 606 583 706)."
            ]
          },
          "under18": {
            "heading": "Under 18s",
            "promoTitle": "The $50 'Double U' Cashback Promotion Terms and Conditions",
            "runDates": "This promotion runs from 1 February 2026 to 30 September 2026.",
            "eligibleIntro": "To be eligible you must:",
            "eligibleItems": [
              "Be a new customer, under 18 years old and have not held any transaction or savings accounts with Westpac in the last 2 years from the date the last transaction or savings account closure.",
              "Open a new Westpac Choice account AND, a Westpac Bump OR eSaver. Accounts must be in the same name, activated and ready to use.",
              "Deposit a total of at least $50 into your Westpac Choice account within 10 calendar days of the first account being opened. Deposit(s) must be processed (not pending) by the end of the 10th day.",
              "Deposit must be customer-initiated and does not include interest payments into the account or internal transfers between your Westpac accounts.",
              "Keep the account open for a minimum of 60 days after you meet all other eligibility criteria.",
              "Hold the accounts in one name only. These accounts cannot be in joint names."
            ],
            "outcomeIntro": "If you meet the above:",
            "outcomeItems": [
              "You're eligible for a one-time $50 payment.",
              "The $50 payment will be made to your Westpac Bump OR eSaver within 60 days of you meeting all Terms and Conditions and eligibility criteria.",
              "If you open more than one Westpac Bump OR eSaver, the $50 payment will only be made once into the first savings account opened and activated."
            ],
            "closing": "This promotion may be varied or withdrawn at any time. It is not available in conjunction with any other offer unless otherwise stated."
          },
          "over18": {
            "heading": "Over 18s",
            "promoTitle": "The $50 'Double U' Cashback Promotion Terms and Conditions",
            "runDates": "This promotion runs from 9 June 2026 to 30 September 2026.",
            "eligibleIntro": "To be eligible you must:",
            "eligibleItems": [
              "Be a new customer, 18+ and have not held any transaction account or savings accounts with Westpac in the last 2 years from the date the last transaction or savings account closure.",
              "Open a new Westpac Choice account AND, either a Westpac Life OR Westpac eSaver. Accounts must be in the same name, activated and ready to use.",
              "Make eligible purchases totalling at least $50 using the debit card linked to your Westpac Choice account within 15 calendar days of the first account being opened. Transaction(s) must be processed (not pending) by the end of the 15th day.",
              "Transaction(s) must be customer-initiated and does not include interest payments, direct debits or internal transfers between your Westpac accounts.",
              "Keep the account open for a minimum of 60 days after you meet all other eligibility criteria.",
              "Hold the accounts in one name only. These accounts cannot be joint accounts."
            ],
            "outcomeIntro": "If you meet the above:",
            "outcomeItems": [
              "You're eligible for a one-time $50 payment.",
              "The $50 payment will be made to your Westpac Life or Westpac eSaver account within 60 days of you meeting all Terms and Conditions and eligibility criteria.",
              "If you open more than one Westpac Life or Westpac eSaver, the $50 payment will only be made once into the first savings account opened and activated."
            ],
            "closing": "This promotion may be varied or withdrawn at any time. It is not available in conjunction with any other offer unless otherwise stated."
          },
          "important": {
            "heading": "Important",
            "items": [
              "The Anyway $50 Bonus and Westpac $50 Cashback are independent promotions.",
              "Customers must satisfy the eligibility criteria for each promotion separately to receive the full $100 value.",
              "Availability of either promotion may change or end without notice.",
              "The $50 Westpac Reward is only payable into a valid Westpac account held in the eligible Anyway member's name. Payments will not be made to third-party accounts, and Anyway reserves the right to verify account ownership and member eligibility prior to payment."
            ]
          }
        },
        "modal50": {
          "title": "The Fine Print",
          "anywayBonus": {
            "heading": "Anyway $50 Bonus Offer",
            "items": [
              "Limited time offer.",
              "One time only redemption.",
              "Maximum reward value: $50.",
              "Members must redeem 500 Anyway Coins ($5 value) to receive the $50 Anyway bonus reward.",
              "The promotion is provided and funded by Anyway, not Westpac.",
              "Offer end 30 September 2026, or when a total $100,000 of Reward Bonus payments are made, whatever comes first.",
              "The reward will be paid into an eligible Westpac account.",
              "Available to Australian residents aged between 14 and 24.",
              "Reward processing may take up to 7 business days.",
              "Eligibility and redemption requirements are determined by Anyway.",
              "Anyway reserves the right to modify, suspend or withdraw the promotion at any time.",
              "The $50 Westpac Reward is only payable into a valid Westpac account held in the eligible Anyway member's name. Payments will not be made to third-party accounts, and Anyway reserves the right to verify account ownership and member eligibility prior to payment.",
              "Anyway Australia is operated by Year13 Pty Ltd (ABN 93 606 583 706)."
            ]
          }
        },
        "logoAnywayAlt": "Anyway",
        "logoWestpacAlt": "Westpac"
      }
    }
  },
  "cashout": {
    "voiceVerification": {
      "pageTitle": "Verification",
      "title": "Verify it’s you",
      "description": "For your security, we need to check it’s really you before you cash out. Tap below and we’ll call your phone with a verification code.",
      "duration": "Takes about 30 seconds",
      "why": {
        "heading": "Why we do this",
        "intro": "Phone verification helps keep rewards safe, fair, and available for real students.",
        "safe": {
          "title": "Keeps your bonus safe",
          "body": "Stops someone else from cashing out using your account."
        },
        "fraud": {
          "title": "Stops fraud before cash leaves",
          "body": "Fraud means claiming money you didn’t earn, using fake accounts, or using someone else’s details."
        },
        "students": {
          "title": "More money goes to students",
          "body": "Detecting fake claims protects the rewards pool for learners who earned it."
        }
      },
      "steps": {
        "heading": "What happens next",
        "one": "Tap Call me",
        "two": "Answer the automated call",
        "three": "Enter the code to continue"
      },
      "footer": "We only use this to verify this cash out. No cost from Anyway.",
      "called": "We’ve called your phone. Enter the 6-digit code below to continue.",
      "callButton": "Call me",
      "calling": "Calling…",
      "codeLabel": "Verification",
      "codePlaceholder": "Enter the code",
      "verifyButton": "Verify",
      "verifying": "Verifying…",
      "completing": "Completing your cash-out…",
      "resendPrompt": "Didn’t get a call?",
      "resend": "Resend",
      "resendIn": "Resend in {seconds}s",
      "resendLimitReached": "You’ve used all your call attempts. Start the cash-out again if you still need a code.",
      "errors": {
        "start": "We couldn’t place the call. Please try again.",
        "verify": "That code wasn’t right. Request a new call and try again.",
        "expired": "That verification has expired. Request a new call to get a fresh code.",
        "unavailable": "We couldn’t check your code right now. Wait a moment and try again.",
        "rateLimited": "Too many call attempts. You can request another call in {seconds}s."
      }
    },
    "amount": {
      "coinBalanceLabel": "Your coin balance",
      "balanceValue": "Equal to {amount}",
      "youWillReceive": "You will receive",
      "percentOfBalance": "{percent}% of your balance",
      "chooseHeading": "Choose how many coins to cash out",
      "sliderHint": "Move the slider to choose your amount",
      "minimum": "Minimum {coins} coins",
      "minimumUpTo": "Minimum {coins} coins · up to {amount}",
      "fraudProtection": "We use advanced fraud protection to make sure your money gets to you.",
      "learnMore": "Learn more"
    },
    "review": {
      "amountLabel": "Amount",
      "conversionRate": "{coins} coins = $1"
    },
    "errors": {
      "loadFailed": "We couldn’t load your cash-out details. Please try again.",
      "retry": "Try again",
      "rewardTypeDisabled": "This reward is not currently available."
    }
  },
  "content": {
    "articles": {
      "table": {
        "createArticle": "+ Create Article",
        "filters": {
          "status": "Status"
        },
        "headers": {
          "publicUrl": "Public URL",
          "template": "Template"
        },
        "actions": {
          "edit": "Edit",
          "publish": "Publish",
          "unpublish": "Unpublish",
          "delete": "Delete"
        }
      },
      "editor": {
        "createTitle": "Create article",
        "editTitle": "Edit article",
        "save": "Save",
        "back": "Back",
        "showPreview": "Show preview",
        "hidePreview": "Hide preview",
        "openPublicPage": "Open public page",
        "previewPublicPage": "Preview public page",
        "publish": "Publish",
        "unpublish": "Unpublish",
        "saveAsDraft": "Save as draft",
        "fields": {
          "template": "Template",
          "templateSwitchHint": "Switching templates keeps your content: fields from the other template are preserved but hidden.",
          "name": "Name",
          "namePlaceholder": "Enter article name",
          "slug": "Slug",
          "slugPlaceholder": "Enter article slug",
          "publicPageHint": "Public page will be served at {path}",
          "standfirst": "Standfirst",
          "body": "Body",
          "readingTimeMinutes": "Reading time (minutes)",
          "readingTime": "Reading time",
          "readingTimePlaceholder": "Enter reading time in minutes",
          "authorName": "Author name",
          "authorNamePlaceholder": "Enter author name",
          "displayPublishedAt": "Publish date",
          "displayPublishedAtHint": "Optional. Back-dates the date readers see. Leave empty to show the date the article was actually published.",
          "coverImage": "Cover image",
          "metaTitle": "Meta title",
          "metaTitlePlaceholder": "Enter meta title",
          "metaDescription": "Meta description",
          "metaDescriptionPlaceholder": "Enter meta description",
          "steps": "Steps",
          "stepsHint": "Numbered steps render as cards on the page; step titles feed the In-this-guide navigation.",
          "stepNumber": "Step {number}",
          "stepTitle": "Step title",
          "stepTitlePlaceholder": "Enter step title",
          "stepBody": "Step body",
          "addStep": "+ Add step",
          "moveRowUp": "Up",
          "moveRowDown": "Down",
          "removeRow": "Remove",
          "tracksHeading": "Career tracks heading",
          "tracksHeadingPlaceholder": "e.g. The main career tracks in digital tech",
          "tracksIntro": "Career tracks intro",
          "tracks": "Career tracks",
          "tracksHint": "Tracks render as a card grid; the section heading feeds the In-this-article navigation.",
          "addTrack": "+ Add track",
          "trackNumber": "Track {number}",
          "trackTitle": "Track title",
          "trackTitlePlaceholder": "Enter track title",
          "trackDescription": "Track description",
          "trackMostCommon": "Mark as most common",
          "stages": "Pathway stages",
          "stagesHint": "Each stage renders as a salary table; stage headings feed the In-this-article navigation.",
          "addStage": "+ Add stage",
          "stageNumber": "Stage {number}",
          "stageHeading": "Stage heading",
          "stageHeadingPlaceholder": "e.g. Entry-level: how people get their start",
          "stageIntro": "Stage intro",
          "stageRows": "Rows",
          "addStageRow": "+ Add row",
          "stageRowNumber": "Row {number}",
          "stageRowRole": "Role",
          "stageRowRolePlaceholder": "e.g. IT Support / Help Desk",
          "stageRowDescription": "Description",
          "stageRowTime": "Time to first role",
          "stageRowSalaryAu": "Starting salary (AU)",
          "stageRowSalaryUs": "Starting salary (US)",
          "studyRoutesHeading": "Study routes heading",
          "studyRoutesHeadingPlaceholder": "e.g. Study routes and time-to-hire",
          "studyRoutesIntro": "Study routes intro",
          "studyRoutes": "Study routes",
          "addStudyRoute": "+ Add study route",
          "studyRouteNumber": "Study route {number}",
          "routeTitle": "Route title",
          "routeTitlePlaceholder": "e.g. University degree",
          "routeSubtitle": "Route subtitle",
          "routeDuration": "Duration",
          "routeDurationPlaceholder": "e.g. 3–4 years",
          "routeCost": "Cost",
          "routeCostPlaceholder": "e.g. AU ~$30–50k (HECS-HELP)",
          "routePros": "Pros (one per line)",
          "routeCons": "Cons (one per line)",
          "decisionGuideHeading": "Decision guide heading",
          "decisionGuideHeadingPlaceholder": "e.g. Which route should you take?",
          "decisionGuideBody": "Decision guide body",
          "faqs": "FAQs",
          "addFaq": "+ Add FAQ",
          "faqNumber": "FAQ {number}",
          "faqQuestion": "Question",
          "faqQuestionPlaceholder": "Enter question",
          "faqAnswer": "Answer",
          "rankedVariant": "Card type",
          "rankedVariantHint": "Sets each card’s field labels. Switching re-labels existing card fields but keeps their values.",
          "rankedVariantJobs": "Jobs",
          "rankedVariantSkills": "Skills",
          "rankedVariantCompanies": "Companies",
          "rankedCards": "Cards",
          "rankedCardsHint": "Cards render as a numbered list in this order.",
          "rankedCardNumber": "Card {number}",
          "rankedCardTitle": "Title",
          "rankedCardTitlePlaceholder": "e.g. Software Engineer",
          "rankedCardBadge": "Badge (optional)",
          "rankedCardBadgePlaceholder": "e.g. most wanted 2026",
          "rankedCardFields": "Fields",
          "rankedCardFieldNumber": "Field {number}",
          "rankedCardFieldLabel": "Label",
          "rankedCardFieldValue": "Value",
          "addRankedCard": "Add card",
          "addRankedCardField": "Add field",
          "synthesisHeading": "Synthesis heading (optional)",
          "synthesisHeadingPlaceholder": "e.g. What these roles have in common",
          "synthesisBody": "Synthesis body",
          "rankedCardSalaryAu": "Average salary (AU)",
          "rankedCardSalaryAuPlaceholder": "e.g. $75–130k+",
          "rankedCardSalaryUs": "Average salary (US)",
          "rankedCardSalaryUsPlaceholder": "e.g. $90–160k+",
          "rankedCardDemandLevel": "Demand level (1–5)",
          "rankedCardDemandLabel": "Demand outlook label",
          "rankedCardDemandLabelPlaceholder": "e.g. Very high",
          "rankedCardDemandNote": "Demand outlook note",
          "methodologyNote": "Methodology note",
          "methodologyNoteHint": "State your salary data sources (e.g. SEEK, LinkedIn Salary Insights, US BLS). Required to publish.",
          "entryRoles": "Entry-level roles",
          "entryRolesHint": "Optional snapshot table of entry roles with time to first role and starting salaries.",
          "addEntryRole": "Add entry role",
          "salaryRoles": "Salary matrix roles",
          "salaryRolesHint": "One card per role with entry, mid and senior salary ranges for AU and US.",
          "salaryRoleNumber": "Role {number}",
          "salaryRoleTitle": "Role title",
          "salaryRoleTitlePlaceholder": "e.g. Software Engineer / Developer",
          "salaryRoleBadge": "Badge (optional)",
          "salaryRoleBadgePlaceholder": "e.g. Highest upside",
          "salaryEntryAu": "Entry salary (AU)",
          "salaryEntryUs": "Entry salary (US)",
          "salaryMidAu": "Mid salary (AU)",
          "salaryMidUs": "Mid salary (US)",
          "salarySeniorAu": "Senior salary (AU)",
          "salarySeniorUs": "Senior salary (US)",
          "salaryRoleNote": "Footer note (optional)",
          "addSalaryRole": "Add role",
          "factorsHeading": "Factors heading",
          "factorsHeadingPlaceholder": "e.g. What Affects Your Salary?",
          "factorsIntro": "Factors intro",
          "salaryFactors": "Salary factors",
          "salaryFactorsHint": "Cards explaining what moves salaries: role, company size, skills, experience.",
          "salaryFactorNumber": "Factor {number}",
          "salaryFactorTitle": "Factor title",
          "salaryFactorBadge": "Badge (optional)",
          "salaryFactorBadgePlaceholder": "e.g. Most common",
          "salaryFactorBody": "Factor description",
          "addSalaryFactor": "Add factor",
          "bridgeHeading": "Skills–salary heading",
          "bridgeHeadingPlaceholder": "e.g. The Skills–Salary Connection",
          "bridgeBody": "Skills–salary body",
          "comparisonDensity": "Density",
          "comparisonDensityHint": "Editorial hides the per-option cost cards. Entered costs are kept, just hidden.",
          "comparisonDensityFull": "Full",
          "comparisonDensityEditorial": "Editorial",
          "comparisonOptions": "Options",
          "comparisonOptionsHint": "One block per study or career option being compared.",
          "comparisonOptionNumber": "Option {number}",
          "comparisonOptionName": "Option name",
          "comparisonOptionNamePlaceholder": "e.g. University degree",
          "comparisonOptionDuration": "Duration (optional)",
          "comparisonOptionDurationPlaceholder": "e.g. 3–4 years",
          "comparisonWhatItIs": "What it is",
          "comparisonWhoSuitsIt": "Who suits it",
          "comparisonCostAu": "Cost in Australia",
          "comparisonCostUs": "Cost in the US",
          "comparisonRealTalk": "The real talk (optional)",
          "comparisonBestFor": "Best for (one per line)",
          "addComparisonOption": "Add option",
          "decisionHeading": "Decision map heading",
          "decisionHeadingPlaceholder": "e.g. Which path should you pick?",
          "decisionIntro": "Decision map intro",
          "decisionMap": "Decision map",
          "decisionMapHint": "Who should pick what: one row per reader situation.",
          "decisionRowNumber": "Row {number}",
          "decisionWho": "Who",
          "decisionWhoPlaceholder": "e.g. You want the fastest employable skills",
          "decisionPick": "Pick",
          "decisionPickPlaceholder": "e.g. TAFE / certificate",
          "addDecisionRow": "Add row",
          "closingHeading": "Closing heading",
          "closingHeadingPlaceholder": "e.g. What Actually Matters to Employers",
          "closingBody": "Closing body",
          "storyDisclaimerHint": "Profiles are composite narratives. The public page always shows a composite disclaimer.",
          "storyProfiles": "Profiles",
          "storyProfilesHint": "One block per person sharing their story.",
          "storyProfileNumber": "Profile {number}",
          "storyProfileName": "Name",
          "storyProfileNamePlaceholder": "e.g. Maya",
          "storyProfileAge": "Age",
          "storyProfileAgePlaceholder": "e.g. 28",
          "storyProfileRole": "Role",
          "storyProfileRolePlaceholder": "e.g. Software Engineer",
          "storyProfileCity": "City",
          "storyProfileCityPlaceholder": "e.g. Sydney",
          "storyPullQuote": "Opening pull-quote",
          "storyPullQuotePlaceholder": "e.g. I failed maths in Year 11. I genuinely thought tech wasn’t for me.",
          "storyNarrative": "Narrative",
          "storyYoungerSelf": "What they’d tell their younger self",
          "addStoryProfile": "Add profile",
          "timelineDisclaimer": "Composite disclaimer",
          "timelineDisclaimerPlaceholder": "e.g. Composite account based on typical experiences of junior-to-mid software engineers at Australian tech companies.",
          "timelineDisclaimerHint": "Required. Shown on the public page above the timeline.",
          "timelineEntries": "Timeline",
          "timelineEntriesHint": "One time-stamped entry per moment of the day, in order.",
          "timelineEntryNumber": "Entry {number}",
          "timelineEntryTime": "Time",
          "timelineEntryTimePlaceholder": "e.g. 7:30AM",
          "timelineEntryTitle": "Title",
          "timelineEntryTitlePlaceholder": "e.g. Deep work",
          "timelineEntryBody": "Body",
          "addTimelineEntry": "Add entry",
          "honestyHeading": "Honesty heading",
          "honestyHeadingPlaceholder": "e.g. The honest version",
          "honestyBody": "Honesty body",
          "quizCollection": "Start collection",
          "quizCollectionHint": "The quiz card is built from this collection: its cover image, name, description, stories, coins and Start link.",
          "quizCollectionPlaceholder": "Search collections",
          "resultsHeading": "Results heading",
          "resultsHeadingPlaceholder": "e.g. What your result means",
          "resultsIntro": "Results intro",
          "quizResultTypes": "Result types",
          "quizResultTypesHint": "One card per result persona the quiz can match.",
          "quizResultTypeNumber": "Result type {number}",
          "quizResultTypeTitle": "Title",
          "quizResultTypeTitlePlaceholder": "e.g. The Builder",
          "quizResultTypeDescription": "Description",
          "quizResultTypeMapsTo": "Maps to (one per line)",
          "quizResultTypeIllustration": "Illustration",
          "quizResultTypeAccent": "Accent color",
          "quizAccentGold": "Gold",
          "quizAccentSalmon": "Salmon",
          "quizAccentOrchid": "Orchid",
          "quizAccentSky": "Sky",
          "quizAccentOrange": "Orange",
          "illustrationChoose": "Choose illustration",
          "illustrationDialogTitle": "Choose an illustration",
          "illustrationSearchPlaceholder": "Search illustrations",
          "illustrationNoResults": "No illustrations match your search.",
          "illustrationClear": "Clear",
          "addQuizResultType": "Add result type",
          "stepsHeading": "Next steps heading",
          "stepsHeadingPlaceholder": "e.g. What to do after your result",
          "quizNextSteps": "Next steps",
          "quizNextStepsHint": "Numbered steps for after the quiz, each with optional link chips.",
          "quizNextStepNumber": "Step {number}",
          "quizNextStepTitle": "Title",
          "quizNextStepTitlePlaceholder": "e.g. Read more about those specific roles",
          "quizNextStepBody": "Body",
          "quizStepLinks": "Links",
          "quizStepLinkNumber": "Link {number}",
          "quizStepLinkLabel": "Label",
          "quizStepLinkLabelPlaceholder": "e.g. Anyway’s jobs in digital tech",
          "quizStepLinkUrl": "URL",
          "quizStepLinkUrlPlaceholder": "e.g. /career-advice/digital-technology/jobs-in-digital-tech",
          "addQuizStepLink": "Add link",
          "addQuizNextStep": "Add step",
          "explainerHint": "The article body carries the question-form H2 sections; everything below is optional and renders only when authored.",
          "rolesHeading": "Roles heading",
          "rolesHeadingPlaceholder": "e.g. Where the roles are heading",
          "rolesIntro": "Roles intro",
          "explainerRoles": "Role cards",
          "explainerRolesHint": "One card per role, with an optional growing/evolving outlook badge.",
          "explainerRoleNumber": "Role {number}",
          "explainerRoleTitle": "Title",
          "explainerRoleTitlePlaceholder": "e.g. AI / Machine Learning Engineer",
          "explainerRoleOutlook": "Outlook (optional, click again to clear)",
          "roleOutlookGrowing": "Growing",
          "roleOutlookEvolving": "Evolving",
          "explainerRoleDescription": "Description",
          "addExplainerRole": "Add role",
          "checklistHeading": "Checklist heading",
          "checklistHeadingPlaceholder": "e.g. What future-proofing actually looks like",
          "checklistIntro": "Checklist intro",
          "explainerChecklist": "Checklist",
          "explainerChecklistHint": "Bold-lead items with a short explanation each.",
          "explainerChecklistItemNumber": "Item {number}",
          "explainerChecklistItemTitle": "Title",
          "explainerChecklistItemTitlePlaceholder": "e.g. Learn to use AI tools, not just understand them",
          "explainerChecklistItemBody": "Body",
          "addExplainerChecklistItem": "Add item",
          "resourcesHeading": "Resources heading",
          "resourcesHeadingPlaceholder": "e.g. Free places to start",
          "explainerResources": "Resources",
          "explainerResourcesHint": "Numbered links to free resources.",
          "explainerResourceNumber": "Resource {number}",
          "explainerResourceTitle": "Title",
          "explainerResourceTitlePlaceholder": "e.g. freeCodeCamp",
          "explainerResourceUrl": "URL",
          "explainerResourceUrlPlaceholder": "e.g. https://www.freecodecamp.org",
          "addExplainerResource": "Add resource",
          "usHeading": "US equivalents heading",
          "usHeadingPlaceholder": "e.g. How this looks in the US",
          "usBody": "US equivalents body"
        }
      },
      "templates": {
        "careerPathwayMap": "Career Pathway Map",
        "defaultBlog": "Default Blog Article",
        "stepByStepGuide": "Step-by-Step Guide",
        "rankedCards": "Ranked Cards",
        "salaryGuide": "Salary Guide",
        "comparisonGuide": "Comparison Guide",
        "practitionerStories": "Practitioner Stories",
        "dayInTheLife": "Day in the Life",
        "quizLanding": "Quiz Landing",
        "explainer": "Explainer / Outlook",
        "editorialEssay": "Editorial Essay"
      }
    },
    "videos": {
      "table": {
        "createVideo": "Create video",
        "filters": {
          "status": "Status"
        },
        "headers": {
          "name": "Name",
          "publicUrl": "Public URL",
          "sponsor": "Sponsor",
          "status": "Status"
        },
        "actions": {
          "edit": "Edit",
          "publish": "Publish",
          "unpublish": "Unpublish",
          "delete": "Delete"
        }
      },
      "editor": {
        "back": "Back",
        "createTitle": "Create video",
        "editTitle": "Edit video",
        "save": "Save",
        "saveAsDraft": "Save as draft",
        "publish": "Publish",
        "unpublish": "Unpublish",
        "openPublicPage": "Open public page",
        "providers": {
          "VIMEO": "Vimeo",
          "YOUTUBE": "YouTube"
        },
        "fields": {
          "name": "Title",
          "namePlaceholder": "A Day in the Life of an Apprentice",
          "slug": "Slug",
          "slugPlaceholder": "a-day-in-the-life-of-an-apprentice",
          "publicPageHint": "Public page: {path}",
          "videoUrl": "Video URL",
          "videoUrlPlaceholder": "https://vimeo.com/123456789 or https://www.youtube.com/watch?v=…",
          "videoUrlHint": "Paste a Vimeo or YouTube link.",
          "videoUrlDetected": "{provider} video detected",
          "videoUrlInvalid": "This is not a Vimeo or YouTube video link.",
          "description": "Description",
          "thumbnail": "Thumbnail",
          "metaTitle": "SEO title",
          "metaTitlePlaceholder": "Shown in search results and the browser tab",
          "metaDescription": "SEO description",
          "metaDescriptionPlaceholder": "One or two sentences for search results",
          "speakers": "Speakers",
          "speakersHint": "Optional. Shown under the video in this order.",
          "speakerLabel": "Speaker {number}",
          "addSpeaker": "Add speaker",
          "speakerName": "Name",
          "speakerOrganisation": "Organisation",
          "speakerBio": "Short bio",
          "speakerPhoto": "Photo"
        }
      }
    },
    "cashOuts": {
      "title": "Users & coins",
      "cashoutsTitle": "Cashouts",
      "loading": "Loading users & coins...",
      "noResults": "No users & coins found.",
      "tooltip": {
        "markAsJunk": "Mark as junk",
        "markAsNotJunk": "Mark as not junk"
      },
      "button": {
        "ariaLabel": {
          "markAsJunk": "Mark as junk",
          "markAsNotJunk": "Mark as not junk"
        }
      },
      "messages": {
        "userMarkedAsJunk": "User marked as junk",
        "userRemovedFromJunkList": "User removed from junk list"
      },
      "export": {
        "button": "Export",
        "successMessage": "Export ready.",
        "downloadLink": "Download",
        "abaButton": "Export ABA File",
        "abaError": "Failed to export the ABA file.",
        "abaBlockedTitle": "Export blocked: {count} cash-out needs fixing | Export blocked: {count} cash-outs need fixing",
        "abaBlockedCopy": "Copy list",
        "abaBlockedCopied": "Copied the list.",
        "abaBlockedDismiss": "Dismiss"
      },
      "batch": {
        "viewBatch": "View batch #{id}",
        "payoutExecutionDate": "Payout execution date {date}",
        "batched": "Batched {date}"
      },
      "bulkActions": {
        "markSelectedAsJunk": "Mark selected as junk",
        "markSelectedAsNotJunk": "Mark selected as not junk",
        "allFilteredNotSupported": "Bulk action for all filtered rows is not supported. Please select specific rows.",
        "selectAtLeastOneUser": "Please select at least one user.",
        "updatePartial": "{successCount} updated, {failureCount} failed.",
        "processPartial": "{successCount} processed, {failureCount} skipped — {reasons}",
        "updateSuccess": "{successCount} users updated successfully.",
        "selectionCount": "{count} users selected",
        "processConfirmation": {
          "title": "Process selected redemptions",
          "description": "Are you sure you want to process payouts for the selected redemptions? Only approved redemptions will be processed; anything else is reported as a failure.",
          "confirm": "Process",
          "cancel": "Cancel"
        },
        "jumpQueue": "Jump queue & export",
        "jumpQueueSuccess": "{successCount} redemptions queued in a new ad-hoc batch, ready to export.",
        "jumpQueuePartial": "{successCount} queued, {failureCount} skipped — {reasons}",
        "jumpQueueNoneQueued": "Nothing could be queued — {reasons}",
        "jumpQueueConfirmation": {
          "title": "Jump queue & export",
          "description": "This moves the selected pending or manual-review bank cash-outs straight to a new ad-hoc batch for immediate ABA export, skipping the normal schedule. Low-trust and ineligible rows are reported and left in place. Continue?",
          "confirm": "Jump queue",
          "cancel": "Cancel"
        },
        "approveSelected": "Approve Cashouts",
        "approveSuccess": "Approved {successCount} cash-out for payout | Approved {successCount} cash-outs for payout",
        "approvePartial": "Approved {successCount}, failed {failureCount}: {reasons}",
        "approveFailed": "Failed to bulk approve cash-outs",
        "approveConfirmation": {
          "title": "Approve selected cash-outs",
          "description": "This will approve every selected request that is still awaiting a decision (pending decision, manual review, or rejection scheduled) for payout. Requests in any other status will be skipped and reported.",
          "confirm": "Approve",
          "cancel": "Cancel"
        }
      },
      "coins": {
        "current": "current",
        "lifetime": "Lifetime",
        "cashedOut": "Cashed out",
        "pending": "Pending",
        "lastRedeemed": "Last redeemed {age}",
        "neverRedeemed": "Never redeemed"
      },
      "table": {
        "searchPlaceholder": "Search by cash-out ID, email or name",
        "titles": {
          "studentCoinValues": "Student Coin Values",
          "users": "Users",
          "cashouts": "Cashouts"
        },
        "filters": {
          "withTrashed": "Show with Deleted Students",
          "showJunkUser": "Include Junk Users",
          "status": "Status",
          "userFilter": "Users Filter",
          "junkUsers": "Junk users",
          "phoneNumberAssigned": {
            "label": "Has Phone Number",
            "placeholder": "Select"
          },
          "hasProcessedCoinsRedemption": {
            "label": "Has Processed Coins Redemption",
            "placeholder": "Select"
          },
          "appealVerified": {
            "label": "Appeal Verified",
            "options": {
              "verified": "Verified",
              "notVerified": "Not verified"
            }
          }
        },
        "headers": {
          "name": "Name",
          "email": "Primary Email",
          "nameEmail": "Name & Email",
          "users": "Users",
          "coinBalance": "Coin Balance",
          "coins": "Coins",
          "state": "State",
          "grade": "Grade",
          "birthDate": "Birthdate",
          "accountCreatedAt": "Account Created At",
          "accountDeletedAt": "Account Deleted",
          "phoneNumber": "Phone Number",
          "isJunk": "Junk/Not Junk",
          "status": "Status",
          "notes": "Notes",
          "coinsLastRedeemedAt": "Coins Last Redeemed At",
          "actions": "Actions",
          "prizeCampaignEntryAt": "Prize Campaign Entry At"
        },
        "status": {
          "payoutEligibleAt": "Payout eligible {date}",
          "rejectionNotifyAt": "Rejection notice {date}",
          "rejectionReason": "Reason: {reason}"
        },
        "actions": {
          "mixpanelProfile": "Mixpanel Profile",
          "processRedemption": "Process Redemption",
          "approveRedemption": "Approve Redemption",
          "markAsJunk": "Mark as junk",
          "unmarkAsJunk": "Mark as not junk",
          "markAppealVerified": "Mark appeal verified",
          "removeAppealVerification": "Remove appeal verification",
          "rejectRedemption": "Reject Redemption",
          "refundRedemption": "Refund Redemption",
          "closeAndRefundRedemption": "Close and Refund"
        },
        "messages": {
          "approveSuccessful": "Payout has been approved for processing",
          "approveUnsuccessful": "Failed to approve payout",
          "processPaidSuccessful": "Payout has been marked as paid.",
          "processRequeuedSuccessful": "Payout has been added back to the queue for processing.",
          "processUnsuccessful": "Failed to process payout",
          "rejectSuccessful": "Payout scheduled for rejection",
          "rejectUnsuccessful": "Failed to reject payout",
          "refundSuccessful": "Reversal initiated successfully",
          "refundUnsuccessful": "Failed to reverse cashout",
          "closeAndRefundSuccessful": "Cash out closed and coins refunded",
          "closeAndRefundUnsuccessful": "Could not close and refund this cash out"
        },
        "confirmations": {
          "markAppealVerified": {
            "description": "Mark {email} as a verified real human after an upheld appeal? For the next 180 days they cannot be auto-rejected — a low trust score routes to manual review instead. Verification alone never auto-approves.",
            "actions": {
              "confirm": "Mark verified",
              "cancel": "Cancel"
            }
          },
          "removeAppealVerification": {
            "description": "Remove the appeal verification from {email}? They can be auto-rejected again from their next cash-out — a low trust score will no longer route to manual review.",
            "actions": {
              "confirm": "Remove verification",
              "cancel": "Cancel"
            }
          },
          "approveRedemption": {
            "description": "Are you sure you want to approve the redemption of {amount} for {email}?",
            "actions": {
              "confirm": "Approve",
              "cancel": "Cancel"
            }
          },
          "processRedemption": {
            "description": "Are you sure you want to process the redemption of {amount} for {email}?",
            "actions": {
              "confirm": "Process",
              "cancel": "Cancel"
            }
          },
          "refundRedemption": {
            "description": "Are you sure you want to refund the redemption of {amount} for {email}?",
            "reason": {
              "label": "Reason",
              "placeholder": "Enter reason to reverse this cashout request"
            },
            "actions": {
              "confirm": "Refund",
              "cancel": "Cancel"
            }
          },
          "rejectRedemption": {
            "description": "Are you sure you want to reject the redemption of {amount} for {email}?",
            "reason": {
              "label": "Message",
              "placeholder": "Add a message about this rejection"
            },
            "actions": {
              "confirm": "Reject",
              "cancel": "Cancel"
            }
          },
          "closeAndRefundRedemption": {
            "description": "This will set the redemption of {amount} for {email} as Rejected with the reason Bank details incorrect and refund {coins} coins back to the user. They will be notified by email.",
            "genericDescription": "This will close the redemption of {amount} for {email}, set it as Rejected, and refund {coins} coins back to the user. They will be notified by email that the request could not be processed.",
            "actions": {
              "confirm": "Close and Refund",
              "cancel": "Cancel"
            }
          }
        }
      }
    },
    "redemptionBatches": {
      "title": "Cashout batches",
      "pageTitle": "Cashout batch",
      "noResults": "No cashout batches yet",
      "filters": {
        "executedLabel": "Executed batches",
        "excludeExecuted": "Exclude executed batches",
        "excludedLozenge": "Excluded"
      },
      "table": {
        "batch": "Batch",
        "payoutExecutionDate": "Payout Execution Date",
        "created": "Created",
        "redemptions": "Redemptions Count",
        "view": "View #{id}",
        "amount": "Total Cashout Amount",
        "overThreshold": "Over threshold",
        "adHoc": "Ad-hoc"
      },
      "detail": {
        "heading": "Batch #{id}",
        "payoutExecutionDate": "Payout Execution Date",
        "batched": "Batched",
        "redemptions": "Redemptions",
        "batchId": "Batch ID",
        "backToBatches": "Back to batches",
        "amount": "Total Cashout Amount",
        "overThreshold": "Over threshold — review before export",
        "adHoc": "Ad-hoc batch"
      },
      "searchPlaceholder": "Search by batch ID, cash-out ID, email or name"
    },
    "learningAssetEdit": {
      "metadata": {
        "name": "Name",
        "namePlaceholder": "Enter story title",
        "slug": "Slug",
        "slugPlaceholder": "Enter story slug",
        "internalName": "Internal Name",
        "internalNamePlaceholder": "Enter story internal name",
        "duration": "Duration",
        "durationPlaceholder": "Enter duration",
        "metaTitle": "Meta title",
        "metaTitlePlaceholder": "Enter story meta title",
        "metaDescription": "Meta Description",
        "metaDescriptionPlaceholder": "Enter Meta description",
        "coins": "Coins",
        "coinsPlaceholder": "Enter coin value for this story",
        "learningOutcomes": "Learning Outcomes (legacy)",
        "learningOutcomesPlaceholder": "Enter learning outcomes",
        "structuredOutcome": "Structured Learning Outcome",
        "structuredOutcomeTitle": "Title",
        "structuredOutcomeTitlePlaceholder": "Outcome title",
        "structuredOutcomeDescription": "Description",
        "coverImage": "Story cover image"
      }
    },
    "learningAssets": {
      "transcript": {
        "heading": "Story Transcript",
        "pageTitle": "{title}: Story Transcript",
        "backToEditor": "Back to Editor",
        "print": "Print / PDF",
        "transcriptButton": "Transcript",
        "loading": "Loading transcript...",
        "noStoryData": "This story asset has no story data to display."
      },
      "table": {
        "filters": {
          "considerationArea": "Consideration area",
          "curriculumTag": "Curriculum tag",
          "curriculumFramework": "Framework",
          "curriculumEndOfChain": "This is as specific as this framework goes."
        },
        "headers": {
          "curriculumTags": "Curriculum tags",
          "health": "Health"
        },
        "health": {
          "unreadable": "Health unavailable: this story could not be read or scored",
          "unreadableLabel": "Health unavailable",
          "summaryScope": "Health of the assets on this page only",
          "openReport": "Health {score}, {band}: open the health report",
          "bands": {
            "failing": "Failing",
            "needsWork": "Needs work",
            "healthy": "Healthy"
          }
        },
        "bulkActions": {
          "publishSelected": "Publish Selected",
          "unpublishSelected": "Unpublish Selected"
        }
      },
      "curriculumTags": {
        "heading": "Curriculum tags",
        "description": "Map this asset to one node per curriculum framework. Tags are saved when you save the settings.",
        "addTag": "Add tag",
        "addTagTrigger": "Add curriculum tag",
        "removeTag": "Remove {tag}",
        "unknownFramework": "Unknown framework",
        "empty": "No curriculum tags yet.",
        "frameworkLevel": "Framework",
        "withdrawnLevel": "Withdrawn node"
      },
      "assetList": {
        "notPublished": "This learning asset is not published!",
        "notPublishedHint": "Will not show in preview or on production",
        "internalName": "Internal name: {name}",
        "remove": "Remove {name}"
      }
    },
    "curriculumFrameworks": {
      "title": "Curriculum Frameworks",
      "index": {
        "columns": {
          "name": "Framework",
          "levels": "Levels",
          "nodesCount": "Nodes"
        },
        "empty": "No curriculum frameworks yet.",
        "loading": "Loading curriculum frameworks…",
        "loadError": "Could not load curriculum frameworks. Please refresh and try again."
      },
      "browse": {
        "loading": "Loading the framework…",
        "loadError": "Could not load this curriculum framework. Please refresh and try again.",
        "availabilitySection": {
          "title": "Availability",
          "description": "Control where teachers can use this framework."
        },
        "browseSection": {
          "title": "Browse the framework",
          "description": "Find a node by searching its code or name, or drill down one level at a time. Select a node to see the learning assets tagged to it."
        },
        "searchLabel": "Search nodes",
        "searchPlaceholder": "Search by code or name…",
        "noSearchResults": "No nodes match this search.",
        "branchEnded": "This branch ends here.",
        "clearLevel": "Clear {level}",
        "coverageHeading": "{node}, {count} tagged",
        "notFound": "This curriculum framework does not exist, or belongs to another region.",
        "backToIndex": "Back to curriculum frameworks",
        "coverage": {
          "loadError": "Could not load learning assets. Please refresh and try again.",
          "empty": "No learning assets are tagged here yet.",
          "truncated": "Showing the first {shown} of {count}. Filter the learning asset tables by this node to see them all."
        },
        "assetType": {
          "ARTICLE": "Article",
          "INDUSTRY": "Industry",
          "PATHWAY": "Pathway",
          "STORY_ASSET": "Story asset"
        },
        "states": {
          "label": "Available in states",
          "placeholder": "Every state",
          "searchPlaceholder": "Add another state",
          "help": "Teachers only see this framework at schools in the selected states. Leave empty to make it available in every state.",
          "save": "Save states",
          "saved": "States saved.",
          "saveError": "Could not save the states. Please try again."
        }
      }
    },
    "referrals": {
      "title": "Referrals",
      "table": {
        "loading": "Loading referrals...",
        "empty": "No referrals yet.",
        "noResults": "No referrals found.",
        "headers": {
          "referrer": "Referrer",
          "referee": "Referee",
          "referralCode": "Referral code",
          "status": "Status",
          "createdAt": "Created at"
        },
        "filters": {
          "status": "Status"
        },
        "status": {
          "created": "Created",
          "pendingQualification": "Pending qualification",
          "qualified": "Qualified"
        }
      },
      "redemptions": {
        "title": "Referral Redemptions",
        "table": {
          "loading": "Loading redemption requests...",
          "empty": "No redemption requests yet.",
          "noResults": "No redemption requests found.",
          "selectionCount": "{count} redemptions selected",
          "codeDisabled": "Disabled",
          "headers": {
            "user": "User",
            "amount": "Amount",
            "paymentAccountId": "Payment account ID",
            "status": "Status",
            "referralCode": "Referral code",
            "createdAt": "Created at"
          },
          "filters": {
            "status": "Status"
          },
          "status": {
            "pending": "Pending",
            "inProgress": "In progress",
            "success": "Success",
            "failed": "Failed"
          }
        },
        "actions": {
          "processPayout": "Process payout",
          "markAsJunk": "Mark as junk",
          "markAsNotJunk": "Mark as not junk",
          "disableCode": "Disable referral code",
          "enableCode": "Enable referral code"
        },
        "confirmations": {
          "payout": {
            "title": "Process payout",
            "message": "Are you sure you want to process a payout of {amount} to {email}?",
            "confirm": "Process payout"
          }
        },
        "messages": {
          "selectAtLeastOne": "Select at least one user.",
          "bulkJunkPartialFailure": "{successCount} updated, {failureCount} failed.",
          "bulkMarkedAsJunk": "{count} users marked as junk.",
          "bulkMarkedAsNotJunk": "{count} users unmarked as junk.",
          "payoutSuccess": "Payout processed successfully.",
          "markedAsJunk": "User marked as junk.",
          "markedAsNotJunk": "User marked as not junk.",
          "noReferralCode": "User does not have a referral code.",
          "codeDisabled": "Referral code disabled successfully.",
          "codeEnabled": "Referral code enabled successfully."
        }
      }
    },
    "conversationReview": {
      "userConversations": "User Conversations",
      "backToRoll": "Back to Conversation Review",
      "backToUserDetails": "Back to User Details",
      "toolRound": "Round {round} · {count} call | Round {round} · {count} calls",
      "sessionNotLoaded": "This session could not be found for this student.",
      "sessionLoadFailed": "This session could not be loaded. Try again.",
      "railLoadFailed": "The sessions could not be loaded.",
      "title": "Conversation Review",
      "table": {
        "count": "{count} session | {count} sessions",
        "started": "Started",
        "student": "Student",
        "engagement": "Engagement",
        "engagementStudentEvents": "{count} student event | {count} student events",
        "engagementNavigations": "{count} navigation | {count} navigations",
        "goal": "Goal",
        "status": "Status",
        "reviewedBy": "Reviewed by",
        "loading": "Loading sessions…",
        "empty": "No coach sessions yet",
        "noMatches": "No sessions match these filters",
        "noMatchesSubtitle": "Widen the date range, lower the engagement level or clear the other filters."
      },
      "filters": {
        "dateRange": "Date range",
        "engagement": "Engagement",
        "excludeInternal": "Exclude internal users",
        "excludeLowTrust": "Exclude low-trust students",
        "onLozenge": "On",
        "schoolUsersOnly": "School students only",
        "lessonGoalsOnly": "Lesson goals only",
        "reviewed": "Reviewed",
        "reviewedOptions": {
          "any": "Any",
          "reviewed": "Reviewed",
          "notReviewed": "Not reviewed",
          "notReviewedByMe": "Not reviewed by me"
        }
      },
      "dateRanges": {
        "last24Hours": "Last 24 hours",
        "last7Days": "Last 7 days",
        "lastMonth": "Last month",
        "allTime": "All time"
      },
      "engagement": {
        "any": "Any student events",
        "engaged": "Engaged ({min}+)",
        "high": "Highly engaged ({min}+)",
        "deep": "Deep engagement ({min}+)"
      },
      "status": {
        "active": "Active",
        "ended": "Ended"
      },
      "endReason": {
        "goalAchieved": "Goal achieved",
        "userEnded": "Ended by student",
        "goalSwitched": "Goal switched",
        "abandoned": "Abandoned",
        "superseded": "Superseded"
      },
      "actions": {
        "openConversation": "Open conversation"
      },
      "stats": {
        "totalUsers": "Total users",
        "totalConversations": "Total conversations",
        "activityNavigations": "Activity navigations",
        "learningAssetCompletions": "LAs completed via conversation"
      },
      "question": {
        "kind": {
          "plain": "Question",
          "endSession": "End session",
          "goalSwitch": "Goal switch",
          "goalSet": "Goal set",
          "starters": "Starters"
        },
        "selectType": {
          "many": "Select many"
        },
        "role": {
          "accept": "Accept",
          "decline": "Decline"
        },
        "outcome": {
          "answered": "Answered",
          "notAnswered": "Not answered",
          "superseded": "Superseded"
        },
        "picked": "Picked",
        "goal": "Proposed goal",
        "handoff": "Handoff: {handoff}",
        "provenance": {
          "userRequested": "Student requested",
          "coachSuggested": "Coach suggested"
        },
        "lessonCount": "Assigned lessons: {count}",
        "questionSeq": "Question seq {seq}"
      },
      "time": {
        "dateTimeWithZone": "DD/MM/YYYY hh{':'}mm a z"
      },
      "noConversations": "No conversations found for this user.",
      "goalSource": {
        "coachFormulated": "Formulated by the coach",
        "teacherAssigned": "Assigned by a teacher",
        "entryAssumed": "Assumed from the lesson the student joined from",
        "schoolChosen": "Chosen by the school"
      },
      "rail": {
        "label": "Sessions",
        "noGoal": "No goal",
        "studentEvents": "{count} student event | {count} student events",
        "navigations": "{count} navigation | {count} navigations",
        "previous": "Previous",
        "next": "Next",
        "pageOf": "Page {page} of {lastPage}",
        "total": "{count} session | {count} sessions",
        "pinned": "Open session",
        "retry": "Try again",
        "reviewedBy": "Reviewed by"
      },
      "header": {
        "goal": "Goal",
        "noGoal": "No goal set",
        "created": "Created {time}",
        "ended": "Ended {time}",
        "duration": "Lasted {duration}",
        "preV6": "pre-V6",
        "summary": "Conversation summary",
        "endReason": {
          "abandoned": "Ended by the sweep after 4 h idle",
          "goalAchieved": "Ended when the student achieved the goal",
          "userEnded": "Ended by the student",
          "goalSwitched": "Ended when the student switched to another goal",
          "superseded": "Ended when a newer session replaced it",
          "notRecorded": "End reason not recorded (pre-V6)"
        }
      },
      "compactions": {
        "title": "{count} compaction | {count} compactions",
        "item": "Compaction {index} · {time}",
        "seqs": "Memory through seq {through} · this run took seq {ranges} ({count} event) | Memory through seq {through} · this run took seq {ranges} ({count} events)",
        "noSeqs": "Compacts no events",
        "diffSummary": "{added} new, {carried} carried over, {dropped} dropped",
        "dropped": "Dropped from memory"
      },
      "duration": {
        "underMinute": "<1 min",
        "minutes": "{count} min",
        "hours": "{count} h",
        "hoursMinutes": "{hours} h {minutes} min",
        "days": "{count} d",
        "daysHours": "{days} d {hours} h"
      },
      "events": {
        "title": "Events ({count})",
        "arguments": "Arguments",
        "response": "Response",
        "rawArgs": "Raw args",
        "rawPayload": "Raw payload",
        "seq": "seq {seq}"
      },
      "turn": {
        "title": "Turn {index} · {kind} · {count} event | Turn {index} · {kind} · {count} events",
        "sinceStart": "at {offset}",
        "sinceLastTurn": "+{offset}",
        "kind": {
          "birth": "Opening",
          "student": "Student",
          "nudge": "Nudge",
          "activity": "Activity, no reply"
        }
      },
      "activity": {
        "learningAsset": "Opened learning asset {id}",
        "learningAssetInCollection": "Opened learning asset {id} in collection {collection}",
        "singleJob": "Opened job {id}",
        "multipleJobs": "Opened a list of jobs",
        "singleInstitution": "Opened institution {id}",
        "multipleInstitutions": "Opened a list of institutions",
        "collection": "Opened collection {id}",
        "collectionBySlug": "Opened collection {slug}",
        "collectionNotFound": "Opened a collection that could not be found",
        "saved": "Opened their saved items",
        "badges": "Opened their badges",
        "account": "Opened their account",
        "rewards": "Opened rewards",
        "library": "Opened the learning library",
        "lessons": "Opened their lessons",
        "portfolio": "Opened their portfolio",
        "profile": "Opened their profile",
        "jobCandidatesList": "Opened their job candidates",
        "jobCandidate": "Opened job candidate {id}",
        "jobCandidateWithRoute": "Opened job candidate {id} on route {routeKey}"
      },
      "goal": {
        "set": "Goal set: {goal}",
        "setFrom": "Goal set: {previous} → {goal}",
        "updated": "Goal updated: {goal}",
        "updatedFrom": "Goal updated: {previous} → {goal}",
        "achieved": "Goal achieved: {goal}",
        "achievedFrom": "Goal achieved: {previous} → {goal}"
      },
      "collectionType": {
        "channel": "Channel",
        "teacherPlaylist": "Teacher playlist",
        "teacherTemplate": "Teacher template"
      },
      "card": {
        "type": {
          "job": "Job",
          "institution": "Institution",
          "industry": "Industry",
          "action": "Action",
          "survey": "Survey"
        },
        "saved": "Saved",
        "completed": "Completed",
        "notShown": "{count} more recommendation not shown to the student | {count} more recommendations not shown to the student",
        "figure": {
          "duration": "{minutes} min",
          "coins": "{coins} coins",
          "progress": "{completed} of {total} done",
          "partner": "Partner {partner}"
        }
      },
      "eventType": {
        "assistantTurn": "Assistant",
        "starters": "Starters",
        "userInput": "User",
        "questionAnswer": "Answer",
        "toolCall": "Tool call",
        "toolResponse": "Tool response",
        "activityNavigation": "Activity navigation",
        "activityInfo": "Activity info",
        "goalChanged": "Goal",
        "unknown": "Event"
      },
      "marks": {
        "schoolStudent": "School student",
        "lessonGoal": "Lesson goal"
      },
      "annotations": {
        "title": "Session notes",
        "addNote": "Add note",
        "noteOnTurn": "Note on turn {index} ({kind}, opens at seq {seq})",
        "noteOnEvent": "Note on seq {seq} · {type}",
        "noteOnSession": "Note on the whole session",
        "verdict": {
          "good": "Good",
          "bad": "Bad",
          "neutral": "Neutral"
        },
        "verdictLabel": "Verdict",
        "bodyLabel": "Note",
        "bodyPlaceholder": "What did the coach do well or badly here?",
        "save": "Save note",
        "cancel": "Cancel",
        "edit": "Edit note",
        "delete": "Delete note",
        "deleteConfirmTitle": "Delete this note?",
        "deleteConfirmBody": "The note is removed for every reviewer. This cannot be undone.",
        "deleteConfirm": "Delete",
        "unknownAuthor": "Unknown reviewer",
        "saveFailed": "The note could not be saved. Try again.",
        "deleteFailed": "The note could not be deleted. Try again.",
        "seq": "seq {seq}",
        "turnTag": "turn {index}",
        "goToSeq": "Go to seq {seq}",
        "goToTurn": "Go to turn {index}",
        "showNotes": "Show the note on this event | Show the {count} notes on this event"
      },
      "reviewers": {
        "chip": "{name} · {count}",
        "chipLabel": "{name}, {count} note | {name}, {count} notes",
        "more": "+{count}",
        "moreLabel": "{count} more reviewer | {count} more reviewers",
        "noteTotal": "{count} note in all | {count} notes in all"
      }
    },
    "feedbackSurveys": {
      "title": "Surveys",
      "new": "New survey",
      "cancel": "Cancel",
      "table": {
        "name": "Name",
        "attachedTo": "Attached to",
        "questions": "Questions",
        "coins": "Coins",
        "responses": "Responses",
        "empty": "No surveys yet. Create one to ask for feedback when a collection is completed.",
        "unattached": "Not attached",
        "edit": "Edit survey",
        "type": "Type",
        "viewResponses": "View responses",
        "truncated": "Only the first {count} surveys are shown."
      },
      "form": {
        "askPoint": "How it is asked",
        "askPointCoach": "Through the coach, as a card once the activity is finished",
        "askPointCompletion": "At the end of the activity, before its completion screen",
        "askPointCompletionUnavailable": "A survey answered on SurveyMonkey is always asked through the coach.",
        "coins": "Coins for answering",
        "coinsHint": "Leave empty when answering pays nothing.",
        "create": "Create survey",
        "created": "Survey created.",
        "createHint": "A survey is created once it is configured, so nothing half-made is left behind.",
        "createTitle": "New survey",
        "delete": "Delete survey",
        "deleteConfirm": "Yes, delete",
        "deleteDescription": "A survey with responses on file cannot be deleted.",
        "deleteTitle": "Delete this survey?",
        "delivery": "How students answer",
        "deliveryExternal": "On SurveyMonkey",
        "deliveryInternal": "In the app",
        "detachPlace": "Detach",
        "failed": "Something went wrong. Try again.",
        "name": "Name",
        "place": "Where it is asked",
        "placeBoundHint": "Students have already been invited to answer this survey where it stands, so it can be detached but not moved somewhere else.",
        "placeDetached": "Not attached",
        "placeHint": "A survey stands in one place. A collection asks once it is completed; an activity asks once it is finished, through the coach or at the end of the activity.",
        "placeKindActivity": "Activity",
        "placeKindCollection": "Collection",
        "placeNoCollection": "Not in a collection",
        "placePlaceholder": "Search collections and activities…",
        "reattachPlace": "Reattach",
        "save": "Save",
        "saved": "Survey saved.",
        "title": "Survey",
        "unsavedChanges": "Unsaved changes"
      },
      "questions": {
        "title": "Questions",
        "hint": "Students answer these in the app, in this order.",
        "empty": "No questions yet. Add one to ask students something.",
        "add": "Add question",
        "number": "Question {number}",
        "label": "Question",
        "labelKeyHint": "Worded by the translation key {key} until wording is typed here.",
        "required": "Required",
        "type": "Type",
        "key": "Answer key",
        "keyHint": "Answers are stored under it: lowercase letters, digits and underscores, starting with a letter.",
        "identityLocked": "Students have answered this survey, so this question’s key and type can no longer change.",
        "moveUp": "Move question up",
        "moveDown": "Move question down",
        "remove": "Remove question",
        "scaleMin": "Lowest value",
        "scaleMax": "Highest value",
        "scaleMinLabel": "Label under the lowest value",
        "scaleMaxLabel": "Label under the highest value",
        "likertOptions": "Agreement options offered",
        "options": "Options",
        "optionValue": "Value",
        "optionLabel": "Wording",
        "optionPositive": "Counts as a good result",
        "addOption": "Add option",
        "removeOption": "Remove option",
        "types": {
          "LIKERT": "Agreement (likert)",
          "SCALE": "Number scale",
          "DROPDOWN": "Dropdown",
          "TEXT": "Short text",
          "TEXTAREA": "Long text",
          "YES_NO": "Yes / no"
        }
      },
      "type": {
        "custom": "Custom",
        "lesson": "Lesson"
      },
      "lesson": {
        "title": "Lesson feedback survey",
        "everyLesson": "Every lesson",
        "viewQuestions": "View questions",
        "fixedNote": "These questions are the same for every lesson, on every school. Reporting compares results across lessons by these fixed questions, so they can’t be edited here.",
        "reportingHint": "A reworded or reordered lesson question would silently end like-for-like reporting, which is why this page is read-only."
      },
      "external": {
        "deliveryHint": "Search the connected SurveyMonkey account to link a survey; completing it still pays coins here.",
        "locked": "This survey has responses on file, so its delivery can no longer change.",
        "pickCollector": "Choose a weblink collector…",
        "noCollectors": "This survey has no open weblink collectors. Create a Web Link collector on its Collect page in SurveyMonkey first.",
        "notLinked": "No SurveyMonkey survey linked yet. Search above to pick one.",
        "searchLabel": "SurveyMonkey survey",
        "searchPlaceholder": "Search the connected SurveyMonkey account…",
        "checking": "Checking with SurveyMonkey…",
        "verifiedBadge": "Verified",
        "failedBadge": "Check failed",
        "unverifiedBadge": "Not verified",
        "checkFailed": "SurveyMonkey refused the check.",
        "preview": "Preview on SurveyMonkey",
        "results": "View results on SurveyMonkey",
        "badge": "SurveyMonkey",
        "answersElsewhere": "Answers are collected on SurveyMonkey and copied here when a completion is paid. Questions are labelled from the copy taken at the last save; save the survey again after editing it on SurveyMonkey.",
        "coinsAwarded": "Coins paid",
        "refreshQuestions": "Refresh questions",
        "internalAnswersTitle": "Answers taken in the app"
      }
    },
    "schoolsConnections": {
      "nav": "Integration Connections",
      "title": "Integration Connections",
      "cancel": "Cancel",
      "confirmPhrase": "Type {phrase} to confirm",
      "actionFailed": "That didn’t work. Try again.",
      "viewOnly": "You have view-only access to Schools connections. To make changes, ask a super admin for the Schools editor role ({capability}).",
      "dateTimeFormat": "D MMM YYYY, h:mm a",
      "dateFormat": "D MMM YYYY",
      "help": {
        "about": "What does {term} mean?"
      },
      "load": {
        "loading": "Loading",
        "failedTitle": "We couldn’t load this",
        "failedBody": "Nothing has been changed. Check your internet connection and try again. If it keeps happening, tell an engineer.",
        "retry": "Try again",
        "refreshFailed": "We couldn’t refresh this page, so what it shows may be out of date."
      },
      "pager": {
        "summary": "Page {page} of {lastPage}, {total} in total"
      },
      "providers": {
        "clever": "Clever",
        "fakeClever": "Clever (fake)"
      },
      "statuses": {
        "discovered": "Discovered",
        "active": "Active",
        "paused": "Paused",
        "rejected": "Rejected",
        "disconnected": "Disconnected"
      },
      "checkNow": {
        "action": "Check for new districts",
        "failure": "{provider} could not be checked because {reason}.",
        "reasons": {
          "authorisationLost": "Anyway’s access to the provider was refused",
          "providerUnavailable": "the provider is not responding, so try again in a few minutes",
          "malformedResponse": "the provider sent a reply we could not read",
          "unexpectedError": "something unexpected went wrong, and engineering has been told"
        },
        "result": "{discovered} new, {known} already listed.",
        "tenantFailure": "{provider} district {tenant} could not be checked because {reason}."
      },
      "killSwitch": {
        "rosterSync": {
          "title": "Syncing is switched off",
          "help": "Engineering has switched off syncing for every connection. No preview or sync can start, and any that are running stop. It is not controlled from this page."
        },
        "providerLogin": {
          "title": "Provider sign-in is switched off",
          "help": "Engineering has switched off sign-in through providers for everyone. It is not controlled from this page."
        },
        "unknown": {
          "title": "Could not check the kill switches",
          "help": "This page could not find out whether syncing and provider sign-in are switched on. Until it can, treat both as unknown."
        }
      },
      "table": {
        "name": "Connection",
        "status": "Status",
        "schools": "Schools",
        "schoolCounts": "{linked} / {proposed} / {ignored}",
        "lastFullRun": "Last sync",
        "noOwner": "Not chosen yet",
        "noOwnerYet": "no owner school",
        "noRun": "Never",
        "authorisationLost": "Authorisation lost",
        "count": "No connections | {count} connection | {count} connections",
        "statusFilter": "Status",
        "noResults": "No connections yet. Check for new districts once a district has approved the Anyway app.",
        "noMatches": "No connections match these filters. Rejected connections only show when the status filter names them.",
        "schoolCountsHelp": "Linked / proposed / ignored schools.",
        "provider": "Provider",
        "providerFilter": "Provider"
      },
      "nextStep": {
        "setupShort": "Setup Wizard {step}/{total}",
        "switchOff": {
          "short": "Syncing off"
        },
        "previewQueued": {
          "short": "Preview queued"
        },
        "syncQueued": {
          "short": "Sync queued"
        },
        "previewRunning": {
          "short": "Preview running"
        },
        "syncRunning": {
          "short": "Sync running"
        },
        "authorisationLost": {
          "short": "Access lost",
          "title": "The district has withdrawn Anyway’s access",
          "help": "Anyway can no longer read this district’s roster, so syncs fail. Students keep their accounts and their place at the school. Ask the district contact to share with Anyway again in the provider. The next successful sync clears this."
        },
        "rejected": {
          "short": "Rejected",
          "title": "This connection was rejected",
          "help": "Nothing syncs and the district is left alone. Reopening returns it to Discovered with the schools found earlier, so setup can carry on.",
          "action": "Reopen"
        },
        "paused": {
          "short": "Paused",
          "title": "This connection is paused",
          "help": "No syncs run and nobody can sign in through the provider. Students and school links are kept, and teachers still can’t add students by hand at linked schools. Resume starts a full sync.",
          "action": "Resume"
        },
        "disconnected": {
          "short": "Disconnected",
          "title": "This connection is disconnected",
          "help": "Nothing syncs and nobody can sign in through the provider. Its schools are manual again. Reconnect returns it to Discovered, to preview and approve again.",
          "action": "Reconnect"
        },
        "lastSyncFailed": {
          "short": "Sync failed",
          "title": "The last sync did not finish",
          "titleWithReason": "The last sync did not finish: {reason}",
          "help": "Open the run to see how far it got. Changes it had already made are kept.",
          "action": "View run"
        },
        "holds": {
          "short": "{count} held",
          "title": "{count} person is held | {count} people are held",
          "help": "People the sync could not place safely. Nothing happens to them until the cause is fixed, and they are checked again on every sync.",
          "action": "Review holds"
        }
      },
      "detail": {
        "notFound": "This connection isn’t in this region.",
        "rejected": "Connection rejected.",
        "reopened": "Connection reopened.",
        "rejectAction": "Reject connection",
        "rejectDialog": {
          "title": "Reject this connection?",
          "description": "Nothing syncs, no student is changed, and the district drops off the list. It can be reopened later.",
          "reason": "Reason (optional)",
          "reasonHelp": "Saved in the audit log. It is not sent to the district. Removing the Anyway app on the district’s side is done in the provider.",
          "submit": "Reject"
        },
        "pauseAction": "Pause",
        "paused": "Connection paused.",
        "resumed": "Connection resumed.",
        "pausedSince": "Paused {date}",
        "pauseDialog": {
          "title": "Pause this connection?",
          "description": "Syncs and provider sign-in stop for this district until it is resumed.",
          "points": {
            "stops": "Syncs stop and nobody at this district can sign in through the provider.",
            "email": "Students can still sign in with email.",
            "keeps": "Students, their roles and school links are kept.",
            "invites": "Teachers still can’t add students by hand at its linked schools.",
            "signedIn": "People already signed in stay signed in."
          },
          "submit": "Pause"
        },
        "resumeDialog": {
          "title": "Resume this connection?",
          "description": "Syncs and provider sign-in start again for this district.",
          "points": {
            "sync": "A full sync starts now.",
            "signIn": "Students at linked schools can sign in through the provider again."
          },
          "submit": "Resume"
        },
        "disconnectAction": "Disconnect",
        "disconnected": "Connection disconnected.",
        "disconnectedSince": "Disconnected {date}",
        "disconnectDialog": {
          "title": "Disconnect this connection?",
          "description": "Every student role this district manages is removed and its schools go back to manual.",
          "points": {
            "roles": "Student roles removed: {roles}.",
            "schools": "Schools returned to manual: {schools}. Teachers can invite students there again.",
            "stops": "Syncs and {provider} sign-in stop for this district.",
            "kept": "Sign-in identities and school matches are kept, so the district can be reconnected."
          },
          "submit": "Disconnect"
        },
        "reconnected": "Connection reconnected.",
        "approvedSince": "Approved {date} by {name}",
        "approvedSinceNoName": "Approved {date}",
        "rejectedSince": "Rejected {date}",
        "reconnectDialog": {
          "title": "Reconnect this connection?",
          "description": "The connection goes back to Discovered.",
          "points": {
            "links": "Its schools come back as proposed, matched as before.",
            "approve": "Run a fresh preview and approve it again before anything syncs."
          },
          "submit": "Reconnect"
        },
        "refusedDomainsChoice": {
          "legend": "This connection added {count} refused sign-up domain. | This connection added {count} refused sign-up domains.",
          "keep": "Keep them, so the public site still refuses sign-up there",
          "remove": "Remove them, so the public site opens accounts there again",
          "sharedStay": "A domain another active or paused connection still trusts stays refused."
        }
      },
      "tabs": {
        "overview": "Overview",
        "schools": "Schools",
        "runs": "Runs",
        "holds": "Holds",
        "domains": "Trusted Domains"
      },
      "overview": {
        "lastSync": "Last sync",
        "peopleRead": "People in last sync",
        "linkedSchools": "Linked schools",
        "holds": "Holds",
        "provider": "Provider",
        "owner": "Owner school",
        "roster": "Student list",
        "rosterShared": "Shared",
        "rosterNotShared": "Not shared",
        "districtId": "District ID",
        "copy": "Copy the district ID",
        "copied": "District ID copied."
      },
      "approval": {
        "stepDone": "Step {step}, done",
        "loginButtonMissing": {
          "title": "No sign-in button for this provider yet",
          "help": "The schools sign-in page does not list this provider’s button, so students can’t sign in with it. The button is set per region by engineering. Setup can be finished in the meantime."
        },
        "preview": {
          "title": "Run a preview",
          "help": "Reads the district’s schools, head counts and email domains from the provider. It never creates or changes a student. Schools and domains appear in their tabs when it completes.",
          "action": "Run preview",
          "runAgain": "Run again",
          "started": "Preview started.",
          "view": "View preview"
        },
        "owner": {
          "title": "Choose the owner school",
          "help": "The Anyway school this district’s students belong to. In this version it is the only school the connection can link, and it can’t change while a school is linked. Only verified schools in this region can be chosen.",
          "change": "Change"
        },
        "domains": {
          "title": "Configure trusted domains",
          "help": "Trust only domains the district itself runs. Anyone with an address on a trusted domain is trusted to be that person: existing accounts are linked without asking and new logins are verified. Setup can carry on without one.",
          "edit": "Review"
        },
        "approve": {
          "title": "Approve",
          "help": "Makes the connection active. Nothing syncs and no student changes until a school is linked.",
          "action": "Approve",
          "approved": "Connection approved.",
          "blocked": "Finish steps 1 and 2 first.",
          "noTrustedDomain": "No trusted domain yet. Students who already have an Anyway account will wait as pending instead of being linked."
        },
        "link": {
          "title": "Link the school",
          "help": "Links the district’s school to the owner school. From then on the roster decides who is a student there, and teachers can’t add students by hand.",
          "locked": "After approval",
          "action": "Go to Schools"
        },
        "sync": {
          "title": "Run the first sync",
          "help": "Creates accounts for the students the district lists at the linked school. Nobody is removed by the first sync. Anyone who can’t be placed safely is held.",
          "locked": "After a school is linked",
          "action": "Sync now",
          "started": "Sync started."
        },
        "wizardTitle": "Setup Wizard",
        "recommended": "Recommended"
      },
      "ownerPicker": {
        "label": "Owner school",
        "placeholder": "Search schools",
        "saved": "{name} is now the owner school.",
        "unlinkFirst": "Unlink this connection’s school before changing the owner school.",
        "saving": "Saving",
        "searchFailed": "Could not search schools. Try again."
      },
      "domains": {
        "domain": "Domain",
        "observed": "Seen in preview",
        "addedByHand": "Added by hand",
        "trustColumn": "Trusted",
        "notTrusted": "Not trusted",
        "trust": "Trust",
        "trusted": "Trusted",
        "trustedToast": "{domain} trusted.",
        "trustedBy": "by {name} on {date}",
        "empty": "No domains yet. Run a preview or add one.",
        "addLabel": "Add a domain",
        "addPlaceholder": "district.org",
        "add": "Add",
        "added": "{domain} added.",
        "invalid": "Enter a domain such as district.org.",
        "publicMailService": "Public mail service",
        "addresses": "{count} address | {count} addresses",
        "trustDialog": {
          "title": "Trust {domain}?",
          "description": "Trusts {domain} as a domain the district runs.",
          "trusted": "New students with an address on this domain get a verified login straight away.",
          "silentLink": "Existing Anyway accounts with an address on this domain are linked to the roster without asking the person.",
          "submit": "Trust domain",
          "refusePublicSignUp": "Also refuse public sign-up at this domain",
          "refusePublicSignUpHelp": "New students and teachers with an address on this domain are sent to the schools site instead of opening an account on the public site."
        },
        "addHelp": "The part after the at sign, for example district.org. Adding a domain does not trust it.",
        "untrust": "Untrust",
        "untrustedToast": "{domain} is no longer trusted.",
        "runInProgress": "Wait for the run to finish.",
        "untrustDialog": {
          "title": "Untrust {domain}?",
          "description": "Stops trusting {domain}.",
          "keepsLinked": "Students already linked through this domain stay linked.",
          "stopsSilentLink": "From the next sync, existing Anyway accounts with an address on this domain wait as pending instead of being linked.",
          "submit": "Untrust domain"
        }
      },
      "schools": {
        "externalSchool": "{provider} school",
        "externalId": "ID {id}",
        "census": "People",
        "matched": "Anyway school",
        "status": "Status",
        "actions": "Actions",
        "censusCounts": "Students {students} · Teachers {teachers} · Staff {staff}",
        "lastSeen": "Last shared {date}",
        "noCensus": "Not counted yet",
        "unnamed": "Unnamed school",
        "link": "Link",
        "ignore": "Ignore",
        "unlink": "Unlink",
        "linkNeedsApproval": "Approve this connection before linking schools.",
        "linkNeedsResume": "Resume this connection before linking schools.",
        "linkNeedsReconnect": "Reconnect this connection before linking schools.",
        "linkNeedsReopen": "Reopen this connection before linking schools.",
        "linkNeedsOwner": "Choose the owner school first.",
        "onlyOneLink": "{school} is already linked. In this version a connection links one school.",
        "empty": "No schools yet. Run a preview.",
        "notLinked": "Not linked",
        "linkStatuses": {
          "proposed": "Proposed",
          "linked": "Linked",
          "ignored": "Ignored",
          "unshared": "No longer shared"
        },
        "linkDialog": {
          "title": "Link this {provider} school to an Anyway school?",
          "description": "Links the {provider} school {external} to the Anyway school {school}.",
          "rosterDecides": "The roster decides who is a student at {school}.",
          "noManualStudents": "Teachers can no longer invite or add students by hand.",
          "pendingInvites": "No pending invites are affected. | {count} pending invite stops working. | {count} pending invites stop working.",
          "manualRoles": "No students were added by hand. | {count} student added by hand stays, and is taken over when the roster lists them. | {count} students added by hand stay, and are taken over when the roster lists them.",
          "studentsToRestore": "Up to {count} student removed by an unlink or a disconnect gets their place back on the next sync. | Up to {count} students removed by an unlink or a disconnect get their place back on the next sync.",
          "studentsToCreate": "No students to create on the next sync. | Up to {count} student created on the next sync. | Up to {count} students created on the next sync.",
          "submit": "Link",
          "done": "{external} linked."
        },
        "ignoreDialog": {
          "title": "Ignore {external}?",
          "description": "Sets {external} aside.",
          "nothingSyncs": "Nothing syncs for this school.",
          "nobodyChanges": "No student is changed.",
          "noUndo": "This can’t be undone from this page yet.",
          "submit": "Ignore",
          "done": "{external} ignored."
        },
        "unlinkDialog": {
          "title": "Unlink this {provider} school from its Anyway school?",
          "description": "Unlinks the {provider} school {external} from the Anyway school {school}.",
          "managedRolesToRevoke": "No students lose their place. | {count} managed student loses their place at {school}. | {count} managed students lose their place at {school}.",
          "includesTakenOver": "This includes students added by hand and later taken over by the roster.",
          "backToManual": "Teachers can invite and add students by hand again. The match is kept.",
          "submit": "Unlink",
          "done": "{external} unlinked."
        },
        "runInProgress": "Wait for the run to finish.",
        "sides": {
          "fromProvider": "From {provider}",
          "anywaySchool": "Anyway school",
          "noAnywaySchool": "Not linked"
        },
        "consequencesLoading": "Counting what this changes",
        "consequencesFailed": "Could not load the numbers for this school."
      },
      "runs": {
        "preview": "Run preview",
        "syncNow": "Sync now",
        "unavailable": "Runs can’t be started while the connection is not live.",
        "started": "Run started.",
        "kind": "Kind",
        "status": "Status",
        "startedAt": "Started",
        "finished": "Finished",
        "notFinished": "Not finished",
        "processed": "People read",
        "revoked": "Revoked",
        "triggeredBy": "Started by",
        "operatorRemoved": "Removed operator",
        "triggers": {
          "scheduled": "Nightly schedule"
        },
        "view": "View",
        "empty": "No runs yet.",
        "inProgress": "A run is in progress.",
        "kinds": {
          "preview": "Preview",
          "full": "Full sync"
        },
        "runStatuses": {
          "queued": "Queued",
          "running": "Running",
          "completed": "Completed",
          "failed": "Failed",
          "stopped": "Stopped",
          "stalled": "Stalled"
        },
        "reasons": {
          "syncDisabled": "Syncing was switched off",
          "connectionPaused": "The connection was paused",
          "connectionNotLive": "The connection was not live",
          "rosterNotEnabled": "Roster sharing was off",
          "authorisationLost": "The district withdrew Anyway’s access",
          "providerUnavailable": "The provider was not responding",
          "malformedResponse": "The provider sent something it should not have",
          "unexpectedError": "Something unexpected went wrong",
          "timedOut": "The run took too long and was stopped",
          "noPeople": "The roster came back empty",
          "noSchools": "The district shared no schools"
        },
        "reasonHelp": {
          "syncDisabled": "Engineering switched syncing off. Try again once it is back on.",
          "connectionPaused": "Runs can start again once the connection is resumed.",
          "connectionNotLive": "A full sync needs an approved, active connection.",
          "rosterNotEnabled": "A full sync needs roster sharing enabled on the connection.",
          "authorisationLost": "Ask your district contact to share with Anyway again in the provider, then run a sync.",
          "providerUnavailable": "This is usually temporary. Try again in a few minutes.",
          "malformedResponse": "Nobody was removed, as a safety measure. Try again later, and tell an engineer if it keeps happening.",
          "unexpectedError": "Engineering has been told automatically. Try again, and tell an engineer if it keeps failing.",
          "timedOut": "Try again. Tell an engineer if it keeps happening.",
          "noPeople": "Nobody was removed, as a safety measure. Ask your district contact to check what they share with Anyway in the provider.",
          "noSchools": "No school was unlinked and nobody was removed, as a safety measure. Ask your district contact to check which schools they share with Anyway in the provider."
        },
        "kindsHelpTitle": "Preview and full sync",
        "kindsHelp": "A preview only reads the district’s schools, head counts and email domains. A full sync creates, updates and removes students at linked schools to match the roster. Only one run at a time per connection.",
        "statusHelp": {
          "queued": "Waiting for the runs ahead of it to finish. It starts on its own.",
          "running": "Still running. The page updates by itself.",
          "completed": "Finished without stopping.",
          "failed": "Ended on an error. Changes it had already made are kept.",
          "stopped": "Stopped part way because syncing was switched off or the connection stopped being live. Changes it had already made are kept.",
          "stalled": "This run stopped reporting and will not finish on its own. Starting a new run marks it failed."
        }
      },
      "runDetail": {
        "title": "{kind} run",
        "titleUnknown": "Run",
        "notFound": "This run isn’t in this region.",
        "providerReportedStatus": "Reported by the provider",
        "runAgainStarted": "Full sync started.",
        "counts": "Counts",
        "records": "Records",
        "noCounts": "Nothing counted.",
        "noRecords": "No records.",
        "noRecordsForOutcome": "No records with this outcome.",
        "outcome": "Outcome",
        "outcomeFilter": "Outcome",
        "reason": "Reason",
        "subject": "Provider user ID",
        "school": "School in provider",
        "person": "Person",
        "unnamedPerson": "Open account",
        "noPerson": "Not recorded",
        "allOutcomes": "All outcomes",
        "runFullSyncNow": "Run full sync again",
        "groups": {
          "none": "None",
          "changed": {
            "title": "Changed",
            "help": "People this run created or updated."
          },
          "leftAlone": {
            "title": "Left alone",
            "help": "People this run read and did not need to touch."
          },
          "needsAttention": {
            "title": "Needs attention",
            "help": "People who were held, removed or could not be read."
          }
        },
        "outcomes": {
          "unreadable": "Could not be read",
          "skippedRole": "Skipped, not a student",
          "notAtLinkedSchool": "Not at a linked school",
          "ineligible": "Not eligible",
          "held": "Held",
          "created": "Account created",
          "linked": "Linked to an existing account",
          "pending": "Pending proof",
          "createdRole": "Added to the school",
          "takenOver": "Taken over",
          "refreshed": "Details updated",
          "unchanged": "Unchanged",
          "ignoredSchool": "At an ignored school",
          "revoked": "Removed from the school"
        },
        "recordReasons": {
          "no_email": "No email address in the roster",
          "address_collision": "The email belongs to another account",
          "under_age": "Under the minimum age",
          "no_date_of_birth": "No date of birth in the roster",
          "tombstoned": "No longer in the roster",
          "unshared": "The school is no longer shared",
          "disconnected": "The connection was disconnected",
          "restored": "Place at the school restored"
        },
        "countKeys": {
          "people": "People read",
          "unreadable": "Could not be read",
          "skipped_role": "Skipped, not a student",
          "not_at_linked_school": "Not at a linked school",
          "ineligible_under_age": "Not eligible, under age",
          "ineligible_no_date_of_birth": "Not eligible, no date of birth",
          "held_no_email": "Held, no email",
          "held_address_collision": "Held, email already taken",
          "created": "Accounts created",
          "linked": "Linked to existing accounts",
          "pending": "Pending proof",
          "created_role": "Added to the school",
          "created_role_restored": "Place restored",
          "taken_over": "Taken over",
          "refreshed": "Details updated",
          "unchanged": "Unchanged",
          "ignored_school": "At an ignored school",
          "revoked_unshared": "Removed, school no longer shared",
          "revoked_tombstoned": "Removed, left the roster",
          "sweep_skipped": "Removals skipped"
        },
        "countHelp": {
          "people": "Everyone the district listed in its roster for this run.",
          "unreadable": "The provider sent a record for this person that Anyway could not understand. It was skipped. Tell an engineer if the number is large.",
          "skipped_role": "Teachers and staff. Only students are synced in this version.",
          "not_at_linked_school": "Students at a school in the district that is not linked to Anyway.",
          "ineligible_under_age": "Students younger than the minimum age for this region. No account was created.",
          "ineligible_no_date_of_birth": "The roster has no date of birth, so Anyway can’t check the minimum age. Ask the district to add it.",
          "held_no_email": "The roster has no email address for the student. Ask the district to add one.",
          "held_address_collision": "The student’s email already belongs to a different Anyway account. See the Holds tab.",
          "created": "New Anyway accounts created for students who did not have one.",
          "linked": "Students who already had an Anyway account with an address on a trusted domain. The roster was connected to that account.",
          "pending": "The email matches an existing account, but its domain is not trusted, so Anyway did not connect them. See the Holds tab.",
          "created_role": "Students given a place at the linked school.",
          "created_role_restored": "Students who had lost their place and got it back because they are in the roster again.",
          "taken_over": "Students who were added by hand before, and are now managed by the roster. Their name and class year come from the roster and are locked.",
          "refreshed": "Students whose name or class year changed in the roster and was updated on Anyway.",
          "unchanged": "Students who were already up to date.",
          "ignored_school": "People listed at a school you chose to ignore.",
          "revoked_unshared": "Students who lost their place because the district stopped sharing their school.",
          "revoked_tombstoned": "Students who lost their place because they are no longer in the district’s roster. Their account is kept.",
          "sweep_skipped": "A record from the provider had no id, so Anyway could not tell who left the roster. Nobody was removed this run. Tell an engineer if it happens again."
        },
        "pageTitle": "{kind} run, {name}",
        "countsHelp": "What happened to the people the district listed. One person can appear on more than one line, for example when their account is created and they are then added to the school, so the lines can add up to more than the people read.",
        "recordsHelp": "One row for each change this run made, or each person it could not read. People who were left alone are counted but not listed. Rows are kept for 90 days."
      },
      "holds": {
        "name": "Name",
        "subject": "Provider user ID",
        "status": "Status",
        "reason": "Reason",
        "account": "Account",
        "noAccount": "None",
        "unnamedAccount": "Unnamed account",
        "held": "Held",
        "pending": "Pending proof",
        "noName": "No name",
        "pendingReason": "Email matches an existing account",
        "empty": "Nobody is held.",
        "reasons": {
          "noEmail": "No email address",
          "addressCollision": "Email already taken"
        },
        "whatToDo": {
          "noEmail": "Ask the district to add an email address for this student in the provider. The next sync picks it up.",
          "addressCollision": "The email already belongs to the Anyway account shown. If the district gave the address to this student, release it from that account and the next sync places them. Otherwise ask the district to correct the roster.",
          "pending": "The email matches the Anyway account shown, but its domain is not trusted. The hold clears when the student signs in with {provider} and enters the code we email them. If the district runs that domain, you can also trust it on the Trusted Domains tab and run a sync."
        },
        "release": {
          "action": "Release address",
          "released": "Released. The hold clears at the next sync.",
          "releasedToast": "Address released. The hold clears at the next sync.",
          "refused": {
            "notAddressCollision": "This hold changed since you opened it. Reload and try again.",
            "addressNotHeld": "The old account no longer holds this address. The hold clears at the next sync."
          },
          "dialog": {
            "title": "Release {address}?",
            "description": "Moves {address} off the account that has it, so the next sync can place the held student.",
            "from": "From",
            "to": "To",
            "toAtNextSync": "{name}, at the next sync",
            "keeps": "{account} keeps roles, progress and any other email addresses. Without another address, the account can’t sign in by email.",
            "staysHeld": "{name} stays held until the next sync, which clears the hold.",
            "permanent": "This can’t be undone from these pages.",
            "submit": "Release address"
          }
        }
      },
      "glossary": {
        "provider": {
          "title": "Provider",
          "definition": "The service a district uses to keep its student list and to let students sign in to apps. Clever is a provider."
        },
        "districtId": {
          "title": "District ID in the provider",
          "definition": "The provider’s own ID for this district. You only need it when talking to the provider’s support or to an engineer."
        },
        "discovered": {
          "title": "Discovered",
          "definition": "The district has given Anyway permission, but nobody at Anyway has set the connection up yet. Nothing syncs."
        },
        "active": {
          "title": "Active",
          "definition": "The connection is approved and live. Students at linked schools can sign in through the provider and the roster can sync."
        },
        "paused": {
          "title": "Paused",
          "definition": "The connection is stopped for now. No syncs run and nobody can sign in through the provider. Students and school links are kept.",
          "action": "Resume it from the alert on the connection’s page. A full sync starts at once."
        },
        "rejected": {
          "title": "Rejected",
          "definition": "Someone at Anyway decided not to work with this district. Nothing syncs. It can be reopened."
        },
        "disconnected": {
          "title": "Disconnected",
          "definition": "The connection has been taken down. Nothing syncs and nobody can sign in through the provider.",
          "action": "Reconnect it from the alert on the connection’s page, then preview and approve it again."
        },
        "ownerSchool": {
          "title": "Owner school",
          "definition": "The Anyway school this district’s students belong to. For now a school stands in for the district. In this version it is the only school a connection can link, and it can’t change while a school is linked."
        },
        "run": {
          "title": "Run",
          "definition": "One time Anyway read the district’s roster. A run is either a preview or a full sync, and only one can run at a time for a connection."
        },
        "proposed": {
          "title": "Proposed",
          "definition": "The district shares this school, and nobody at Anyway has linked or ignored it yet."
        },
        "linked": {
          "title": "Linked",
          "definition": "The school’s student list is managed by the district’s roster. Teachers can’t add students by hand."
        },
        "ignored": {
          "title": "Ignored",
          "definition": "Set aside. Nothing syncs for this school.",
          "action": "This can’t be undone from this page yet."
        },
        "unshared": {
          "title": "No longer shared",
          "definition": "The district stopped sharing this school with Anyway, so its students lost their place at the school.",
          "action": "If that was not intended, ask your district contact to share the school again in the provider."
        },
        "peopleAtSchool": {
          "title": "People at this school",
          "definition": "How many students, teachers and staff the district listed at this school in the last completed preview. Only students are synced in this version."
        },
        "trustedDomain": {
          "title": "Trusted domain",
          "definition": "An email domain you have trusted as one the district runs. Anyone with an address on it is trusted to be that person, so existing accounts are linked without asking and new logins are verified straight away."
        },
        "publicMailService": {
          "title": "Public mail service",
          "definition": "A domain anyone can sign up to, such as gmail.com. A district can’t run one, so it can never be trusted."
        },
        "pending": {
          "title": "Pending proof",
          "definition": "The person’s email matches an existing Anyway account, but the email’s domain is not trusted, so Anyway has not connected the two.",
          "action": "Clears when the student signs in and enters the code we email them. If the district runs the domain, you can also trust it on the Trusted Domains tab and run a sync."
        },
        "providerUserId": {
          "title": "Provider user ID",
          "definition": "The provider’s own ID for a person. It is shown instead of an email address to protect privacy. Give it to the district or an engineer when asking about someone."
        },
        "revoked": {
          "title": "Revoked",
          "definition": "Students who lost their place at the school, because they left the roster, their school is no longer shared, or the school was unlinked. Their account is kept."
        },
        "authorisationLost": {
          "title": "Authorisation lost",
          "definition": "The district has withdrawn Anyway’s access in the provider. Syncs fail, but students keep their accounts and their place.",
          "action": "Ask your district contact to share with Anyway again. The next successful sync clears this."
        },
        "held": {
          "title": "Held",
          "definition": "A person the sync could not place safely, for example because the roster has no email for them. Nothing happens to them until the cause is fixed.",
          "action": "Open the reason’s info for what to do, then run a sync."
        }
      },
      "refusedDomains": {
        "nav": "Refused Sign-up Domains",
        "title": "Refused Sign-up Domains",
        "help": "Nobody with an address on these domains can open an account on the public site. They are sent to the schools site instead.",
        "domain": "Domain",
        "origin": "Added from",
        "addedManually": "Added by hand",
        "addedBy": "Added by",
        "unknownAdder": "Unknown",
        "createdAt": "Added on",
        "empty": "No domains are refused yet.",
        "addLabel": "Refuse sign-up at a domain",
        "addPlaceholder": "district.org",
        "addHelp": "The part after the at sign, for example district.org. A subdomain is a separate domain.",
        "add": "Add",
        "added": "{domain} added.",
        "errors": {
          "invalidMailDomain": "Enter a domain such as district.org.",
          "publicMailDomain": "{domain} is a public mail service, so sign-up there can’t be refused.",
          "exists": "{domain} is already on the list."
        },
        "remove": "Remove",
        "removeDomain": "Remove {domain}",
        "removed": "{domain} removed.",
        "removeDialog": {
          "title": "Remove {domain}?",
          "description": "Takes {domain} off the refused sign-up list.",
          "opens": "People with an address on this domain can open an account on the public site again.",
          "trustStays": "If a connection trusts this domain, it stays trusted.",
          "submit": "Remove domain"
        }
      }
    },
    "contentAssets": {
      "tabs": {
        "library": "Library",
        "castReview": "Cast review"
      },
      "castReviewDescription": "Every story’s characters, with the request each part makes of its face and the face cast for it. Approve or change them, then save the stories you have reviewed."
    },
    "loginAttempts": {
      "nav": "Login attempts",
      "title": "Login attempts",
      "dateTimeFormat": "D MMM YYYY, h:mm:ss a",
      "field": {
        "label": "Look up a login attempt",
        "placeholder": "Reference code or email",
        "submit": "Look up"
      },
      "table": {
        "code": "Reference code",
        "started": "Started",
        "outcome": "Outcome",
        "reason": "Reason",
        "providerIds": "Provider IDs",
        "connection": "Connection",
        "identity": "Identity",
        "account": "Account"
      },
      "methods": {
        "otp": "Email code",
        "password": "Password",
        "google": "Google",
        "microsoft": "Microsoft",
        "clever": "Clever",
        "fakeClever": "Clever (fake)"
      },
      "surfaces": {
        "student": "Student login",
        "teacher": "Educator login",
        "admin": "Admin login"
      },
      "methodOnSurface": "{method} · {surface}",
      "statuses": {
        "started": "In progress",
        "awaitingProof": "Waiting for email code",
        "proven": "Email proven, not finished",
        "failed": "Failed",
        "succeeded": "Succeeded"
      },
      "reasons": {
        "notAvailable": "Not available",
        "loginsDisabled": "Logins switched off",
        "connectionPaused": "Connection paused",
        "notSetUp": "Not set up",
        "needsAttention": "Needs attention",
        "notEnrolled": "Not enrolled here",
        "unauthorizedUser": "Refused by the provider",
        "loginExpired": "Login expired",
        "signInFailed": "Sign-in failed",
        "proofFailed": "Email proof failed"
      },
      "credentialReasons": {
        "invalidCode": "Wrong or expired code",
        "unconfirmedAddress": "Address not confirmed",
        "addressClaimed": "Claimed by another account",
        "invalidCredentials": "Wrong password, or no account",
        "signInExpired": "Sign-in expired before the password",
        "schoolAccountEmail": "School email, sent to the school’s site",
        "classroomNotVerified": "Invite is to an unverified classroom"
      },
      "flows": {
        "existingRole": "Signed in",
        "newRole": "Sent to sign-up",
        "mfaChallengeRequired": "Waiting for second factor",
        "mfaEnrolmentRequired": "Waiting for second factor setup",
        "passwordRequired": "Code passed, waiting for password",
        "accountChoiceRequired": "Waiting for account choice"
      },
      "steps": {
        "transactionStart": "Step 0 · Start",
        "transactionLookup": "Step 1 · Return from provider",
        "codeExchange": "Step 2 · Code exchange",
        "connection": "Step 4 · Connection",
        "identity": "Step 5 · Identity",
        "role": "Step 6 · Role"
      },
      "noConnection": "None",
      "schoolsViewNeeded": "Schools view needed",
      "identityStatuses": {
        "linked": "Linked",
        "pending": "Pending proof",
        "held": "Held"
      },
      "proven": "Proven",
      "notProven": "Not proven",
      "firstSeen": "First seen {time}",
      "lastSeen": "Last seen {time}",
      "never": "not recorded",
      "holdsTab": "Holds",
      "noIdentity": "None",
      "noAccount": "No account",
      "empty": "No login attempts match",
      "userCard": {
        "title": "Login attempts",
        "empty": "No login attempts in the last 90 days"
      }
    },
    "institutionPromotions": {
      "title": "Institution Promotions",
      "nav": "Promotions",
      "navGroup": "Institutions",
      "missingId": "An institution promotion id is required.",
      "backToPromotions": "Back to institution promotions",
      "notFound": {
        "title": "Promotion not found",
        "description": "This promotion does not exist, or it has been deleted."
      },
      "unavailable": {
        "title": "Promotion could not be loaded",
        "description": "Something went wrong while loading this promotion. Try again in a moment."
      },
      "types": {
        "event": "Event",
        "alumni": "Alumni",
        "areaOfStudy": "Areas of study"
      },
      "typeDescriptions": {
        "event": "A dated event card, shown under the institution overview.",
        "alumni": "A standing rail of graduates, shown under the event card.",
        "areaOfStudy": "A standing grid of tiles linking out to the institution’s own course pages."
      },
      "status": {
        "draft": "Draft",
        "live": "Live",
        "ended": "Ended"
      },
      "validation": {
        "tooLong": "Keep this to {max} characters or fewer."
      },
      "table": {
        "emptyState": {
          "title": "No institution promotions configured",
          "subtitle": "Configure a promotion to show an event on an institution profile",
          "action": "Add Promotion"
        },
        "noResultsState": {
          "title": "No promotions found",
          "subtitle": "Try adjusting your search or clearing the filters"
        },
        "filters": {
          "type": "Type",
          "status": "Status"
        },
        "headers": {
          "institution": "Institution",
          "type": "Type",
          "title": "Title",
          "visibleUntil": "Shows until",
          "status": "Status",
          "createdAt": "Created",
          "actions": "Actions"
        },
        "actions": {
          "edit": "Edit",
          "publish": "Publish",
          "unpublish": "Unpublish",
          "delete": "Delete"
        },
        "confirmations": {
          "publish": {
            "title": "Publish promotion",
            "description": "Publish this promotion on ‘{name}’? It appears on the institution profile until its window ends.",
            "confirm": "Publish"
          },
          "unpublish": {
            "title": "Unpublish promotion",
            "description": "Unpublish this promotion on ‘{name}’? It disappears from the institution profile but keeps its configuration.",
            "confirm": "Unpublish"
          },
          "delete": {
            "title": "Delete promotion",
            "description": "Delete this promotion on ‘{name}’? The position is free to configure again.",
            "confirm": "Delete"
          }
        }
      },
      "messages": {
        "created": "Promotion created successfully",
        "updated": "Promotion updated successfully",
        "published": "Promotion published successfully",
        "unpublished": "Promotion unpublished successfully",
        "deleted": "Promotion deleted successfully",
        "deleteFailed": "Promotion could not be deleted"
      },
      "form": {
        "save": "Save Promotion",
        "promotionSection": "Promotion",
        "fields": {
          "institution": "Institution",
          "type": "Promotion type"
        },
        "placeholders": {
          "institution": "Search for an institution",
          "type": "Select a promotion type"
        },
        "hints": {
          "type": "Where the promotion appears on the profile is fixed by its type.",
          "typeLocked": "A promotion keeps the type it was created with."
        },
        "validation": {
          "institutionRequired": "Choose the institution this promotion belongs to"
        }
      },
      "alumni": {
        "sectionTitle": "Alumni",
        "fields": {
          "title": "Section heading",
          "badgeLabel": "Badge",
          "description": "Section intro",
          "name": "Name",
          "occupation": "Occupation",
          "blurb": "Quote",
          "studiedLabel": "Studied",
          "categoryLabel": "Category chip",
          "detailsUrl": "Read more link",
          "image": "Portrait"
        },
        "placeholders": {
          "title": "e.g. Real people. Real pathways.",
          "badgeLabel": "e.g. Our alumni",
          "description": "e.g. See where our graduates have taken their study.",
          "name": "e.g. Maddie Chen",
          "occupation": "e.g. Registered Nurse",
          "blurb": "e.g. The hands-on experience gave me the confidence to step into a career I care about.",
          "studiedLabel": "e.g. Bachelor of Nursing",
          "categoryLabel": "e.g. Health",
          "detailsUrl": "e.g. https://example.edu/alumni/maddie-chen"
        },
        "addPerson": "Add a graduate",
        "removePerson": "Remove this graduate",
        "personHeading": "Graduate {number}",
        "cap": "Up to {max} graduates.",
        "validation": {
          "titleRequired": "A section heading is required",
          "nameRequired": "This graduate needs a name, or the row will not be saved.",
          "blurbRequired": "Every graduate needs a quote.",
          "detailsUrlInvalid": "A graduate’s link must be a http or https address."
        }
      },
      "areaOfStudy": {
        "sectionTitle": "Areas of study",
        "fields": {
          "title": "Section heading",
          "label": "Label",
          "url": "Link",
          "iconName": "Icon"
        },
        "placeholders": {
          "title": "e.g. Explore areas of study at TAFE Queensland",
          "label": "e.g. Business and IT",
          "url": "e.g. https://example.edu/study/business-and-it"
        },
        "icons": {
          "business": "Business",
          "creative": "Creative",
          "education": "Education",
          "environment": "Environment",
          "health": "Health",
          "infrastructure": "Infrastructure",
          "service": "Service",
          "technology": "Technology",
          "trades": "Trades"
        },
        "addTile": "Add an area of study",
        "removeTile": "Remove this area of study",
        "tileHeading": "Area {number}",
        "cap": "Up to {max} tiles.",
        "validation": {
          "titleRequired": "A section heading is required",
          "labelRequired": "This tile needs a label.",
          "urlRequired": "This tile needs a link.",
          "urlInvalid": "An area of study must link to a http or https address."
        }
      },
      "event": {
        "section": "Event",
        "fields": {
          "typeLabel": "Event type label",
          "title": "Title",
          "description": "Description",
          "startsAt": "Starts",
          "endsAt": "Ends",
          "isAllDay": "All-day event",
          "locationLabel": "Location",
          "locationDetail": "Location detail",
          "audienceLabel": "Audience",
          "audienceDetail": "Audience detail",
          "costLabel": "Cost",
          "costDetail": "Cost detail",
          "ctaLabel": "Button label",
          "ctaUrl": "Button link",
          "detailsUrl": "Details link",
          "image": "Image",
          "imageTags": "Image tags"
        },
        "placeholders": {
          "typeLabel": "e.g. Open day",
          "title": "e.g. Experience Monash in person",
          "locationLabel": "e.g. Clayton Campus",
          "locationDetail": "e.g. Melbourne, VIC",
          "audienceLabel": "e.g. All welcome",
          "audienceDetail": "e.g. Students, families",
          "costLabel": "e.g. Free event",
          "costDetail": "e.g. Registration required",
          "ctaLabel": "e.g. Register now",
          "url": "e.g. https://example.edu/open-day",
          "imageTags": "e.g. Tours, Course info, Student panels"
        },
        "hints": {
          "typeLabel": "Shown as the badge above the title",
          "endsAt": "Leave empty for an event with no set finish. The card then shows for the rest of the start day",
          "imageTags": "Comma separated, up to six"
        },
        "validation": {
          "typeLabelRequired": "An event type label is required",
          "titleRequired": "A title is required",
          "startsAtRequired": "A start date and time is required",
          "endAfterStart": "The end must not be before the start",
          "urlInvalid": "Enter a full URL, starting with https://"
        }
      }
    }
  },
  "general": {
    "on": "On",
    "off": "Off",
    "form": {
      "clearSelection": "Clear selection",
      "selectAnOption": "Select an option…"
    },
    "table": {
      "resultsCount": "{count} results",
      "titles": {
        "videos": "Videos"
      },
      "emptyState": {
        "videos": {
          "title": "No videos yet",
          "subtitle": "Create your first video to get started."
        }
      },
      "noResultsState": {
        "videos": {
          "title": "No videos match your search",
          "subtitle": "Try a different search term or filter."
        }
      }
    }
  }
}
